export const translations = {
  en: {
    offline_opened: "Offline — showing your saved data; it syncs when you are back online.",
    buddy_company_remove: "Remove member from company",
    buddy_company_leave_approve: "Approve leave request",
    buddy_company_leave_reject: "Reject leave request",
    buddy_company_removed: "Member removed.",
    invites_title: "Invitations sent",
    invites_sent: "sent",
    invites_accepted: "accepted",
    invites_empty: "No invitations sent yet.",
    invited_by: "by",
    invite_status_accepted: "Joined",
    invite_status_pending: "Pending",
    invite_share_hint: "Sharing is not available on this device — the text was copied. Paste it in WhatsApp or wherever you like.",
    invite_share: "Share via WhatsApp or another app",
    close: "Close",
    invite_title: "Invite to OnSiteComms",
    invite_not_found: "is not on OnSiteComms yet. Want to send an invitation?",
    invite_email_explain: "We will e-mail an invitation with a link — when they create the account, you get connected automatically.",
    invite_sms_explain: "Your messages app will open with the invitation already written — just tap Send.",
    invite_sms_hint: "If the messages app did not open, copy the text below and send it your way.",
    invite_send_email: "Send e-mail invite",
    invite_send_sms: "Send SMS invite",
    invite_open_sms: "Open messages",
    invite_email_sent: "Invitation sent to",
    invite_already_registered: "This person already has an account — check the e-mail/phone you typed.",
    invite_email_unavailable: "E-mail invitations are not available right now.",
    invite_invalid: "Type a valid e-mail or phone number.",
    buddy_admin_approve: "Approve account",
    buddy_admin_reject: "Reject account request",
    buddy_admin_broadcast: "Send broadcast",
    buddy_admin_user_update: "Update user",
    buddy_admin_user_delete: "Delete user",
    buddy_admin_approved: "Account approved!",
    buddy_admin_rejected: "Request rejected.",
    buddy_admin_broadcast_sent: "Broadcast sent!",
    buddy_admin_user_updated: "User updated!",
    buddy_admin_user_deleted: "User deleted.",
    attach_intent_camera: "Buddy: tap to take the photo to send here",
    attach_intent_gallery: "Buddy: tap to pick the photo to send here",
    attach_intent_video: "Buddy: tap to pick the video to send here",
    attach_intent_document: "Buddy: tap to choose the file to send here",
    app_tagline: "Built to resolve field work.",
    select_profile: "Who are you?",
    select_profile_sub: "Pick your profile to enter OnSiteComms. No password needed in demo mode.",
    sign_in: "Sign In",
    create_account: "Create Account",
    email: "Email",
    password: "Password",
    your_name: "Full name",
    role: "Role",
    or: "or",
    sign_in_passkey: "Sign in with FaceID / Passkey",
    sign_in_apple: "Sign in with Apple",
    apple_soon: "Sign in with Apple is coming soon",
    apple_prod_only: "Apple login works on on-site-comms.com (after the production deploy)",
    apple_signing_in: "Signing in with Apple...",
    apple_login_failed: "Apple sign-in failed. Please try again.",
    google_soon: "Sign in with Google is coming soon",
    google_signing_in: "Signing in with Google...",
    google_login_failed: "Google sign-in failed. Please try again.",
    google_account_not_found: "Account not found. Ask your administrator to register your email first.",
    register_approval_notice: "New accounts require administrator approval. You will receive an e-mail when your request is approved.",
    register_pending_title: "Request sent!",
    register_pending_sub: "Your account request was sent to the administrator. You will receive an e-mail as soon as it is approved.",
    register_already_pending: "Your request was already sent and is awaiting approval.",
    login_pending_approval: "Your account is still awaiting administrator approval. You will receive an e-mail when it is approved.",
    reg_requests_title: "Account requests",
    reg_approve: "Approve",
    reg_reject: "Reject",
    reg_approved_toast: "Account approved",
    reg_rejected_toast: "Request rejected",
    reg_mode_solo: "No company",
    reg_mode_join: "Join company",
    reg_mode_create: "Create company",
    reg_solo_notice: "Independent account: you start alone and add contacts one-by-one using connect codes.",
    reg_create_notice: "You will create the company and become its administrator, approving who joins.",
    company_name: "Company name",
    company_code: "Company code",
    company_name_required: "Enter the company name",
    company_code_required: "Enter the company code (ask your administrator)",
    invalid_company_code: "Company code not found. Double-check with your administrator.",
    phone_optional: "Phone (optional)",
    phone_exists: "This phone number is already registered",
    invalid_phone: "Invalid phone number",
    company_created_toast: "Company created! Share the company code (in Admin) to invite your team",
    company_and_connections: "Company & Connections",
    company: "Company",
    no_company: "Independent account (no company)",
    connect_code_explainer: "Your code IS your e-mail or phone number. Share it with someone OUTSIDE your company so they can connect with you.",
    generate_my_code: "Generate my code",
    enter_someones_code: "Person's e-mail or phone",
    connect: "Connect",
    connected_with: "Connected with",
    invalid_connect_code: "This user does not exist",
    phone: "Phone",
    own_connect_code: "That is your own code",
    valid_until: "valid until",
    copied: "Copied!",
    members: "members",
    company_code_hint: "Share this code with people who should JOIN your company (you approve each request).",
    partner_companies: "Partner companies",
    partner_code_placeholder: "Partner code",
    connect_companies: "Connect companies",
    partner_connected_toast: "Companies connected",
    partner_disconnected_toast: "Companies disconnected",
    disconnect_company: "Disconnect",
    disconnect_company_confirm: "Both companies will stop seeing each other's contacts.",
    purge_related_question: "Would you like to delete the related conversations and contacts?",
    purge_yes_delete_all: "Yes — delete everything",
    purge_no_keep_loose: "No — keep as personal contacts",
    purge_no_hint: "If you keep them, contacts with started conversations become personal contacts.",
    no_partner_companies: "No partner companies yet — enter a partner code above to exchange business cards.",
    my_company_badge: "My company",
    company_card_empty: "No contact info yet — tap Edit to fill in your business card.",
    company_card_saved: "Business card saved",
    edit_company_card: "Edit card",
    connect_company_hint: "Enter the other company's code to exchange business cards — both contact directories become visible to each other.",
    company_name_label: "Company name",
    company_address_label: "Address",
    company_website_label: "Website",
    business_cards_tab: "Business Cards",
    partner_visibility_btn: "Visible contacts",
    partner_visibility_title: "Visible contacts",
    partner_visibility_hint: "Choose which contacts of this company YOUR users can see. Unchecked contacts disappear from the directory and the new-chat list (admins always see everyone; existing conversations are kept).",
    partner_visibility_hint_out: "Choose which contacts of YOUR company this partner can see. Unchecked contacts become invisible to EVERYONE there — including their admins (existing conversations are kept).",
    partner_visibility_tab_in: "What my team sees",
    partner_visibility_tab_out: "What they see of mine",
    partner_visibility_saved: "Contact visibility updated",
    partner_visibility_count: "{n} of {t} contacts visible",
    select_all: "Select all",
    clear_all: "Clear all",
    personal_contacts: "Personal contacts",
    add_personal_contact: "Add personal contact",
    add_existing_user: "Add user",
    add_existing_user_hint: "The person already has an account in the app? Enter their e-mail or phone to invite them to your company. They become a member as soon as they approve.",
    add_existing_user_toast: "Invite sent — waiting for the person's approval",
    company_invite_title: "Company invite",
    company_invite_text: "{admin} invited you to join {company} as {role}",
    invite_accepted_toast: "You are now part of the company",
    invite_declined_toast: "Invite declined",
    pending_invites_title: "Sent invites (waiting approval)",
    cancel_invite: "Cancel invite",
    invite_cancelled_toast: "Invite cancelled",
    already_member: "This person is already part of your company",
    belongs_to_other_company: "This person already belongs to another company — they must leave it first.",
    last_admin_error: "The company must always have at least one Admin. Promote another Admin first.",
    connect_confirm_title: "Connect with this person?",
    connect_confirm_hint: "A direct conversation will be opened between you.",
    member_history_title: "Member history",
    mh_joined: "joined the company",
    mh_left: "left the company",
    mh_removed: "was removed from the company",
    mh_created: "account created",
    mh_deleted: "account deleted",
    mh_promoted: "became Admin",
    mh_by: "by",
    mh_empty: "No events yet — the history starts counting from now on.",
    transfer_admin: "Transfer Admin role",
    transfer_admin_hint: "You are the only Admin — to be able to leave the company, first hand the role to another member.",
    transfer_admin_pick: "Choose the new Admin",
    transfer_admin_done: "is now also an Admin — you can request to leave.",
    pmhr_links_title: "Sync links",
    pmhr_links_hint: "The sync never creates users. Link each supervisor and crew from the schedule to an EXISTING user — including partner company users — nothing stays orphan.",
    pmhr_partner_company: "partner company",
    buddy_voice_title: "Buddy voice",
    buddy_voice_desc: "Used when Buddy speaks and presents to the customer",
    buddy_voice_preview: "Listen to a sample",
    buddy_voice_error: "Could not update the voice. Try again.",
    voice_echo: "male (default)",
    voice_alloy: "neutral",
    voice_fable: "British",
    voice_onyx: "deep",
    voice_nova: "female",
    voice_shimmer: "soft female",
    signin_with_apple: "Sign in with Apple",
    signin_with_google: "Sign in with Google",
    signin_with_faceid: "Sign in with Face ID",
    ai_consent_title: "AI features & your data",
    ai_consent_p1: "OnSiteComms uses OpenAI to provide automatic translation, voice transcription and the Buddy assistant.",
    ai_consent_p2: "When you use these features, the following content is sent to OpenAI (USA) solely to provide the feature. It is never used for advertising, and OpenAI does not use API data to train its models:",
    ai_consent_b1: "Text of your messages — for automatic translation",
    ai_consent_b2: "Voice recordings — for transcription and the live interpreter",
    ai_consent_b3: "Your questions and voice commands to Buddy",
    ai_consent_b4: "Photos you ask the AI to analyze (e.g. measurements)",
    ai_consent_warning: "If you do not authorize, you will NOT be able to use automatic translation, the Buddy assistant or audio transcription. You can change this anytime in Settings.",
    ai_consent_accept: "Authorize and continue",
    ai_consent_decline: "Don't authorize",
    ai_consent_privacy: "Read our Privacy Policy",
    ai_consent_error: "Could not save your choice. Try again.",
    ai_settings_title: "AI features (OpenAI)",
    ai_settings_on: "Authorized — automatic translation, Buddy and transcription are active",
    ai_settings_off: "Off — no automatic translation, no Buddy, no transcription",
    info_email: "Email",
    info_phone: "Mobile",
    contact_copied: "Contact copied!",
    email_pending: "There is already a pending account request with this email — ask your admin to approve it",
    master_users_title: "All accounts",
    master_banners_hint: "Every account in the system, in one list: change role, edit, remove from company or delete. The switches re-show a first-login banner at the user's NEXT login (opening tour / Buddy-AI consent); each shows once and turns itself off.",
    banner_tour: "Opening tour",
    banner_ai: "Buddy/AI consent",
    master_users_search_ph: "Search by name, email or company...",
    all_companies: "All companies",
    all_roles: "All roles",
    master_no_company: "No company",
    master_sort_name_asc: "Name (A–Z)",
    master_sort_name_desc: "Name (Z–A)",
    master_sort_company: "By company",
    master_sort_role: "By role",
    master_sort_pending: "Pending banners first",
    master_filter_no_results: "No accounts match the filters",
    pmhr_link_pending: "Pending",
    pmhr_link_linked: "Linked",
    pmhr_link_btn: "Link",
    pmhr_link_saved: "Link saved",
    pmhr_links_pending_toast: "Sync finished — there are pending links to configure",
    pmhr_kind_crew: "Crew",
    pmhr_kind_supervisor: "Supervisor",
    pmhr_link_select: "Choose user",
    personal_connections_title: "Personal connections",
    own_company_code: "That is your own company's code",
    code_regenerated_toast: "New company code generated (the old one no longer works)",
    leave_requests_title: "Leave requests",
    leave_approved_toast: "Leave approved",
    leave_rejected_toast: "Leave rejected",
    member_removed_toast: "Removed from the company",
    remove_from_company: "Remove from company",
    remove_from_company_confirm: "{name} will leave the company and lose access to its jobs, crews and conversations directory. Contacts with started conversations become personal contacts. The account stays active (solo).",
    request_leave_company: "Request to leave the company",
    leave_company_confirm: "Your administrator must approve this request. Your account stays active, but you will lose access to the company's contacts and jobs.",
    leave_requested_toast: "Request sent to your administrator",
    leave_pending_note: "Leave request sent — awaiting administrator approval.",
    confirm: "Confirm",
    sync_source_title: "Sync source (your company's system)",
    sync_source_sub: "Each company configures its OWN job system here. The sync only touches your company's jobs.",
    sync_base_url: "API address (e.g. https://mysystem.com/api)",
    sync_username: "Username",
    sync_password: "Password",
    sync_password_saved: "Password (saved)",
    sync_interval: "Interval (min)",
    sync_past_days: "Past days",
    sync_future_days: "Future days",
    sync_save: "Save sync settings",
    sync_saved_toast: "Sync settings saved",
    sync_test: "Test connection",
    sync_test_ok: "Connection OK! Login worked and {n} jobs were found at the source. You can enable auto-sync.",
    sync_last_error_title: "Last sync failed — here is why:",
    sync_err_not_configured: "Sync is not configured yet. Fill in the API address, username and password, save, and test again.",
    sync_err_invalid_url: "The API address is invalid. Use the full format, e.g. https://yoursystem.com/api (it must start with http:// or https://).",
    sync_err_connection: "Could not reach the address. Check for typos in the URL and make sure the system is online and accessible from the internet.",
    sync_err_timeout: "The source system took too long to respond. It may be slow or offline — try again in a few minutes.",
    sync_err_auth: "The source rejected the USERNAME or PASSWORD. Double-check the credentials of YOUR job system (not your OnSiteComms login).",
    sync_err_server: "The source system returned an internal error (5xx). The problem is on their side — try again later.",
    sync_err_bad_response: "The address responded, but not in the expected format. Make sure it is the API address (usually ending in /api) and that the system is compatible.",
    sync_err_generic: "Unexpected sync error. Test the connection to see the details.",
    company_qr_title: "Company invite QR code",
    company_qr_hint: "Your team scans this QR with the phone camera: the sign-up opens with the company code already filled in. You still approve each request.",
    company_qr_copy_link: "Copy link",
    join_link_logged_in: "This is a company sign-up invite. You're already signed in — log out to register with this code.",
    share_link: "Share",
    share_invite_text_personal: "Chat with me on OnSiteComms — tap the link to connect:",
    share_invite_text_company: "Join my company on OnSiteComms — tap the link to sign up:",
    my_qr_btn: "My QR code",
    my_qr_title: "My connection QR code",
    my_qr_hint: "Anyone who scans this QR with the phone camera connects with you instantly and a direct chat opens (they log in first if needed).",
    connect_after_login: "Sign in (or create your account) to complete the connection",
    welcome_back: "Welcome",
    account_created: "Account created!",
    login_failed: "Invalid email or password",
    register_failed: "Could not create account",
    email_exists: "An account with this email already exists",
    password_min: "Minimum 6 characters",
    passkey_error: "Passkey sign-in failed",
    passkey_cancelled: "Passkey cancelled",
    passkey_added: "Passkey added! You can now sign in with FaceID",
    passkey_already_active: "FaceID was already enabled on this device — you're all set!",
    reminder_alarm_title: "Reminder!",
    reminder_alarm_sub: "Buddy is reminding you:",
    reminder_alarm_close: "OK, got it",
    add_passkey: "Add Passkey (FaceID)",
    passkey_active: "Passkey active",
    sign_out: "Sign out",
    login_footer: "Secure sign-in. Sessions stay active for 30 days.",
    profile: "Profile",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    confirm_password: "Confirm new password",
    password_changed: "Password changed!",
    passwords_mismatch: "Passwords don't match",
    wrong_current_password: "Current password is incorrect",
    reopened: "Reopened",
    push_notifications: "Push notifications",
    notifications_off: "Notifications disabled",
    markup_sent: "Markup sent to the conversation",
    speak_issue: "Speak the problem",
    speak_again: "Speak again",
    listening_tap_stop: "Listening... tap to stop",
    creating_title: "Creating the issue draft...",
    draft_ready: "Draft ready — review below",
    add_media_question: "Add a photo or video?",
    create_now: "Create issue now",
    speak_resolution: "Speak the fix",
    speak_task: "Speak the task",
    speak_material: "Speak the material request",
    processing_voice: "Processing what you said...",
    send_now: "Send now",
    task_create_now: "Create task now",
    add_photo_question: "Add a photo?",
    pick_assignee_hint: "Pick who it's assigned to below, then create",
    photo_one: "Photo",
    unread_chat: "Unread Chat",
    take_photo: "Take Photo",
    photo_gallery: "Photo (Gallery)",
    record_video: "Record Video",
    video_gallery: "Video (Gallery)",
    camera_unavailable: "Camera not available",
    captions: "Captions",
    generating_captions: "Generating captions...",
    generate_captions: "Generate subtitles",
    compressing_video: "Compressing video...",
    sending_video: "Sending video...",
    sending_photo: "Sending photo...",
    photo_sent_to: "Photo sent to {name}",
    photo_send_failed_to: "Photo could not be sent to {name}",
    tap_to_retry: "tap to retry",
    video_quality_title: "Send video as",
    video_quality_fast: "Fast (720p)",
    video_quality_fast_hint: "Compressed on your phone — less data, faster",
    video_quality_original: "Original",
    video_quality_original_hint: "Full quality, bigger file",
    queued: "Waiting...",
    video_sending_bg: "Sending in the background — you can keep using the app",
    video_sent_to: "Video sent to {name}",
    video_send_failed_to: "Video could not be sent to {name}",
    video_discarded: "Video discarded",
    copy: "Copy",
    copied: "Copied",
    forward: "Forward",
    forward_to: "Forward to...",
    send_to_chat: "Send to a chat",
    pick_emoji: "Pick an emoji",
    reactions: "Reactions",
    you: "You",
    tap_to_remove: "Tap to remove",
    stickers: "Stickers",
    sticker: "Sticker",
    add_sticker: "Add",
    stickers_imported: "{n} sticker(s) added",
    sticker_import_hint: "Import PNG, WebP or GIF (animated too) — e.g. stickers exported from WhatsApp",
    no_recent_stickers: "No recent stickers yet",
    no_saved_stickers: "No saved stickers yet. Tap + to add your own.",
    save_sticker: "Save to My stickers",
    sticker_saved: "Sticker saved",
    sticker_from_photo: "Sticker from photo",
    create_sticker: "Create sticker",
    no_speech_detected: "No speech detected in this video",
    crop_hint_sticker: "Drag to position the photo inside the frame — use the slider to zoom",
    sticker_studio: "Sticker studio",
    sticker_text_placeholder: "Add text (optional)",
    text_top: "Top",
    text_bottom: "Bottom",
    record_video_sticker: "Record a short video sticker",
    sticker_clip_start: "Clip start (max 5s)",
    sticker_creating: "Creating…",
    sticker_studio_hint_anim: "Drag to frame · zoom · up to 5 s in loop, no sound",
    sticker_too_large: "Sticker too heavy — use a shorter or tighter clip",
    sticker_render_failed: "Could not create the sticker from this file",
    sticker_no_preview: "Preview not available on this device — the sticker will use the center of the first 5 seconds",
    make_sticker: "Make sticker",
    sticker_saved_hint: "Sticker saved to \"Mine\" in the sticker tray",
    view_photo: "View photo",
    period_all: "All dates",
    period_today: "Today",
    period_this_week: "This week",
    period_last_week: "Last week",
    period_next_week: "Next week",
    period_this_month: "This month",
    period_last_month: "Last month",
    period_next_month: "Next month",
    forward_comment_placeholder: "Add a comment (optional)",
    forwarded: "Forwarded",
    message_forwarded: "Message forwarded",
    deleted_message_by: "Message deleted by {name} on {date} at {time}",
    add_favorite: "Add to favorites",
    remove_favorite: "Remove from favorites",
    favorites: "Favorites",
    no_favorites: "No favorite messages yet",
    added_favorite: "Added to favorites",
    removed_favorite: "Removed from favorites",
    pin_message: "Pin to top",
    pin_for: "Pin for...",
    hours_24: "24 hours",
    days_7: "7 days",
    days_30: "30 days",
    pinned_by: "Pinned by",
    message_pinned: "Message pinned",
    deleted_message: "Message deleted",
    delete_conversation: "Delete conversation",
    delete_conversation_confirm: "The conversation will disappear only from your list — the other person keeps it. If someone sends a new message it reappears, but the old history stays deleted for you.",
    conversation_deleted: "Conversation deleted",
    save_to_device: "Save to device",
    saved_to_device: "Saved to your device",
    other_supervisors_jobs: "Other Supervisors' Jobs",
    installer: "Crew Leader",
    supervisor: "Supervisor",
    office: "Office",
    manager: "Manager",
    admin: "Admin",
    admin_panel: "Admin Panel",
    admin_only: "Admin access only",
    users: "Users",
    system: "System",
    create_user: "Create user",
    full_name: "Full name",
    password_min: "Password must be at least 6 characters",
    password_ph: "Password (min. 6 characters)",
    password_updated: "Password updated",
    user_created: "User created",
    reset_password: "Reset password",
    last_login: "Last login",
    clear: "Clear",
    passkeys_cleared: "Passkeys removed — user can register Face ID again",
    token_removed: "Device removed",
    test_push_sent: "Test push sent",
    test_push_body: "Push notifications are working!",
    no_devices_yet: "No devices registered yet. Devices appear here after users log in on the mobile app.",
    pmhr_tab: "Sync",
    pmhr_title: "Schedule Sync",
    pmhr_sync_now: "Sync now",
    pmhr_syncing: "Syncing...",
    pmhr_sync_done: "Sync complete",
    pmhr_auto_sync: "Auto-sync",
    pmhr_auto_on: "Runs automatically every {n} min",
    pmhr_auto_off: "Auto-sync is off — manual sync only",
    pmhr_last_sync: "Last sync",
    pmhr_never: "Never",
    pmhr_synced_jobs: "Synced jobs",
    pmhr_synced_pdfs: "PDFs imported",
    pmhr_created: "Created",
    pmhr_updated: "Updated",
    pmhr_deleted: "Deleted",
    pmhr_pdfs: "PDFs",
    pmhr_skipped: "Unchanged",
    pmhr_errors: "Errors",
    pmhr_history: "Sync history",
    pmhr_no_logs: "No syncs yet",
    pmhr_window: "Window: last {p} + next {f} days",
    pmhr_note: "Jobs and Installation Package PDFs are mirrored from your scheduling system. Users and chat groups are NEVER created automatically — link supervisors and crews to existing users in \"Sync links\" above.",
    dup_title: "Duplicated jobs",
    dup_check: "Check duplicates",
    dup_checking: "Checking...",
    dup_none: "No duplicated jobs or PDFs found. Everything clean!",
    dup_found: "{j} duplicated job(s) ({e} extra copies) and {p} extra PDF(s) found:",
    dup_delete_all: "Delete all duplicates",
    dup_deleted: "Duplicates removed",
    dup_copies: "copies",
    delete_user: "Delete user",
    delete_message: "Delete message",
    delete_message_confirm: "\"Delete for me\" hides it only for you. \"Delete for everyone\" removes it for all.",
    delete_for_me: "Delete for me",
    delete_for_everyone: "Delete for everyone",
    delete_window_expired: "Too late to delete for everyone — you can still delete it for yourself.",
    message_deleted: "Message deleted",
    search: "Search...",
    send_markup_title: "Send markup",
    send_to_whom: "Who do you want to send it to?",
    link_to_job_q: "Link to a job? (optional)",
    choose_job: "Choose a job",
    old_measurements_wrong: "Old wrong measurements",
    all_crews: "All",
    service_supervisor_label: "Default supervisor for Service jobs",
    service_supervisor_none: "None (leave unassigned)",
    service_supervisor_hint: "Service jobs come from the source without a supervisor — the person chosen here is assigned automatically on every sync.",
    resolved: "Resolved",
    cleanup_orphans_title: "Clean orphaned records",
    cleanup_orphans_desc: "Deletes leftovers pointing to things that no longer exist: messages of deleted conversations, and issues/tasks whose job AND conversation are both gone. Issues still attached to a living job are kept.",
    cleanup_orphans_btn: "Clean orphans",
    cleanup_orphans_confirm: "This permanently deletes every orphaned record in the whole system. This cannot be undone. Continue?",
    cleanup_orphans_done: "Cleaned: {m} messages, {i} issues, {t} tasks, {f} files",
    new_job_group_chat: "New Job Group Chat",
    start_conversation: "Start conversation",
    edit_user: "Edit user",
    no_crew: "No crew",
    new_password_optional: "New password (optional)",
    keep_current_password: "Leave empty to keep the current one",
    delete_user_confirm: "This will permanently delete this user. Messages they sent stay in the chat history. This cannot be undone.",
    user_deleted: "User deleted",
    download_source_zip: "Download full source code (ZIP)",
    download_source_desc: "Backend + frontend + iOS + Android projects, ready for Xcode / Android Studio (node_modules excluded — run 'yarn install' after unzipping).",
    preparing_zip: "Preparing ZIP...",
    zip_phase_zipping: "Compressing source code",
    zip_phase_downloading: "Downloading",
    zip_files: "files",
    zip_done: "Source code downloaded!",
    cleanup_demo_title: "Delete demo data",
    font_size_title: "Text size",
    font_small: "Small",
    font_medium: "Medium",
    font_large: "Large",
    font_preview: "This is how your messages will look.",
    bio_unlock_reason: "Unlock OnSiteComms",
    change_photo: "Change photo",
    remove_photo: "Remove photo",
    photo_updated: "Photo updated",
    photo_removed: "Photo removed",
    group_photo: "Group photo",
    seed_demo_title: "Create App Review demo account",
    seed_demo_desc: "Creates/refreshes the demo account for the Google Play and Apple review teams: johnny.garbim@gmail.com with sample jobs, conversations, photos and a poll (all in English). Safe to run multiple times.",
    seed_demo_done: "Demo account ready",
    cleanup_demo_desc: "Removes ONLY the demo data: the App Review demo account (johnny.garbim@gmail.com, Mike Anderson, Carlos Silva), its jobs (#10424, #10431), chats and photos, plus any legacy seed data. Real users, real conversations and synced jobs are kept.",
    cleanup_demo_confirm: "Delete demo data permanently?",
    demo_cleaned: "Demo data deleted",
    job_type_install: "Install",
    job_type_service: "Service/JIP",
    removed_from_matrix: "Removed from source",
    job_notes: "Notes",
    tab_active: "Active (today)",
    tab_past: "Past",
    tab_future: "Upcoming",
    no_jobs_today: "No jobs scheduled for today.",
    filter_teams: "Teams",
    filter_dates: "Dates",
    clear_filters: "Clear filters",
    day_of_days: "Day {d} of {n}",
    days_count: "{n} days",
    preset_this_week: "This week",
    preset_this_month: "This month",
    preset_last_week: "Last week",
    preset_last_month: "Last month",
    preset_next_week: "Next week",
    preset_next_month: "Next month",
    devices: "Devices",
    media: "Media",
    something_wrong: "Something went wrong",
    source_code_title: "Source code for Xcode / Android Studio",
    source_code_info: "The native projects (ios/ and android/) live inside the app source code. To build in Xcode/Android Studio:",
    source_step_1: "On Emergent: open the project chat menu and use 'Save to GitHub' (or Download code) to get the full source",
    source_step_2: "On your computer: cd frontend, run 'yarn install' and 'yarn cap:sync'",
    source_step_3: "Open with 'yarn cap:ios' (Xcode) or 'yarn cap:android' (Android Studio) — see CAPACITOR_GUIA.md",
    crew_leader: "Crew Leader",
    home: "Home",
    jobs: "Jobs",
    messages: "Messages",
    issues: "Issues",
    tasks: "Tasks",
    photos: "Photos",
    today: "TODAY",
    open_issues: "Open Issues",
    active_jobs: "Active Jobs",
    unread_conversations: "Unread Chats",
    new_field_photos: "New Field Photos",
    completed_jobs: "Jobs Completed",
    open_tasks: "My Open Tasks",
    recent_activity: "Recent",
    my_jobs: "My Jobs",
    all_jobs: "All Jobs",
    scheduled: "Scheduled",
    active: "Active",
    completed: "Completed",
    crew: "Crew",
    job_chat: "Job Chat",
    crew_chat: "Crew Chat",
    direct: "Direct",
    chat: "Chat",
    decisions: "Decisions",
    documents: "Documents",
    info: "Info",
    report_issue: "Report Issue",
    complete_job: "Complete Job",
    job_completed: "Job completed",
    type_message: "Message",
    draft: "Draft",
    waiting_conn: "waiting for connection",
    offline_queue_title: "Send queue",
    retry_now: "Retry now",
    queue_empty: "Nothing waiting to be sent",
    poll: "Poll",
    create_poll: "Create Poll",
    poll_question: "Question",
    poll_question_ph: "Ask something...",
    poll_options: "Options",
    add_option: "Add option",
    option: "Option",
    poll_multi: "Multiple answers",
    poll_anonymous: "Anonymous votes",
    votes: "votes",
    vote_one: "vote",
    no_votes_yet: "No votes yet",
    job_day_summaries: "Day summaries",
    daily_summary: "Daily Summary",
    summary_hint: "AI recap per job — generated automatically at 6 AM and 6 PM, or on demand.",
    summary_generate: "Generate now",
    summary_generating: "Generating...",
    summary_refresh: "Refresh",
    summary_empty: "No summaries for this day yet.",
    summary_empty_home: "No summary yet for today — tap to open and generate.",
    summary_none_activity: "No job chat activity found for this day.",
    summary_recheck: "Check again",
    issues_opened_label: "opened",
    issues_resolved_label: "resolved",
    drop_media_here: "Drop to send",
    drop_media_sub: "Photos open the editor · Videos open the review player",
    drop_unsupported: "Only photos and videos can be dropped here",
    send: "Send",
    photo: "Photo",
    voice: "Voice",
    document: "Document",
    issue: "Issue",
    question: "Question",
    measurement: "Measurement",
    material_request: "Material Request",
    task: "Task",
    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",
    status_open: "Open",
    status_reviewing: "Reviewing",
    status_action_required: "Action Required",
    status_resolved: "Resolved",
    location: "Location",
    description: "Description",
    title: "Title",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    before: "Before",
    during: "During",
    issue_cat: "Issue",
    correction: "Correction",
    after: "After",
    all: "All",
    category: "Category",
    caption: "Caption",
    markup: "Markup",
    edit_photo: "Edit Photo",
    original: "Original",
    versions: "Versions",
    compare: "Compare",
    compare_select: "Select second photo",
    sync_zoom: "Sync zoom",
    reply_to_area: "Reply to Area",
    reply_area_hint: "Drag over the photo to highlight the area",
    create_task: "Create Task",
    task_area_hint: "Drag over the photo to mark the task area",
    assign_to: "Assign to",
    due: "Due",
    due_placeholder: "e.g. Before job completion",
    mark_decision: "Mark as Decision",
    unmark_decision: "Unmark Decision",
    decision: "DECISION",
    hold_to_record: "Hold to record",
    recording: "Recording...",
    transcribing: "Transcribing...",
    transcript: "Transcript",
    complete_with_photo: "Complete with Photo",
    completion_photo: "Completion photo",
    mark_complete: "Mark Complete",
    open_job_hub: "Open Job Hub",
    view_thread: "View Thread",
    no_messages: "No messages yet. Start the conversation.",
    search_no_results: "No results",
    search_convs_msgs: "Search conversations and messages...",
    adjust_photo: "Adjust photo",
    crop_hint: "Drag to position the photo inside the circle · use the slider to zoom",
    use_photo: "Use photo",
    wallpaper_title: "Chat wallpaper",
    wallpaper_choose: "Choose photo",
    wallpaper_default: "Default",
    wallpaper_custom: "Custom photo",
    wallpaper_updated: "Wallpaper updated",
    wallpaper_reset: "Default wallpaper restored",
    schedule_message: "Schedule message",
    // Ask the Job (AI)
    ask_job_tab: "Ask AI",
    ask_job_title: "Ask the Job",
    ask_job_hint: "Ask anything about this job — the AI answers using the messages, voice notes and photos of this job.",
    ask_job_placeholder: "e.g. What did we decide about the installation?",
    ask_job_sources: "Sources",
    ask_job_error: "AI unavailable right now. Try again.",
    ask_job_thinking: "Thinking...",
    ask_job_send: "Ask",
    // Quick replies (⚡)
    quick_replies: "Quick replies",
    quick_replies_empty: "No phrases configured yet.",
    quick_replies_admin_hint: "The admin manages these phrases in the Admin panel.",
    quick_replies_user_hint: "Create yours in More → Quick phrases.",
    phrases_row: "Quick phrases",
    phrases_desc: "Your personal phrases appear on the ⚡ button in chats — only for you. Company phrases (set by the Admin) appear for everyone in the company.",
    phrase_company_badge: "Company",
    quick_replies_tab: "Phrases",
    quick_reply_add: "Add phrase",
    quick_reply_placeholder: "e.g. On my way",
    quick_reply_added: "Phrase added",
    quick_reply_deleted: "Phrase removed",
    quick_reply_saved: "Phrase updated",
    app_manual: "App manual",
    buddy_manual: "Buddy & Interpreter manual",
    // Photo watermark stamp
    photo_stamp: "Stamp date + job on photo",
    photo_stamp_short: "Stamp",
    // Aviso com Entendi (broadcast acknowledgment)
    require_ack: "Require confirmation",
    require_ack_hint: "Each person must tap \"Got it\" — you'll see who confirmed.",
    ack_button: "Got it",
    ack_confirmed: "Confirmed",
    ack_waiting: "Waiting confirmation",
    ack_see_confirmations: "See confirmations",
    ack_dialog_title: "Confirmations",
    ack_pending: "Pending",
    ack_all_confirmed: "Everyone confirmed",
    // O que perdi (AI catch-up)
    catchup_chip: "What did I miss?",
    catchup_title: "What did I miss?",
    catchup_recent: "You're caught up — summary of the recent conversation:",
    catchup_missed: "{n} messages while you were away:",
    catchup_error: "AI unavailable right now. Try again.",
    catchup_empty: "Nothing to summarize yet.",
    // Escalonamento urgente
    urgent_menu: "Urgent message",
    urgent_armed: "Urgent message — reminds them every 1 min until read (up to 10x)",
    urgent_badge: "URGENT",
    urgent_unseen: "Not seen — reminders exhausted",
    broadcast_urgent: "Urgent",
    broadcast_urgent_hint: "Re-notifies each person every 1 min (up to 10x). If still unread, you get alerted.",
    schedule_needs_text: "Type the message first, then schedule it",
    schedule_when: "Send at",
    schedule_confirm: "Schedule",
    schedule_future: "Pick a time in the future",
    scheduled_success: "Message scheduled",
    scheduled_canceled: "Schedule canceled",
    scheduled_chip: "{n} scheduled",
    scheduled_list_title: "Scheduled messages",
    edit_message: "Edit",
    editing_message: "Editing message",
    edited_label: "edited",
    broadcast_title: "Announcement",
    broadcast_message_ph: "Announcement message...",
    broadcast_hint: "Each person receives it as a normal direct message — no group is created.",
    broadcast_send: "Send announcement",
    broadcast_sent: "Announcement sent to {n} people",
    conv_wallpaper_title: "Wallpaper for this conversation",
    supervisors_section: "Supervisors",
    installers_section: "Installers",
    job_groups: "Job Groups",
    group: "Group",
    new_group: "New group",
    group_name: "Group name",
    create_group: "Create group",
    members: "members",
    conversations: "Conversations",
    new_conversation: "New conversation",
    direct_message: "Direct message",
    job_group: "Job group",
    no_conversations: "No conversations about this job yet.",
    linked_msgs: "linked messages",
    select_people: "Select people",
    talk_about_job: "Everything you say here will be linked to this job.",
    view_in_chat: "View in conversation",
    resolve_issue: "Click to resolve",
    reopen_issue: "Reopen",
    edit: "Edit",
    delete: "Delete",
    deleted: "Deleted",
    saved: "Saved",
    delete_confirm_q: "Delete permanently?",
    delete_group_conv_confirm: "The group and ALL its messages will be permanently deleted for everyone. This cannot be undone.",
    delete_photo_confirm: "The photo will be permanently deleted for everyone.",
    delete_file_confirm: "The file will be permanently deleted for everyone.",
    delete_comm_msg_confirm: "The message will be permanently deleted for everyone.",
    delete_dm_links_confirm: "All {n} messages of this conversation linked to this job will be permanently deleted for everyone. The rest of the private conversation stays untouched.",
    delete_contact_confirm: "The contact will be removed from your list and will no longer appear anywhere. To see them again, connect with each other again (QR/code).",
    delete_contact_has_conv: "You two have an active conversation — it will also be deleted for you.",
    priority_high: "High",
    priority_medium: "Medium",
    priority_low: "Low",
    add_member: "Add member",
    remove_member: "Remove member",
    change_photo: "Change photo",
    group_updated: "Group updated",
    global_search: "Search",
    search_ph: "Search messages, photos, issues, tasks...",
    no_results: "No results found",
    search_min_hint: "Type at least 2 characters to search",
    reply: "Reply",
    replying_to: "Replying to",
    add_photo_video: "Add photo/video",
    mention_someone: "Mention someone",
    mentioned_you: "mentioned you",
    you_were_mentioned: "You were mentioned",
    share: "Share",
    share_unavailable: "Sharing not available on this device",
    copy_link: "Copy link",
    link_copied: "Link copied",
    save_image: "Save image",
    save_file: "Save file",
    save_all_files: "Save all files ({n})",
    seen_by: "Seen by",
    not_seen_yet: "hasn't seen yet",
    mentions: "Mentions",
    no_mentions: "No mentions yet",
    new: "New",
    pdf_failed: "Could not load the PDF",
    loading: "Loading",
    video: "Video",
    save_to_job_files: "Save PDF to job Files",
    saved_to_files: "Saved to job Files",
    dictate: "Dictate",
    stop: "Stop",
    no_speech_detected: "No speech detected",
    mic_denied: "Microphone access denied",
    add_text_hint: "Tap to add text. Drag a text to move it.",
    resolve_issue_title: "Resolve Issue",
    resolution_note_ph: "Describe what was done to fix it...",
    add_photo: "Add photo",
    issue_resolved_q: "Issue resolved?",
    yes_mark_resolved: "Yes, mark as resolved",
    no_keep_open: "No, keep open",
    contact_info: "Contact info",
    group_info: "Group info",
    shared_media: "Shared media",
    no_media: "No media shared yet",
    language_label: "Language",
    offline_banner: "No connection — messages will be sent automatically when you're back online.",
    queued_offline: "Saved — will send when connection returns",
    msg_pending: "Waiting for connection",
    msg_sending: "Sending...",
    msg_failed: "Failed to send",
    retry: "Retry",
    discard: "Discard",
    queue_full: "Offline storage is full — could not save this photo",
    in_queue: "queued",
    no_photos: "No photos in this category yet.",
    no_issues: "No issues. Field is clean.",
    no_tasks: "No tasks yet.",
    no_decisions: "No decisions recorded yet.",
    no_documents: "No documents yet.",
    items: "Items",
    needed_by: "Needed by",
    value: "Value",
    note: "Note",
    supervisor_label: "Supervisor",
    address: "Address",
    no_account_yet: "No account yet?",
    listen_before_send: "Listen before sending",
    preset_next_7_days: "Next 7 days",
    chats_tab: "Chats",
    all_people: "All people",
    download: "Download",
    delete_account: "Delete my account",
    delete_account_desc: "Permanently deletes your account, sign-in credentials and push tokens, and removes you from all conversations. This cannot be undone.",
    delete_account_confirm_title: "Delete your account?",
    delete_account_confirm_text: "This is permanent. Your account, passkeys and notifications will be removed and you will be signed out immediately.",
    account_deleted: "Account deleted",
    delete_account_failed: "Could not delete the account",
    already_have_account: "Already have an account?",
    forgot_password: "Forgot my password",
    forgot_password_title: "Reset your password",
    forgot_password_sub: "Enter your account email and we'll send you a 6-digit code.",
    send_code: "Send code",
    code_sent: "If this email is registered, a code was sent. Check your inbox.",
    enter_code_title: "Enter the code",
    enter_code_sub: "We sent a 6-digit code to your email. It expires in 30 minutes.",
    verify_code: "Verify code",
    resend_code: "Resend code",
    resend_in: "Resend in",
    new_password_title: "Create a new password",
    new_password_sub: "Your code was confirmed. Choose a new password (6+ characters).",
    save_new_password: "Save new password",
    password_reset_success: "Password updated! Sign in with your new password.",
    invalid_code: "Incorrect code. Please try again.",
    code_expired: "This code has expired. Request a new one.",
    too_many_attempts: "Too many attempts. Request a new code.",
    no_reset_request: "No active reset request. Request a new code.",
    email_send_failed: "Could not send the email. Try again shortly.",
    back_to_login: "Back to sign in",
    sign_in_with_faceid: "Sign in with FaceID / Passkey",
    crop_failed: "Could not crop the image. Please try again.",
    mute_notifications: "Mute notifications",
    unmute_notifications: "Unmute notifications",
    muted_on_toast: "Muted — you'll still receive messages, silently. Today's linked jobs still ring.",
    muted_off_toast: "Notifications back on.",
    mute_job_exception_hint: "Jobsite exception: on days this conversation has a scheduled job, the supervisor and installers still get sound alerts.",
    passkey_prompt_title: "Enable FaceID / Passkey?",
    passkey_prompt_text: "Sign in with a single tap — secure and no password typing. You can also enable it later in Profile.",
    passkey_prompt_enable: "Enable FaceID",
    passkey_prompt_later: "Not now",
    app_lock_title: "Require FaceID / sign-in",
    app_lock_on_desc: "When enabled, you'll sign in (FaceID/passkey or password) every time you reopen the app or browser tab.",
    app_lock_off_desc: "Direct access — you stay signed in when you reopen the app or browser tab.",
    app_lock_enabled: "App lock enabled — sign-in required on reopen.",
    app_lock_disabled: "Direct access enabled — you'll stay signed in.",
    forgot_current_password: "Don't remember your current password? Email me a code",
    code_sent_to: "Code sent to",
    email_code_label: "6-digit code from the email",
    use_current_password: "Use current password instead",
    tour_welcome_title: "Welcome to OnSiteComms!",
    tour_welcome_text: "All your jobsite communication in one place — messages, photos, voice notes and jobs.",
    tour_chat_title: "Chat with auto-translation",
    tour_chat_text: "Write in your language — teammates read it in theirs. Portuguese and English, translated automatically.",
    tour_media_title: "Voice, photos & markup",
    tour_media_text: "Hold the mic to record (slide up to lock). Snap photos and draw on them to show exactly what you mean.",
    tour_jobs_title: "Everything linked to Jobs",
    tour_jobs_text: "Each conversation connects to a job: address with navigation, weather, files and tasks — all in one tap.",
    tour_notif_title: "Never miss a message",
    tour_notif_text: "Get notified of new messages and mentions. Manage alerts anytime in More → Settings.",
    tour_next: "Next",
    tour_start: "Get started",
    tour_skip: "Skip tour",
    tour_row: "App tour",
    open_in_maps: "Open in navigation app",
    customer: "Customer",
    schedule: "Schedule",
    units: "Units",
    switch_profile: "Switch Profile",
    language: "Language",
    sending: "Sending...",
    uploading: "Uploading...",
    send_photo: "Send Photo",
    send_photos_n: "Send {n} photos",
    tomorrow: "Tomorrow",
    yesterday: "Yesterday",
    assigned_to: "Assigned to",
    created_by: "Created by",
    photo_timeline: "Photo Timeline",
    tap_status: "Tap to change status",
    upload_doc: "Upload Document",
    voice_message: "Voice message",
    area_highlighted: "Area highlighted",
    from_photo: "From photo",
    quick_actions: "Quick Actions",
    view_all: "View all",
    in_progress: "In progress",
    done: "Done",
    search_jobs: "Search job # or customer",
    min_away: "min away",
    contacts: "Contacts",
    new_chat: "New Chat",
    search_contacts: "Search contacts",
    link_to_job: "Link to Job",
    relink_to_job: "Link to another job",
    unlink_from_job: "Unlink from job",
    unlink_selected: "Unlink",
    unlinked_from_job: "message(s) unlinked",
    linked_to: "Linked to",
    linked_messages: "Linked Conversations",
    select_job: "Select Job",
    no_linked: "No linked messages yet. Use 'Link to Job' in any chat to connect a message to this job.",
    open_conversation: "Open conversation",
    activity: "Activity",
    more: "More",
    people: "People",
    working_on: "Working on",
    link_msgs_prompt: "Link messages to",
    yes: "Yes",
    no: "No",
    back: "Back",
    measure_photo_hint: "Found a wrong-sized window or door? Take a photo — AI marks the opening and the measurements go on the photo.",
    measure_take_photo: "Take a photo of the window/door",
    measure_analyzing: "AI analyzing the photo...",
    measure_found_window: "Window identified — width and height marked",
    measure_found_door: "Door identified — width and height marked",
    measure_not_found: "Couldn't identify the opening — arrows will use the whole photo",
    measure_retake: "Retake",
    measure_job_q_window: "Is this window from job",
    measure_job_q_door: "Is this door from job",
    measure_loading_pdf: "Reading the job PDF...",
    measure_no_pdf: "This job has no PDF — enter the measurements manually",
    measure_pick_location: "Which one is it, per the PDF?",
    measure_other_location: "It's not in the list / other",
    measure_window: "Window",
    measure_door: "Door",
    measure_expected: "Expected (PDF)",
    measure_real_w: "Measured width",
    measure_shape: "Window shape",
    optional: "optional",
    side_left: "Left",
    side_right: "Right",
    measure_dim_w: "Width",
    measure_dim_h: "Height",
    measure_dim_leg: "Leg height",
    measure_dim_top: "Top width",
    measure_dim_legL: "Left leg",
    measure_dim_legR: "Right leg",
    measure_dim_d: "Diameter",
    measure_dim_side: "Side",
    shape_rectangle: "Rectangle",
    shape_half_circle: "Half Circle",
    shape_quarter_circle: "Quarter Circle",
    shape_eyebrow: "Eyebrow",
    shape_springline: "Springline",
    shape_elliptical: "Elliptical",
    shape_equal_leg_triangle: "Equal Legs",
    shape_right_triangle: "Right Triangle",
    shape_trapezoid: "Trapezoid",
    shape_pentagon: "Pentagon",
    shape_octagon: "Octagon",
    shape_circle: "Circle",
    shape_oval: "Oval",
    measure_door_config: "Door configuration",
    shape_door: "Door only",
    shape_door_sl1: "1 sidelight",
    shape_door_sl2: "2 sidelights",
    shape_door_tr: "Transom",
    shape_door_tr_sl1: "Transom + 1 sidelight",
    shape_door_tr_sl2: "Transom + 2 sidelights",
    measure_dim_sl: "Sidelight width",
    measure_dim_slL: "Left sidelight",
    measure_dim_slR: "Right sidelight",
    measure_dim_tr: "Transom height",
    measure_dim_trL: "Left transom",
    measure_dim_trR: "Right transom",
    measure_dim_trS: "Sidelight transom",
    measure_dim_w_total: "Total width (whole unit)",
    measure_dim_h_total: "Total height (whole unit)",
    shape_door_tr2_sl1: "1 sidelight + 2 transoms",
    shape_door_tr3_sl2: "2 sidelights + 3 transoms",
    measure_real_h: "Measured height",
    measure_match: "Matches the PDF",
    measure_match_short: "OK",
    measure_mismatch: "WRONG measurement",
    force_update_title: "Update required",
    force_update_body: "A new version of OnSiteComms is available. Update to keep using the app.",
    force_update_cta: "Update now",
    force_update_installed: "Installed",
    force_update_required: "Required",
    force_update_title_admin: "Mandatory update",
    force_update_help: "Blocks apps with a version LOWER than the minimum. The user sees the image and is taken to the store. Once updated, the app unlocks by itself. Web and Master are never blocked.",
    force_update_active: "LOCK ACTIVE",
    force_update_min_ios: "Minimum iOS version",
    force_update_min_android: "Minimum Android version",
    force_update_min_hint: "Leave empty to not block that platform. Ex: Apple approved 1.35 → type 1.35 in the iOS field.",
    force_update_image: "Lock screen image",
    force_update_image_add: "Add image",
    force_update_image_big: "Image too large (max 2MB)",
    force_update_ios_url: "App Store link",
    force_update_android_url: "Play Store link",
    force_update_save_on: "Save and ACTIVATE",
    force_update_saved_on: "Mandatory update ACTIVE",
    force_update_saved_off: "Saved (lock off)",
    force_update_need_min: "Set at least one minimum version",
    force_update_preview_close: "Tap anywhere to close the preview",
    preview: "Preview",
    change: "Change",
    remove: "Remove",
    measure_shape_diverges: "The PDF lists this opening as {pdf}, but you selected {chosen}. Double-check the unit on site before reporting.",
    measure_pdf_shape: "PDF shape",
    measure_shape_wrong: "WRONG shape (differs from PDF)",
    measure_preview_btn: "Generate annotated photo",
    measure_preview_hint: "Review the annotated photo before sending to the crew.",
    buddy_measure_photo_attached: "Photo attached.",
    buddy_measure_save_native_only: "Saving to the phone works in the app.",
    buddy_measure_title: "Measuring",
    buddy_measure_saved: "Measurement saved",
    buddy_measure_empty: "Tell Buddy the location, type and size of the first unit.",
    buddy_measure_open_notes: "Open My Notes",
    buddy_measure_finish: "Finish & save",
    buddy_measure_cancelled: "Measurement session cancelled.",
    buddy_measure_saved_msg: "Report saved in My Notes. Want me to send it to someone?",
    buddy_trim_title: "Trim notes", buddy_trim_saved: "Trim notes saved", buddy_trim_empty: "Say the trim type and its sizes, e.g. \"brickmold, top 36, bottom 36, right 60, left 60\".",
    buddy_trim_missing: "Missing", buddy_trim_cancelled: "Trim notes cancelled.", buddy_trim_saved_msg: "Trim table saved in My Notes. Want me to send it to someone?",
    buddy_trim_send: "Send trim notes", trim_report: "Trim notes", trim_side_right: "Right", trim_side_left: "Left", trim_side_top: "Top", trim_side_base: "Bottom",
    trim_no_base: "No bottom piece", trim_thick_short: "thk", trim_inside: "Inside (return)", trim_face: "Face", trim_reforco: "Brick backing",
    trim_field_right: "right", trim_field_left: "left", trim_field_top: "top", trim_field_base: "bottom", trim_field_base_type: "bottom piece type",
    trim_field_right_thick: "right thickness", trim_field_left_thick: "left thickness", trim_field_top_thick: "top thickness", trim_field_base_thick: "bottom thickness",
    trim_field_inside: "inside", trim_field_face: "face", trim_field_finish: "siding or brick backing", trim_field_siding: "siding measure",
    buddy_measure_send: "Send measurements",
    measure_dictate_hint: "Dictate: \"44 3/4 by 21 1/2\"",
    measure_save_phone: "Save the original photo to my phone",
    measure_picker_fallback: "Opening the photo picker…",
    measure_edit_title: "Edit measurement",
    measure_edit: "Edit measurement",
    measure_save_edit: "Save changes",
    measure_edit_expired: "Measurements can only be edited within 2 hours of sending.",
    measure_sent: "Measurement sent!",
    measure_more_q: "Any other window with a wrong measurement?",
    measure_more_yes: "Yes, next one",
    measure_finish_send: "Done — send measurements",
    measure_close_confirm: "You have {n} measurement(s) not sent yet. Close and lose them?",
    measure_shape_live_hint: "The outline follows your measurements (leg ÷ height)",
    measure_more_no: "No, finish",
    measure_take_photo_cam: "Take photo (camera)",
    measure_from_gallery: "From gallery",
    measure_job_no_other: "No, another job",
    measure_pick_job: "Which job is this measurement from?",
    measure_search_job: "Search job # or customer...",
    measure_no_job_manual: "No job / enter manually",
    measure_add_btn: "Add to report",
    measure_added: "Added",
    measure_in_report: "in the report",
    measure_send_all: "Send",
    measure_catalog: "Measurement catalog",
    measure_wrong_count: "wrong",
    measure_multi_window_q: "Several windows in one opening?",
    measure_door_transom_q: "Door with a window above it?",
    measure_door_sidelites_q: "Windows beside the door?",
    measure_door_combo_q: "Door with windows around it?",
    measure_adjust_single: "Check the marking — adjust the box if needed",
    measure_adjust_hint: "Drag the box to move · corners to resize · top handle to rotate (angled photos)",
    measure_units_found: "units marked",
    measure_add_box: "Add box",
    measure_remove_box: "Delete box",
    measure_draw_hint: "Couldn't identify the opening — add the box manually",
    measure_need_box: "Add at least 1 box",
    measure_continue: "Continue",
    measure_piece: "Unit",
    measure_of: "of",
    measure_next_piece: "Next unit",
    measure_overall_q: "Add the overall opening measurement too?",
    measure_overall_w: "Overall width",
    measure_overall_h: "Overall height",
    measure_skip: "Skip",
    measure_sketch_flag: "Sketch",
    measure_sketch_hint: "Also works with a photo of a hand-drawn sketch with several windows",
    measure_units_short: "units",
    measure_used: "used",
    measure_win_type: "Window type (optional):",
    measure_door_type: "Door type (optional):",
    measure_type_none: "Not specified",
    measure_pick_unit_edit: "Which opening do you want to edit?",
    measure_extra_photos: "Extra photos of this opening",
    measure_extra_add_later: "Add photos",
    add: "Add",
    measure_unit_type: "Type (window or door):",
    measure_windows: "Windows",
    measure_doors: "Doors",
    not_now: "Not now",
    end_job_topic: "End Job Topic",
    job_topic_active: "New messages will be linked to this job",
    private: "Private",
    shared: "Shared",
    share_with_job: "Share with Job",
    select_messages: "Select messages",
    selected: "selected",
    link_selected: "Link to Job",
    overview: "Overview",
    communication: "Communication",
    files: "Files",
    open_job_chat: "Open Job Chat",
    shared_jobs: "Shared Jobs",
    search_in_conversation: "Search in conversation...",
    filtering_by: "Filtering by",
    unread: "Unread",
    settings: "Settings",
    create_issue: "Create Issue",
    change_category: "Category",
    msgs: "messages",
    no_activity: "No activity yet.",
    crews: "Crews",
    reported_by: "Reported by",
    from_message: "From message",
    translated: "Translated",
    see_original: "See original",
    show_translation: "Show translation",
    notifications: "Notifications",
    enable_notifications: "Enable notifications",
    notifications_enabled: "Notifications enabled",
    notifications_blocked: "Blocked by the browser",
    leader: "Leader",
    fi_issues_title: "Open problems",
    fi_tasks_title: "Tasks for you",
    fi_alerts_title: "Field alerts",
    fi_complete: "Complete",
    fi_task_done: "Task completed!",
    fi_by: "by",
    fi_view_chat: "View in chat",
    fi_resolve: "Resolve",
    fi_drag_hint: "Drop on the X to dismiss",
    fi_dismissed: "Problem alerts dismissed",
    fi_now: "now",
    buddy_tagline: "Your field helper",
    interp_open_btn: "Client mode (interpreter)",
    interp_title: "Live Interpreter",
    interp_subtitle: "Buddy translates between you and the customer",
    interp_preparing: "Buddy is getting ready: company, team and today's job...",
    interp_starting: "Preparing the introduction...",
    interp_listening: "Listening — anyone can speak",
    interp_recording: "Hearing you...",
    interp_thinking: "Translating...",
    interp_speaking: "Buddy is speaking...",
    interp_paused: "Microphone paused",
    interp_reintro: "Introduce again",
    interp_pause: "Pause",
    interp_resume: "Resume",
    interp_end: "End",
    interp_installer: "You",
    interp_customer: "Customer",
    interp_intro_label: "Introduction",
    interp_exit_label: "Closing",
    interp_customer: "Customer",
    interp_turns: "lines",
    interp_from_customer: "from the customer",
    interp_talks_hint: "Everything said through Buddy's Live Interpreter on this job — what the customer said and what the crew told them.",
    interp_talks_empty: "No interpreter conversation recorded for this job yet.",
    job_tab_customer: "Customer",
    interp_no_job: "No job linked today — this conversation will not be saved to a job.",
    interp_learned: "Got it! Saved for the whole company",
    interp_start_failed: "Couldn't start the interpreter. Try again.",
    interp_turn_failed: "I missed that one — please repeat.",
    interp_hint: "Buddy detects who is speaking by the language. Say \"Buddy...\" to teach terms, re-introduce or end.",
    interp_admin_title: "Interpreter (client mode) & Vocabulary",
    interp_admin_hint: "Buddy introduces the team to the customer and interprets live. Teach company vocabulary here (or by voice) — it applies to the interpreter AND to chat auto-translation.",
    interp_intro_instr_label: "Introduction instructions (optional)",
    interp_intro_instr_ph: "E.g.: always mention our 20-year warranty; keep it brief; thank them for choosing us...",
    interp_intro_saved: "Introduction instructions saved",
    interp_kind_term: "Term",
    interp_kind_team: "Team",
    interp_kind_fact: "Fact",
    interp_know_ph: "E.g.: Keep the term 'casing' untranslated — never translate it as 'moldura'",
    interp_know_added: "Saved — applies to the whole company",
    interp_know_empty: "Nothing taught yet. Add terms here or teach Buddy by voice.",
    buddy_global_title: "Global knowledge (all companies & solo users)",
    buddy_delete_conv: "Delete conversation (for me)",
    buddy_type_ph: "Type a command to Buddy…",
    buddy_mem_title: "What Buddy knows about me",
    buddy_mem_hint: "Everything you taught Buddy by voice or text. Edit or delete anytime — it is kept until you say otherwise.",
    buddy_mem_empty: "Nothing yet. Say \"Buddy, remember that…\" and it shows up here.",
    buddy_mem_add_ph: "Add something Buddy should remember…",
    buddy_mem_deleted: "Memory deleted",
    buddy_mem_saved: "Saved",
    buddy_rem_title: "My reminders",
    buddy_rem_hint: "Reminders Buddy will send you (New York time). Edit the text or time, or cancel.",
    buddy_rem_empty: "No active reminders. Say \"Buddy, remind me at 3 pm to…\".",
    buddy_rem_recurring_hint: "Recurring schedule — to change the days/time, ask Buddy by voice.",
    buddy_rem_in_past: "That time already passed",
    buddy_rem_deleted: "Reminder cancelled",
    bc_title: "Flyer / image notification",
    bc_hint: "Send a flyer to the people you choose. They get a push (with the image) and the flyer opens fullscreen in the app with an X to close. Times = how many times it is delivered and shown.",
    bc_title_ph: "Notification title",
    bc_body_ph: "Short message (optional)",
    bc_pick_image: "Choose image",
    bc_need_title_or_image: "Add a title or an image",
    bc_sent: "Sent!",
    bc_pick_company: "Choose company",
    bc_mode_all: "Everyone",
    bc_mode_company: "Whole company",
    bc_mode_company_role: "Company + role",
    bc_mode_role: "Role (all companies)",
    bc_mode_solo: "Solo accounts (no company)",
    bc_mode_individual: "Individual people",
    bc_times: "How many times",
    bc_interval: "Hours between sends",
    bc_recipients: "recipients",
    bc_send_now: "Send now",
    bc_history: "Sent flyers",
    bc_when_now: "Now",
    bc_when_schedule: "Schedule",
    bc_schedule_btn: "Schedule",
    bc_scheduled: "Scheduled!",
    bc_need_datetime: "Pick a date and time",
    bc_ny_time: "New York time",
    bc_scheduled_for: "Scheduled for",
    bc_next_send: "Next send",
    buddy_conv_deleted: "Conversation deleted for you",
    buddy_global_hint: "MASTER only. Everything here applies to EVERY company and every solo account: chat auto-translation, push previews, photo/video captions, the interpreter and Buddy himself — on top of each company's own knowledge. By voice: \"Buddy, teach everyone that...\".",
    buddy_global_ph: "E.g.: The term 'casing' is always kept in English — never translate it",
    buddy_global_added: "Saved — applies to everyone on the platform",
    buddy_global_empty: "No global knowledge yet.",
    buddy_global_badge: "GLOBAL",
    buddy_enabled_title: "Buddy assistant",
    buddy_enabled_on: "On — floating Buddy button and \"Hey Buddy\" available",
    buddy_enabled_off: "Off — Buddy hidden (translation and transcription keep following the AI setting)",
    banner_buddy: "Buddy on",
    delete_selected_title: "Delete {n} selected?",
    delete_selected_desc: "This cannot be undone.",
    select_items: "Select",
    media_tab: "Media",
    media_one: "item",
    media_many: "items",
    select_day: "Select all of this day",
    deselect_day: "Deselect this day",
    take_another: "Another",
    save_to_gallery: "Save to gallery",
    saved_to_gallery_n: "{n} saved to gallery",
    gallery_save_failed: "Could not save to gallery",
    new_messages_pill: "{n} new",
    unread_divider_one: "1 unread message",
    unread_divider_many: "{n} unread messages",
    app_update_banner: "Your app is outdated — tap to update",
    live_update_ready: "New version ready — tap to apply",
    live_update_applying: "Applying update…",
    live_update_checking: "Checking…",
    live_update_downloading: "Downloading…",
    live_update_check: "Check for updates",
    live_update_uptodate: "App is up to date",
    live_update_failed: "Update failed",
    live_update_ota: "live update",
    live_update_server: "server",
    live_update_builtin: "store version",
    live_update_no_plugin: "live update plugin missing in this build",
    store_versions_title: "Store versions",
    store_versions_hint: "Read automatically every hour from the App Store / Google Play. Users on an older version see a yellow bar until they update. The override field forces a version if a store lookup fails.",
    store_versions_refreshed: "Store versions refreshed",
    store_lookup_failed: "lookup failed",
    store_override_ph: "override",
    store_checked_at: "Last check",
    interp_choose_title: "Which stop are you at?",
    interp_choose_sub: "Say the customer's name or the order (first, second...) — or tap a stop below.",
    interp_choose_speak: "You have {n} stops today. Which one are you at? You can say the customer's name or the order — first, second...",
    interp_choose_retry: "Sorry, I didn't catch that. Say the customer's name or the order — or tap a stop on the screen.",
    interp_choose_status: "Which stop? Speak or tap",
    interp_helpers_title: "Who is with you today?",
    interp_helpers_status: "Who is with you? Speak or tap",
    interp_helpers_fixed: "Regular helpers",
    interp_helpers_none_saved: "No regular helpers saved yet — say their names and Buddy will remember them.",
    interp_helpers_alone: "I'm alone",
    interp_helpers_only_fixed: "Only the regular ones",
    interp_helpers_alone_say: "I'm alone today",
    interp_helpers_fixed_say: "Only my regular helpers",
    interp_helpers_retry: "Sorry, I didn't catch that. Tell me who is with you today, or say 'alone'.",
    interp_ask_helpers_label: "Ask who the helpers are before the introduction",
    helpers_fixed_title: "My fixed helpers",
    helpers_add: "Add",
    helpers_empty: "No helper yet — tap + or tell Buddy: \"my fixed helper is Juca\".",
    helpers_name_ph: "Helper's first name",
    helpers_saved: "Helpers updated",
    interp_ask_helpers_user_hint: "Before each introduction Buddy asks you who is with you today (regular / extra / alone)",
    interp_ask_helpers_hint: "Buddy privately asks the installer who is with him (regular / extra / alone) and only announces those names.",
    buddy_know_update: "Edit company knowledge?",
    buddy_know_delete: "Delete company knowledge?",
    buddy_know_updated: "Updated — applies to the whole company",
    buddy_know_deleted: "Deleted for the whole company",
    buddy_intro_draft: "Customer introduction instructions",
    buddy_intro_cleared: "(clear all instructions)",
    buddy_intro: 'Hi! I\'m Buddy, your helper. Say "Hey Buddy" and just talk — I notice when you finish and we keep the conversation going. Or hold the mic. Messages, reminders, weather, measurements, technical questions...',
    slide_to_cancel: "Slide to cancel",
    voice_cancelled: "Recording cancelled",
    message_info: "Message info",
    played_by: "Played by",
    seen_by: "Seen by",
    delivered_to: "Delivered to",
    not_delivered_yet: "Not delivered yet",
    nobody_yet: "Nobody yet",
    sent_at: "Sent",
    voice_invalid: "This recording could not be read — please record again",
    voice_empty: "Nothing was recorded — keep holding the mic until the timer starts",
    voice_interrupted: "Recording interrupted — listen and send if it's OK",
    voice_send_failed: "Voice send failed",
    chatter_hint: "End-of-day report for the company Chatter — built only from the PDF, today's chat and the job's issues. Review before posting.",
    chatter_release: "Customer happy - release the Survey",
    chatter_hold: "Hold the Survey",
    chatter_unknown: "Supervisor has not confirmed with the customer - hold the Survey",
    chatter_thumb_up: "Customer was happy",
    chatter_thumb_down: "Customer was NOT happy",
    chatter_sat_hint: "Did you call the customer? Tap to record the verdict in the report.",
    chatter_sat_by: "Marked by",
    chatter_sat_clear: "Undo",
    chatter_copy: "Copy",
    chatter_copied: "Report copied",
    chatter_saved: "Report saved",
    chatter_regen: "Regenerate",
    chatter_generated: "Generated",
    factory_reset: "Factory reset",
    factory_reset_confirm: "Wipes EVERYTHING this account did or configured — messages, DMs, photos, issues, tasks, Buddy memories, helpers, reminders, devices, passkeys and preferences. E-mail, password, role and company are kept, as if the account had just been created. This cannot be undone.",
    factory_reset_done: "Account reset to factory state",
    weekly_summary: "Weekly summary",
    weekly_jobs: "Jobs",
    weekly_units: "Units",
    weekly_crews: "Crews",
    weekly_summary_hint: "AI recap of your jobs this week (Mon–Sun)",
    weekly_summary_empty: "No active job of yours this week.",
    buddy_hold: "Tap to talk",
    buddy_listening: "Listening...",
    buddy_send_media: "Send file",
    buddy_media_sent: "Sent!",
    buddy_edit_msg: "Edit message",
    buddy_msg_edited: "Message edited.",
    buddy_delete_msg: "Delete message",
    buddy_msg_deleted: "Message deleted.",
    buddy_issue_status: "Update issue",
    buddy_issue_updated: "Issue updated!",
    buddy_task_complete: "Complete task",
    buddy_task_reopen: "Reopen task",
    buddy_task_done: "Task completed!",
    buddy_task_reopened: "Task reopened.",
    buddy_new_group: "New group",
    buddy_group_created: "Group created!",
    theme_title: "Theme",
    theme_light: "Light",
    theme_dark: "Dark",
    theme_system: "Automatic (follows the phone)",
    search_offline_hint: "Offline — searching what is saved on this phone",
    settings_sec_account: "Account & security",
    settings_sec_appearance: "Appearance",
    settings_sec_buddy: "Buddy (assistant)",
    settings_sec_data: "Data & connection",
    buddy_memories_short: "Everything you taught Buddy — view, edit, delete",
    buddy_reminders_short: "Reminders Buddy will send you",
    offline_mode_on_short: "On",
    offline_mode_off_short: "Off — online only",
    offline_setup_title: "Offline mode on this phone?",
    offline_setup_intro: "Keep a copy of your conversations on this phone so you can read everything without signal. When the connection is back, everything syncs automatically (sent and received).",
    offline_setup_intro_settings: "Choose how much to keep on this phone. Everything stays saved on the server either way.",
    offline_history: "History to download",
    offline_history_90d: "Last 90 days",
    offline_history_12m: "Last 12 months",
    offline_history_all: "Everything",
    offline_history_all_hint: "May use a lot of space on older accounts.",
    offline_photos: "Photos",
    offline_photos_thumb: "Thumbnails only",
    offline_photos_thumb_hint: "Light. Full-size photos load when you have signal.",
    offline_photos_full: "Full-size photos",
    offline_photos_full_hint: "Uses more space on the phone.",
    offline_voice_note: "Voice messages are always kept offline (they are small).",
    offline_enable_btn: "Yes, download and keep in sync",
    offline_online_only_btn: "No, online only",
    offline_downloading: "Downloading your conversations…",
    offline_downloading_hint: "You can keep using the app — it continues in the background.",
    offline_mode: "Offline mode on this device",
    offline_mode_on_hint: "Conversations are mirrored on this phone and synced automatically.",
    offline_mode_off_hint: "Online only — nothing is stored on this device.",
    offline_media_files: "media files",
    offline_device_free: "free on device",
    offline_sync_now: "Sync now",
    offline_change_options: "Options",
    offline_manage: "Free up space",
    offline_manage_title: "Offline storage",
    offline_clear_media_30: "Delete media older than 30 days",
    offline_clear_media_all: "Delete all offline media",
    offline_clear_conv_title: "Delete a conversation from this phone",
    offline_clear: "Delete",
    offline_disabled_toast: "Offline mode off — data removed from this device.",
    offline_full_title: "Phone storage is full",
    offline_full_body: "There is no space left to keep your conversations offline. Free up space (delete media or conversations from this phone) or switch to online-only mode.",
    offline_full_manage_btn: "Free up space and keep offline mode",
    offline_full_short: "Storage full — free up space to continue.",
    offline_banner_mode: "No connection — offline mode: showing what is saved on this phone.",
    offline_syncing: "Syncing…",
    presence_typing_one: "{name} is typing…",
    presence_typing_many: "Several people are typing…",
    presence_recording_one: "{name} is recording audio…",
    presence_recording_many: "Several people are recording audio…",
    presence_recording_label: "Recording audio…",
    presence_typing_label: "typing",
    buddy_thinking: "Thinking...",
    buddy_speaking: "Speaking...",
    buddy_interrupt_hint: 'say "Hey Buddy" to interrupt',
    buddy_memories_label: "Buddy's memories",
    buddy_memories_hint: "Everything you taught Buddy — he uses it in every conversation",
    buddy_memories_empty: 'Buddy hasn\'t learned anything yet. Teach him by voice ("Buddy, remember that...") or add below.',
    buddy_memory_add_ph: "Teach Buddy something new...",
    buddy_memory_saved: "Buddy learned it!",
    buddy_memory_updated: "Memory updated",
    buddy_memory_deleted: "Memory deleted",
    buddy_new_memory: "Remember this?",
    buddy_remember_btn: "Remember",
    buddy_personality: "Personality",
    buddy_style_default: "Default",
    buddy_style_formal: "Formal",
    buddy_style_casual: "Casual",
    buddy_style_direct: "Direct",
    buddy_instructions_ph: 'Personal instructions... e.g. "always call me boss", "answer short"',
    buddy_prefs_saved: "Buddy adapted to you!",
    buddy_prefs_save: "Save",
    buddy_rules_title: "Company rules for Buddy",
    buddy_rules_hint: "Rules apply to every user's Buddy, or only to a specific user. Users can't see or change them.",
    buddy_rule_ph: 'New rule... e.g. "Always mention safety gear when talking about installs"',
    buddy_rule_target_all: "All users",
    buddy_rule_add: "Add rule",
    buddy_rule_added: "Rule added",
    buddy_rule_saved: "Rule saved",
    buddy_rule_deleted: "Rule deleted",
    buddy_user_memories: "Memories by user",
    buddy_pick_user: "Select a user...",
    buddy_no_memories_user: "This user hasn't taught Buddy anything yet.",
    buddy_send: "Send",
    buddy_cancel: "Cancel",
    buddy_to: "To",
    buddy_sent: "Message sent!",
    buddy_group: "Group",
    buddy_new_task: "New task",
    buddy_new_issue: "New problem",
    buddy_task_created: "Task created!",
    buddy_issue_created: "Problem registered!",
    buddy_confirm: "Confirm",
    buddy_open_job: "Open job",
    buddy_wake_label: '"Hey Buddy" (hands-free)',
    buddy_wake_on: '"Hey Buddy" is ON — I am listening while the app is open',
    buddy_wake_off: '"Hey Buddy" is off',
    buddy_wake_hint: 'or say "Hey Buddy"',
    buddy_too_short: "Hold the button while you speak",
    buddy_error: "Ouch, something went wrong. Try again!",
    buddy_mic_denied: "To talk with Buddy, enable the microphone",
    buddy_speak_now: "Go ahead — I'm listening!",
    buddy_handsfree_hint: "I'll answer when you pause",
    buddy_tap_cancel: "tap to cancel",
    buddy_draft_discarded: "Ok, draft discarded.",
    buddy_voice_on: "Voice on — Buddy speaks the replies",
    buddy_voice_off: "Voice muted — text only",
    buddy_size_label: "Buddy size (S/M/L)",
    buddy_speed_label: "Buddy voice speed (1x / 1.5x / 2x)",
    buddy_sfx_on: "Tool sounds: loud",
    buddy_sfx_low: "Tool sounds: soft",
    buddy_sfx_off: "Tool sounds: off",
    buddy_load_older: "View older messages",
  },
  pt: {
    offline_opened: "Sem internet — mostrando seus dados salvos; sincroniza quando a conexão voltar.",
    buddy_company_remove: "Remover membro da empresa",
    buddy_company_leave_approve: "Aprovar pedido de saída",
    buddy_company_leave_reject: "Rejeitar pedido de saída",
    buddy_company_removed: "Membro removido.",
    invites_title: "Convites enviados",
    invites_sent: "enviados",
    invites_accepted: "aceitos",
    invites_empty: "Nenhum convite enviado ainda.",
    invited_by: "por",
    invite_status_accepted: "Entrou",
    invite_status_pending: "Pendente",
    invite_share_hint: "Compartilhar não está disponível neste aparelho — o texto foi copiado. Cole no WhatsApp ou onde preferir.",
    invite_share: "Compartilhar pelo WhatsApp ou outro app",
    close: "Fechar",
    invite_title: "Convidar para o OnSiteComms",
    invite_not_found: "ainda não está no OnSiteComms. Quer enviar um convite?",
    invite_email_explain: "Vamos enviar um e-mail de convite com um link — quando a pessoa criar a conta, vocês ficam conectados automaticamente.",
    invite_sms_explain: "Seu app de mensagens vai abrir com o convite já escrito — é só tocar em Enviar.",
    invite_sms_hint: "Se o app de mensagens não abriu, copie o texto abaixo e envie como preferir.",
    invite_send_email: "Enviar convite por e-mail",
    invite_send_sms: "Enviar convite por SMS",
    invite_open_sms: "Abrir mensagens",
    invite_email_sent: "Convite enviado para",
    invite_already_registered: "Essa pessoa já tem conta — confira o e-mail/telefone digitado.",
    invite_email_unavailable: "Convite por e-mail indisponível no momento.",
    invite_invalid: "Digite um e-mail ou telefone válido.",
    buddy_admin_approve: "Aprovar conta",
    buddy_admin_reject: "Rejeitar pedido de conta",
    buddy_admin_broadcast: "Enviar broadcast",
    buddy_admin_user_update: "Atualizar usuário",
    buddy_admin_user_delete: "Excluir usuário",
    buddy_admin_approved: "Conta aprovada!",
    buddy_admin_rejected: "Pedido rejeitado.",
    buddy_admin_broadcast_sent: "Broadcast enviado!",
    buddy_admin_user_updated: "Usuário atualizado!",
    buddy_admin_user_deleted: "Usuário excluído.",
    attach_intent_camera: "Buddy: toque para tirar a foto e enviar aqui",
    attach_intent_gallery: "Buddy: toque para escolher a foto e enviar aqui",
    attach_intent_video: "Buddy: toque para escolher o vídeo e enviar aqui",
    attach_intent_document: "Buddy: toque para escolher o arquivo e enviar aqui",
    app_tagline: "Feito para resolver o trabalho de campo.",
    select_profile: "Quem é você?",
    select_profile_sub: "Escolha seu perfil para entrar no OnSiteComms. Sem senha no modo demo.",
    sign_in: "Entrar",
    create_account: "Criar conta",
    email: "Email",
    password: "Senha",
    your_name: "Nome completo",
    role: "Função",
    or: "ou",
    sign_in_passkey: "Entrar com FaceID / Passkey",
    sign_in_apple: "Entrar com Apple",
    apple_soon: "Entrar com Apple estará disponível em breve",
    apple_prod_only: "O login com Apple funciona em on-site-comms.com (após o deploy de produção)",
    apple_signing_in: "Entrando com Apple...",
    apple_login_failed: "Falha ao entrar com Apple. Tente novamente.",
    google_soon: "Entrar com Google estará disponível em breve",
    google_signing_in: "Entrando com Google...",
    google_login_failed: "Falha ao entrar com Google. Tente novamente.",
    google_account_not_found: "Conta não encontrada. Peça ao administrador para cadastrar seu e-mail primeiro.",
    register_approval_notice: "Contas novas precisam de aprovação do administrador. Você receberá um e-mail quando sua solicitação for aprovada.",
    register_pending_title: "Solicitação enviada!",
    register_pending_sub: "Sua solicitação de conta foi enviada ao administrador. Você receberá um e-mail assim que for aprovada.",
    register_already_pending: "Sua solicitação já foi enviada e está aguardando aprovação.",
    login_pending_approval: "Sua conta ainda está aguardando aprovação do administrador. Você receberá um e-mail quando for aprovada.",
    reg_requests_title: "Solicitações de conta",
    reg_approve: "Aprovar",
    reg_reject: "Rejeitar",
    reg_approved_toast: "Conta aprovada",
    reg_rejected_toast: "Solicitação rejeitada",
    reg_mode_solo: "Sem empresa",
    reg_mode_join: "Entrar em empresa",
    reg_mode_create: "Criar empresa",
    reg_solo_notice: "Conta independente: você começa sozinho e adiciona contatos um a um pelos códigos de conexão.",
    reg_create_notice: "Você vai criar a empresa e será o administrador dela, aprovando quem entra.",
    company_name: "Nome da empresa",
    company_code: "Código da empresa",
    company_name_required: "Informe o nome da empresa",
    company_code_required: "Informe o código da empresa (peça ao administrador)",
    invalid_company_code: "Código de empresa não encontrado. Confirme com o administrador.",
    phone_optional: "Celular (opcional)",
    phone_exists: "Este número de celular já está cadastrado",
    invalid_phone: "Número de celular inválido",
    company_created_toast: "Empresa criada! Compartilhe o código da empresa (no Admin) para convidar sua equipe",
    company_and_connections: "Empresa & Conexões",
    company: "Empresa",
    no_company: "Conta independente (sem empresa)",
    connect_code_explainer: "Seu código É o seu e-mail ou número de celular. Compartilhe com alguém DE FORA da sua empresa para se conectarem.",
    generate_my_code: "Gerar meu código",
    enter_someones_code: "E-mail ou celular da pessoa",
    connect: "Conectar",
    connected_with: "Conectado com",
    invalid_connect_code: "Este usuário não existe",
    phone: "Celular",
    own_connect_code: "Esse é o seu próprio código",
    valid_until: "válido até",
    copied: "Copiado!",
    members: "membros",
    company_code_hint: "Compartilhe este código com quem deve ENTRAR na sua empresa (você aprova cada solicitação).",
    partner_companies: "Empresas parceiras",
    partner_code_placeholder: "Código parceiro",
    connect_companies: "Conectar empresas",
    partner_connected_toast: "Empresas conectadas",
    partner_disconnected_toast: "Empresas desconectadas",
    disconnect_company: "Desconectar",
    disconnect_company_confirm: "As duas empresas deixam de ver os contatos uma da outra.",
    purge_related_question: "Gostaria de apagar as conversas e contatos relacionados?",
    purge_yes_delete_all: "Sim — apagar tudo",
    purge_no_keep_loose: "Não — manter como contatos avulsos",
    purge_no_hint: "Se mantiver, os contatos com conversas já começadas viram contatos avulsos.",
    no_partner_companies: "Nenhuma empresa parceira ainda — digite o código de uma empresa acima para trocar cartões de visita.",
    my_company_badge: "Minha empresa",
    company_card_empty: "Sem informações de contato — toque em Editar para preencher o cartão.",
    company_card_saved: "Cartão de visita salvo",
    edit_company_card: "Editar cartão",
    connect_company_hint: "Digite o código da outra empresa para trocar cartões de visita — os contatos das duas empresas ficam visíveis entre si.",
    company_name_label: "Nome da empresa",
    company_address_label: "Endereço",
    company_website_label: "Site",
    business_cards_tab: "Cartões de Visita",
    partner_visibility_btn: "Contatos visíveis",
    partner_visibility_title: "Contatos visíveis",
    partner_visibility_hint: "Escolha quais contatos desta empresa os SEUS usuários podem ver. Contatos desmarcados somem da lista de contatos e da nova conversa (admins sempre veem todos; conversas existentes são mantidas).",
    partner_visibility_hint_out: "Escolha quais contatos da SUA empresa esta parceira pode ver. Contatos desmarcados ficam invisíveis para TODOS de lá — inclusive os admins (conversas existentes são mantidas).",
    partner_visibility_tab_in: "O que minha equipe vê",
    partner_visibility_tab_out: "O que eles veem da minha",
    partner_visibility_saved: "Visibilidade dos contatos atualizada",
    partner_visibility_count: "{n} de {t} contatos visíveis",
    select_all: "Marcar todos",
    clear_all: "Desmarcar todos",
    personal_contacts: "Contatos avulsos",
    add_personal_contact: "Adicionar contato avulso",
    add_existing_user: "Adicionar usuário",
    add_existing_user_hint: "A pessoa já tem conta no app? Digite o e-mail ou celular dela para convidá-la para a sua empresa. Ela entra assim que aprovar.",
    add_existing_user_toast: "Convite enviado — aguardando aprovação do usuário",
    company_invite_title: "Convite de empresa",
    company_invite_text: "{admin} convidou você para entrar na empresa {company} como {role}",
    invite_accepted_toast: "Você agora faz parte da empresa",
    invite_declined_toast: "Convite recusado",
    pending_invites_title: "Convites enviados (aguardando aprovação)",
    cancel_invite: "Cancelar convite",
    invite_cancelled_toast: "Convite cancelado",
    already_member: "Essa pessoa já faz parte da sua empresa",
    belongs_to_other_company: "Essa pessoa já pertence a outra empresa — ela precisa sair de lá primeiro.",
    last_admin_error: "A empresa precisa ter sempre pelo menos um Admin. Promova outro Admin primeiro.",
    connect_confirm_title: "Conectar com esta pessoa?",
    connect_confirm_hint: "Uma conversa direta será aberta entre vocês.",
    member_history_title: "Histórico de membros",
    mh_joined: "entrou na empresa",
    mh_left: "saiu da empresa",
    mh_removed: "foi removido da empresa",
    mh_created: "conta criada",
    mh_deleted: "conta excluída",
    mh_promoted: "virou Admin",
    mh_by: "por",
    mh_empty: "Nenhum evento ainda — o histórico começa a contar a partir de agora.",
    transfer_admin: "Transferir posto de Admin",
    transfer_admin_hint: "Você é o único Admin — para poder sair da empresa, primeiro passe o posto para outro membro.",
    transfer_admin_pick: "Escolha o novo Admin",
    transfer_admin_done: "agora também é Admin — você já pode solicitar a saída.",
    pmhr_links_title: "Vínculos da sincronização",
    pmhr_links_hint: "A sincronização nunca cria usuários. Vincule cada supervisor e equipe do schedule a um usuário EXISTENTE — inclusive de empresas parceiras — nada fica órfão.",
    pmhr_partner_company: "empresa parceira",
    buddy_voice_title: "Voz do Buddy",
    buddy_voice_desc: "Usada quando o Buddy fala e apresenta ao cliente",
    buddy_voice_preview: "Ouvir uma amostra",
    buddy_voice_error: "Não foi possível atualizar a voz. Tente de novo.",
    voice_echo: "masculina (padrão)",
    voice_alloy: "neutra",
    voice_fable: "britânica",
    voice_onyx: "grave",
    voice_nova: "feminina",
    voice_shimmer: "feminina suave",
    signin_with_apple: "Iniciar sessão com Apple",
    signin_with_google: "Fazer login com o Google",
    signin_with_faceid: "Entrar com Face ID",
    ai_consent_title: "Recursos de IA e seus dados",
    ai_consent_p1: "O OnSiteComms usa a OpenAI para oferecer tradução automática, transcrição de áudios e o assistente Buddy.",
    ai_consent_p2: "Quando você usa esses recursos, o conteúdo abaixo é enviado à OpenAI (EUA) apenas para fornecer a função. Nunca é usado para publicidade, e a OpenAI não usa dados da API para treinar seus modelos:",
    ai_consent_b1: "Texto das suas mensagens — para a tradução automática",
    ai_consent_b2: "Gravações de voz — para transcrição e o intérprete ao vivo",
    ai_consent_b3: "Suas perguntas e comandos de voz ao Buddy",
    ai_consent_b4: "Fotos que você pedir para a IA analisar (ex.: medidas)",
    ai_consent_warning: "Se você não autorizar, você NÃO poderá usar a tradução automática, o assistente Buddy nem a transcrição de áudios. Você pode mudar isso a qualquer momento em Configurações.",
    ai_consent_accept: "Autorizar e continuar",
    ai_consent_decline: "Não autorizar",
    ai_consent_privacy: "Ler nossa Política de Privacidade",
    ai_consent_error: "Não foi possível salvar sua escolha. Tente de novo.",
    ai_settings_title: "Recursos de IA (OpenAI)",
    ai_settings_on: "Autorizado — tradução automática, Buddy e transcrição ativos",
    ai_settings_off: "Desligado — sem tradução automática, sem Buddy, sem transcrição",
    info_email: "Email",
    info_phone: "Celular",
    contact_copied: "Contato copiado!",
    email_pending: "Já existe uma solicitação de conta pendente com este email — peça ao seu admin para aprová-la",
    master_users_title: "Todas as contas",
    master_banners_hint: "Todas as contas do sistema em uma única lista: mude a função, edite, remova da empresa ou apague. As chaves exibem novamente um banner no PRÓXIMO login do usuário (tour de abertura / consentimento Buddy-IA); cada um aparece uma vez e se desliga sozinho.",
    banner_tour: "Tour de abertura",
    banner_ai: "Consentimento Buddy/IA",
    master_users_search_ph: "Buscar por nome, email ou empresa...",
    all_companies: "Todas as empresas",
    all_roles: "Todas as funções",
    master_no_company: "Sem empresa",
    master_sort_name_asc: "Nome (A–Z)",
    master_sort_name_desc: "Nome (Z–A)",
    master_sort_company: "Por empresa",
    master_sort_role: "Por função",
    master_sort_pending: "Banners pendentes primeiro",
    master_filter_no_results: "Nenhuma conta corresponde aos filtros",
    pmhr_link_pending: "Pendente",
    pmhr_link_linked: "Vinculado",
    pmhr_link_btn: "Vincular",
    pmhr_link_saved: "Vínculo salvo",
    pmhr_links_pending_toast: "Sincronização concluída — há vínculos pendentes para configurar",
    pmhr_kind_crew: "Equipe",
    pmhr_kind_supervisor: "Supervisor",
    pmhr_link_select: "Escolher usuário",
    personal_connections_title: "Conexões pessoais",
    own_company_code: "Esse é o código da sua própria empresa",
    code_regenerated_toast: "Novo código da empresa gerado (o antigo deixou de funcionar)",
    leave_requests_title: "Pedidos de saída",
    leave_approved_toast: "Saída aprovada",
    leave_rejected_toast: "Saída rejeitada",
    member_removed_toast: "Removido da empresa",
    remove_from_company: "Remover da empresa",
    remove_from_company_confirm: "{name} sairá da empresa e perderá acesso aos trabalhos, equipes e contatos da empresa. Contatos com conversas já começadas viram contatos avulsos. A conta continua ativa (avulsa).",
    request_leave_company: "Solicitar saída da empresa",
    leave_company_confirm: "Seu administrador precisa aprovar este pedido. Sua conta continua ativa, mas você perde acesso aos contatos e trabalhos da empresa.",
    leave_requested_toast: "Pedido enviado ao seu administrador",
    leave_pending_note: "Pedido de saída enviado — aguardando aprovação do administrador.",
    confirm: "Confirmar",
    sync_source_title: "Fonte de sincronização (sistema da sua empresa)",
    sync_source_sub: "Cada empresa configura AQUI o próprio sistema de trabalhos. A sincronização só mexe nos trabalhos da sua empresa.",
    sync_base_url: "Endereço da API (ex.: https://meusistema.com/api)",
    sync_username: "Usuário",
    sync_password: "Senha",
    sync_password_saved: "Senha (já salva)",
    sync_interval: "Intervalo (min)",
    sync_past_days: "Dias passados",
    sync_future_days: "Dias futuros",
    sync_save: "Salvar configuração",
    sync_saved_toast: "Configuração de sincronização salva",
    sync_test: "Testar conexão",
    sync_test_ok: "Conexão OK! O login funcionou e {n} trabalhos foram encontrados na fonte. Você já pode ligar a sincronização automática.",
    sync_last_error_title: "A última sincronização falhou — motivo:",
    sync_err_not_configured: "A sincronização ainda não está configurada. Preencha o endereço da API, usuário e senha, salve e teste novamente.",
    sync_err_invalid_url: "O endereço da API é inválido. Use o formato completo, ex.: https://seusistema.com/api (precisa começar com http:// ou https://).",
    sync_err_connection: "Não foi possível conectar ao endereço. Verifique se digitou a URL corretamente e se o sistema está online e acessível pela internet.",
    sync_err_timeout: "O sistema da fonte demorou demais para responder. Ele pode estar lento ou fora do ar — tente novamente em alguns minutos.",
    sync_err_auth: "A fonte recusou o USUÁRIO ou a SENHA. Confira as credenciais do SEU sistema de trabalhos (não é o seu login do OnSiteComms).",
    sync_err_server: "O sistema da fonte retornou um erro interno (5xx). O problema está do lado deles — tente mais tarde.",
    sync_err_bad_response: "O endereço respondeu, mas não no formato esperado. Confirme se é o endereço da API (geralmente termina em /api) e se o sistema é compatível.",
    sync_err_generic: "Erro inesperado na sincronização. Use o Testar conexão para ver os detalhes.",
    company_qr_title: "QR code de convite da empresa",
    company_qr_hint: "Sua equipe aponta a câmera do celular para este QR: o cadastro abre com o código da empresa já preenchido. Você continua aprovando cada solicitação.",
    company_qr_copy_link: "Copiar link",
    join_link_logged_in: "Este é um convite de cadastro em empresa. Você já está logado — saia da conta para se cadastrar com este código.",
    share_link: "Compartilhar",
    share_invite_text_personal: "Fale comigo no OnSiteComms — toque no link para conectar:",
    share_invite_text_company: "Entre na minha empresa no OnSiteComms — toque no link para se cadastrar:",
    my_qr_btn: "Meu QR code",
    my_qr_title: "Meu QR code de conexão",
    my_qr_hint: "Quem apontar a câmera do celular para este QR se conecta com você na hora e uma conversa direta é aberta (a pessoa faz login antes, se precisar).",
    connect_after_login: "Entre (ou crie sua conta) para completar a conexão",
    welcome_back: "Bem-vindo",
    account_created: "Conta criada!",
    login_failed: "Email ou senha inválidos",
    register_failed: "Não foi possível criar a conta",
    email_exists: "Já existe uma conta com este email",
    password_min: "Mínimo 6 caracteres",
    passkey_error: "Falha ao entrar com passkey",
    passkey_cancelled: "Passkey cancelada",
    passkey_added: "Passkey adicionada! Já pode entrar com FaceID",
    passkey_already_active: "O FaceID já estava ativado neste aparelho — tudo certo!",
    reminder_alarm_title: "Lembrete!",
    reminder_alarm_sub: "O Buddy está te lembrando:",
    reminder_alarm_close: "OK, entendi",
    add_passkey: "Adicionar Passkey (FaceID)",
    passkey_active: "Passkey ativa",
    sign_out: "Sair",
    login_footer: "Acesso seguro. A sessão fica ativa por 30 dias.",
    profile: "Perfil",
    change_password: "Mudar senha",
    current_password: "Senha atual",
    new_password: "Nova senha",
    confirm_password: "Confirmar nova senha",
    password_changed: "Senha alterada!",
    passwords_mismatch: "As senhas não coincidem",
    wrong_current_password: "Senha atual incorreta",
    reopened: "Reaberto",
    push_notifications: "Notificações push",
    notifications_off: "Notificações desativadas",
    markup_sent: "Marcação enviada para a conversa",
    speak_issue: "Falar o problema",
    speak_again: "Falar novamente",
    listening_tap_stop: "A ouvir... toque para parar",
    creating_title: "A criar o rascunho do problema...",
    draft_ready: "Rascunho pronto — revê abaixo",
    add_media_question: "Adicionar foto ou vídeo?",
    create_now: "Criar problema agora",
    speak_resolution: "Falar a resolução",
    speak_task: "Falar a tarefa",
    speak_material: "Falar o pedido de material",
    processing_voice: "A processar o que disseste...",
    send_now: "Enviar agora",
    task_create_now: "Criar tarefa agora",
    add_photo_question: "Adicionar foto?",
    pick_assignee_hint: "Escolhe o responsável abaixo e depois cria",
    photo_one: "Foto",
    unread_chat: "Chat não lido",
    take_photo: "Tirar foto",
    photo_gallery: "Foto (Galeria)",
    record_video: "Gravar vídeo",
    video_gallery: "Vídeo (Galeria)",
    camera_unavailable: "Câmera não disponível",
    captions: "Legendas",
    generating_captions: "Gerando legendas...",
    generate_captions: "Gerar legendas",
    compressing_video: "Comprimindo vídeo...",
    sending_video: "Enviando vídeo...",
    sending_photo: "Enviando foto...",
    photo_sent_to: "Foto enviada para {name}",
    photo_send_failed_to: "Não foi possível enviar a foto para {name}",
    tap_to_retry: "toque para reenviar",
    video_quality_title: "Enviar vídeo como",
    video_quality_fast: "Rápido (720p)",
    video_quality_fast_hint: "Comprimido no celular — menos dados, mais rápido",
    video_quality_original: "Original",
    video_quality_original_hint: "Qualidade total, arquivo maior",
    queued: "Aguardando...",
    video_sending_bg: "Enviando em segundo plano — pode continuar usando o app",
    video_sent_to: "Vídeo enviado para {name}",
    video_send_failed_to: "Não foi possível enviar o vídeo para {name}",
    video_discarded: "Vídeo descartado",
    copy: "Copiar",
    copied: "Copiado",
    forward: "Encaminhar",
    forward_to: "Encaminhar para...",
    send_to_chat: "Enviar para conversa",
    pick_emoji: "Escolher emoji",
    reactions: "Reações",
    you: "Você",
    tap_to_remove: "Toque para remover",
    stickers: "Figurinhas",
    sticker: "Figurinha",
    add_sticker: "Adicionar",
    stickers_imported: "{n} figurinha(s) adicionada(s)",
    sticker_import_hint: "Importe PNG, WebP ou GIF (animadas também) — ex.: figurinhas exportadas do WhatsApp",
    no_recent_stickers: "Nenhuma figurinha recente",
    no_saved_stickers: "Nenhuma figurinha salva. Toque em + para adicionar as suas.",
    save_sticker: "Salvar em Minhas figurinhas",
    sticker_saved: "Figurinha salva",
    sticker_from_photo: "Figurinha a partir de foto",
    create_sticker: "Criar figurinha",
    no_speech_detected: "Nenhuma fala detectada neste vídeo",
    crop_hint_sticker: "Arraste para posicionar a foto dentro do quadro — use o controle para dar zoom",
    sticker_studio: "Estúdio de figurinhas",
    sticker_text_placeholder: "Adicionar texto (opcional)",
    text_top: "Em cima",
    text_bottom: "Embaixo",
    record_video_sticker: "Gravar vídeo curto para figurinha",
    sticker_clip_start: "Início do trecho (máx. 5s)",
    sticker_creating: "Criando…",
    sticker_studio_hint_anim: "Arraste para enquadrar · zoom · até 5 s em loop, sem som",
    sticker_too_large: "Figurinha muito pesada — use um trecho menor ou mais fechado",
    sticker_render_failed: "Não foi possível criar a figurinha com este arquivo",
    sticker_no_preview: "Prévia indisponível neste aparelho — a figurinha usará o centro dos primeiros 5 segundos",
    make_sticker: "Criar figurinha",
    sticker_saved_hint: "Figurinha salva em \"Minhas\" na bandeja de figurinhas",
    view_photo: "Ver foto",
    period_all: "Todas as datas",
    period_today: "Hoje",
    period_this_week: "Esta semana",
    period_last_week: "Semana passada",
    period_next_week: "Semana que vem",
    period_this_month: "Este mês",
    period_last_month: "Mês passado",
    period_next_month: "Mês que vem",
    forward_comment_placeholder: "Escreva um comentário (opcional)",
    forwarded: "Encaminhada",
    message_forwarded: "Mensagem encaminhada",
    deleted_message_by: "Mensagem apagada por {name} em {date} às {time}",
    add_favorite: "Adicionar aos favoritos",
    remove_favorite: "Remover dos favoritos",
    favorites: "Favoritos",
    no_favorites: "Nenhuma mensagem favorita ainda",
    added_favorite: "Adicionado aos favoritos",
    removed_favorite: "Removido dos favoritos",
    pin_message: "Fixar no topo",
    pin_for: "Fixar por...",
    hours_24: "24 horas",
    days_7: "7 dias",
    days_30: "30 dias",
    pinned_by: "Fixada por",
    message_pinned: "Mensagem fixada",
    deleted_message: "Mensagem apagada",
    delete_conversation: "Apagar conversa",
    delete_conversation_confirm: "A conversa sumirá apenas da sua lista — a outra pessoa continua com ela. Se alguém enviar uma nova mensagem ela reaparece, mas o histórico antigo continua apagado para você.",
    conversation_deleted: "Conversa apagada",
    save_to_device: "Guardar no dispositivo",
    saved_to_device: "Guardado no teu dispositivo",
    other_supervisors_jobs: "Trabalhos de outros supervisores",
    installer: "Líder de Equipe",
    supervisor: "Supervisor",
    office: "Escritório",
    manager: "Gerente",
    admin: "Admin",
    admin_panel: "Painel Admin",
    admin_only: "Acesso restrito ao administrador",
    users: "Usuários",
    system: "Sistema",
    create_user: "Criar usuário",
    full_name: "Nome completo",
    password_min: "A senha deve ter pelo menos 6 caracteres",
    password_ph: "Senha (mínimo 6 caracteres)",
    password_updated: "Senha atualizada",
    user_created: "Usuário criado",
    reset_password: "Redefinir senha",
    last_login: "Último acesso",
    clear: "Limpar",
    passkeys_cleared: "Passkeys removidas — o usuário pode registrar o Face ID novamente",
    token_removed: "Aparelho removido",
    test_push_sent: "Push de teste enviado",
    test_push_body: "As notificações push estão funcionando!",
    no_devices_yet: "Nenhum aparelho registrado ainda. Os aparelhos aparecem aqui quando os usuários entram pelo app do celular.",
    pmhr_tab: "Sincronização",
    pmhr_title: "Sincronização de Agenda",
    pmhr_sync_now: "Sincronizar agora",
    pmhr_syncing: "Sincronizando...",
    pmhr_sync_done: "Sincronização concluída",
    pmhr_auto_sync: "Sincronização automática",
    pmhr_auto_on: "Roda automaticamente a cada {n} min",
    pmhr_auto_off: "Auto-sync desligado — apenas sincronização manual",
    pmhr_last_sync: "Última sincronização",
    pmhr_never: "Nunca",
    pmhr_synced_jobs: "Jobs sincronizados",
    pmhr_synced_pdfs: "PDFs importados",
    pmhr_created: "Criados",
    pmhr_updated: "Atualizados",
    pmhr_deleted: "Removidos",
    pmhr_pdfs: "PDFs",
    pmhr_skipped: "Sem mudanças",
    pmhr_errors: "Erros",
    pmhr_history: "Histórico de sincronizações",
    pmhr_no_logs: "Nenhuma sincronização ainda",
    pmhr_window: "Janela: últimos {p} + próximos {f} dias",
    pmhr_note: "Jobs e PDFs do Installation Package são espelhados do seu sistema de agenda. Usuários e grupos de chat NUNCA são criados automaticamente — vincule supervisores e equipes a usuários existentes em \"Vínculos da sincronização\" acima.",
    dup_title: "Trabalhos duplicados",
    dup_check: "Verificar duplicados",
    dup_checking: "Verificando...",
    dup_none: "Nenhum trabalho ou PDF duplicado encontrado. Tudo limpo!",
    dup_found: "{j} trabalho(s) duplicado(s) ({e} cópias extras) e {p} PDF(s) extra(s) encontrados:",
    dup_delete_all: "Apagar todos os duplicados",
    dup_deleted: "Duplicados removidos",
    dup_copies: "cópias",
    delete_user: "Apagar usuário",
    delete_message: "Apagar mensagem",
    delete_message_confirm: "\"Apagar para mim\" esconde só para você. \"Apagar para todos\" remove para todos.",
    delete_for_me: "Apagar para mim",
    delete_for_everyone: "Apagar para todos",
    delete_window_expired: "Já passou o prazo para apagar para todos — você ainda pode apagar só para você.",
    message_deleted: "Mensagem apagada",
    search: "Buscar...",
    send_markup_title: "Enviar marcação",
    send_to_whom: "Para quem gostaria de enviar?",
    link_to_job_q: "Vincular a um trabalho? (opcional)",
    choose_job: "Escolher trabalho",
    old_measurements_wrong: "Medidas antigas erradas",
    all_crews: "Todas",
    service_supervisor_label: "Supervisor padrão para trabalhos Service",
    service_supervisor_none: "Nenhum (deixar sem supervisor)",
    service_supervisor_hint: "Trabalhos Service vêm da matriz sem supervisor — a pessoa escolhida aqui é atribuída automaticamente em cada sincronização.",
    resolved: "Resolvido",
    cleanup_orphans_title: "Limpar registros órfãos",
    cleanup_orphans_desc: "Apaga sobras que apontam para coisas que não existem mais: mensagens de conversas apagadas e problemas/tarefas cujo trabalho E conversa se foram. Problemas ainda ligados a um trabalho vivo são mantidos.",
    cleanup_orphans_btn: "Limpar órfãos",
    cleanup_orphans_confirm: "Isso apaga permanentemente todos os registros órfãos do sistema inteiro. Não dá para desfazer. Continuar?",
    cleanup_orphans_done: "Limpou: {m} mensagens, {i} problemas, {t} tarefas, {f} arquivos",
    new_job_group_chat: "Novo Grupo de Trabalho",
    start_conversation: "Iniciar conversa",
    edit_user: "Editar usuário",
    no_crew: "Sem equipe",
    new_password_optional: "Nova senha (opcional)",
    keep_current_password: "Deixe vazio para manter a atual",
    delete_user_confirm: "Isso apagará permanentemente este usuário. As mensagens que ele enviou permanecem no histórico. Essa ação não pode ser desfeita.",
    user_deleted: "Usuário apagado",
    download_source_zip: "Baixar código-fonte completo (ZIP)",
    download_source_desc: "Backend + frontend + projetos iOS e Android, prontos para Xcode / Android Studio (node_modules excluído — rode 'yarn install' após descompactar).",
    preparing_zip: "Preparando ZIP...",
    zip_phase_zipping: "Compactando código-fonte",
    zip_phase_downloading: "Baixando",
    zip_files: "arquivos",
    zip_done: "Código-fonte baixado!",
    cleanup_demo_title: "Apagar dados de demonstração",
    font_size_title: "Tamanho da letra",
    font_small: "Pequena",
    font_medium: "Média",
    font_large: "Grande",
    font_preview: "Assim ficarão as suas mensagens.",
    bio_unlock_reason: "Desbloquear o OnSiteComms",
    change_photo: "Alterar foto",
    remove_photo: "Remover foto",
    photo_updated: "Foto atualizada",
    photo_removed: "Foto removida",
    group_photo: "Foto do grupo",
    seed_demo_title: "Criar conta demo (App Review)",
    seed_demo_desc: "Cria/atualiza a conta demo para as equipes de revisão do Google Play e da Apple: johnny.garbim@gmail.com com jobs, conversas, fotos e enquete de exemplo (tudo em inglês). Pode rodar quantas vezes quiser.",
    seed_demo_done: "Conta demo pronta",
    cleanup_demo_desc: "Remove SOMENTE os dados de demonstração: a conta demo do App Review (johnny.garbim@gmail.com, Mike Anderson, Carlos Silva), seus jobs (#10424, #10431), conversas e fotos, além de dados seed antigos. Usuários reais, conversas reais e jobs sincronizados são preservados.",
    cleanup_demo_confirm: "Apagar os dados de demonstração permanentemente?",
    demo_cleaned: "Dados de demonstração apagados",
    job_type_install: "Install",
    job_type_service: "Service/JIP",
    removed_from_matrix: "Removido da matriz",
    job_notes: "Notas",
    tab_active: "Ativos (hoje)",
    tab_past: "Passados",
    tab_future: "Futuros",
    no_jobs_today: "Nenhum trabalho agendado para hoje.",
    filter_teams: "Equipes",
    filter_dates: "Datas",
    clear_filters: "Limpar filtros",
    day_of_days: "Dia {d} de {n}",
    days_count: "{n} dias",
    preset_this_week: "Esta semana",
    preset_this_month: "Este mês",
    preset_last_week: "Semana passada",
    preset_last_month: "Mês passado",
    preset_next_week: "Próxima semana",
    preset_next_month: "Próximo mês",
    devices: "Aparelhos",
    media: "Mídia",
    something_wrong: "Algo deu errado",
    source_code_title: "Código-fonte para Xcode / Android Studio",
    source_code_info: "Os projetos nativos (ios/ e android/) estão dentro do código-fonte do app. Para compilar no Xcode/Android Studio:",
    source_step_1: "Na Emergent: use 'Save to GitHub' (ou Download do código) no menu do projeto para obter o código completo",
    source_step_2: "No seu computador: cd frontend, rode 'yarn install' e 'yarn cap:sync'",
    source_step_3: "Abra com 'yarn cap:ios' (Xcode) ou 'yarn cap:android' (Android Studio) — veja o CAPACITOR_GUIA.md",
    crew_leader: "Líder de Equipe",
    home: "Início",
    jobs: "Jobs",
    messages: "Mensagens",
    issues: "Problemas",
    tasks: "Tarefas",
    photos: "Fotos",
    today: "HOJE",
    open_issues: "Problemas Abertos",
    active_jobs: "Jobs Ativos",
    unread_conversations: "Conversas Não Lidas",
    new_field_photos: "Fotos Novas de Campo",
    completed_jobs: "Jobs Concluídos",
    open_tasks: "Minhas Tarefas Abertas",
    recent_activity: "Recente",
    my_jobs: "Meus Trabalhos",
    all_jobs: "Todos os Jobs",
    scheduled: "Agendado",
    active: "Ativo",
    completed: "Concluído",
    crew: "Equipe",
    job_chat: "Chat do Job",
    crew_chat: "Chat da Equipe",
    direct: "Direto",
    chat: "Chat",
    decisions: "Decisões",
    documents: "Documentos",
    info: "Info",
    report_issue: "Reportar Problema",
    complete_job: "Concluir Job",
    job_completed: "Job concluído",
    type_message: "Mensagem",
    draft: "Rascunho",
    waiting_conn: "aguardando conexão",
    offline_queue_title: "Fila de envio",
    retry_now: "Tentar agora",
    queue_empty: "Nada aguardando envio",
    poll: "Enquete",
    create_poll: "Criar Enquete",
    poll_question: "Pergunta",
    poll_question_ph: "Pergunte algo...",
    poll_options: "Opções",
    add_option: "Adicionar opção",
    option: "Opção",
    poll_multi: "Múltiplas respostas",
    poll_anonymous: "Votos anônimos",
    votes: "votos",
    vote_one: "voto",
    no_votes_yet: "Nenhum voto ainda",
    job_day_summaries: "Resumos dos dias",
    daily_summary: "Resumo Diário",
    summary_hint: "Resumo IA por job — gerado automaticamente às 6h e às 18h, ou sob demanda.",
    summary_generate: "Gerar agora",
    summary_generating: "Gerando...",
    summary_refresh: "Atualizar",
    summary_empty: "Nenhum resumo para este dia ainda.",
    summary_empty_home: "Ainda sem resumo de hoje — toque para abrir e gerar.",
    summary_none_activity: "Nenhuma atividade de chat de jobs encontrada neste dia.",
    summary_recheck: "Verificar novamente",
    issues_opened_label: "abertas",
    issues_resolved_label: "resolvidas",
    drop_media_here: "Solte para enviar",
    drop_media_sub: "Fotos abrem o editor · Vídeos abrem o player de revisão",
    drop_unsupported: "Somente fotos e vídeos podem ser soltos aqui",
    send: "Enviar",
    photo: "Foto",
    voice: "Voz",
    document: "Documento",
    issue: "Problema",
    question: "Pergunta",
    measurement: "Medida",
    material_request: "Pedido de Material",
    task: "Tarefa",
    priority: "Prioridade",
    high: "Alta",
    medium: "Média",
    low: "Baixa",
    status_open: "Aberto",
    status_reviewing: "Em Análise",
    status_action_required: "Ação Necessária",
    status_resolved: "Resolvido",
    location: "Local",
    description: "Descrição",
    title: "Título",
    cancel: "Cancelar",
    save: "Salvar",
    create: "Criar",
    before: "Antes",
    during: "Durante",
    issue_cat: "Problema",
    correction: "Correção",
    after: "Depois",
    all: "Todas",
    category: "Categoria",
    caption: "Legenda",
    markup: "Marcação",
    edit_photo: "Editar Foto",
    original: "Original",
    versions: "Versões",
    compare: "Comparar",
    compare_select: "Selecione a segunda foto",
    sync_zoom: "Zoom sincronizado",
    reply_to_area: "Responder à Área",
    reply_area_hint: "Arraste sobre a foto para destacar a área",
    create_task: "Criar Tarefa",
    task_area_hint: "Arraste sobre a foto para marcar a área da tarefa",
    assign_to: "Atribuir a",
    due: "Prazo",
    due_placeholder: "ex: Antes de concluir o job",
    mark_decision: "Marcar como Decisão",
    unmark_decision: "Desmarcar Decisão",
    decision: "DECISÃO",
    hold_to_record: "Segure para gravar",
    recording: "Gravando...",
    transcribing: "Transcrevendo...",
    transcript: "Transcrição",
    complete_with_photo: "Concluir com Foto",
    completion_photo: "Foto de conclusão",
    mark_complete: "Concluir",
    open_job_hub: "Abrir Central do Job",
    view_thread: "Ver Conversa",
    no_messages: "Nenhuma mensagem ainda. Comece a conversa.",
    search_no_results: "Nenhum resultado",
    search_convs_msgs: "Buscar conversas e mensagens...",
    adjust_photo: "Ajustar foto",
    crop_hint: "Arraste para posicionar a foto dentro do círculo · use o controle para dar zoom",
    use_photo: "Usar foto",
    wallpaper_title: "Papel de parede do chat",
    wallpaper_choose: "Escolher foto",
    wallpaper_default: "Padrão",
    wallpaper_custom: "Foto personalizada",
    wallpaper_updated: "Papel de parede atualizado",
    wallpaper_reset: "Papel de parede padrão restaurado",
    schedule_message: "Agendar mensagem",
    // Pergunte ao Job (IA)
    ask_job_tab: "Perguntar (IA)",
    ask_job_title: "Pergunte ao Job",
    ask_job_hint: "Pergunte qualquer coisa sobre este job — a IA responde usando as mensagens, áudios e fotos deste job.",
    ask_job_placeholder: "ex.: O que decidimos sobre a instalação?",
    ask_job_sources: "Fontes",
    ask_job_error: "IA indisponível no momento. Tente de novo.",
    ask_job_thinking: "Pensando...",
    ask_job_send: "Perguntar",
    // Respostas rápidas (⚡)
    quick_replies: "Respostas rápidas",
    quick_replies_empty: "Nenhuma frase configurada ainda.",
    quick_replies_admin_hint: "O admin gerencia essas frases no painel Admin.",
    quick_replies_user_hint: "Crie as suas em Mais → Frases rápidas.",
    phrases_row: "Frases rápidas",
    phrases_desc: "Suas frases pessoais aparecem no botão ⚡ dos chats — só para você. As frases da empresa (definidas pelo Admin) aparecem para todos da empresa.",
    phrase_company_badge: "Empresa",
    quick_replies_tab: "Frases",
    quick_reply_add: "Adicionar frase",
    quick_reply_placeholder: "ex.: Estou a caminho",
    quick_reply_added: "Frase adicionada",
    quick_reply_deleted: "Frase removida",
    quick_reply_saved: "Frase atualizada",
    app_manual: "Manual do app",
    buddy_manual: "Manual do Buddy & Intérprete",
    // Carimbo na foto
    photo_stamp: "Carimbar data + job na foto",
    photo_stamp_short: "Carimbo",
    // Aviso com Entendi (confirmação obrigatória)
    require_ack: "Exigir confirmação",
    require_ack_hint: "Cada pessoa precisa tocar em \"Entendi\" — você verá quem confirmou.",
    ack_button: "Entendi",
    ack_confirmed: "Confirmado",
    ack_waiting: "Aguardando confirmação",
    ack_see_confirmations: "Ver confirmações",
    ack_dialog_title: "Confirmações",
    ack_pending: "Pendente",
    ack_all_confirmed: "Todos confirmaram",
    // O que perdi (resumo IA)
    catchup_chip: "O que perdi?",
    catchup_title: "O que perdi?",
    catchup_recent: "Você está em dia — resumo da conversa recente:",
    catchup_missed: "{n} mensagens enquanto você esteve fora:",
    catchup_error: "IA indisponível no momento. Tente de novo.",
    catchup_empty: "Nada para resumir ainda.",
    // Escalonamento urgente
    urgent_menu: "Mensagem urgente",
    urgent_armed: "Mensagem urgente — reavisa a cada 1 min até ser lida (até 10x)",
    urgent_badge: "URGENTE",
    urgent_unseen: "Não visualizada — lembretes esgotados",
    broadcast_urgent: "Urgente",
    broadcast_urgent_hint: "Reavisa cada pessoa a cada 1 min (até 10x). Se continuar sem ler, você é avisado.",
    schedule_needs_text: "Escreva a mensagem primeiro, depois agende",
    schedule_when: "Enviar em",
    schedule_confirm: "Agendar",
    schedule_future: "Escolha um horário no futuro",
    scheduled_success: "Mensagem agendada",
    scheduled_canceled: "Agendamento cancelado",
    scheduled_chip: "{n} agendada(s)",
    scheduled_list_title: "Mensagens agendadas",
    edit_message: "Editar",
    editing_message: "Editando mensagem",
    edited_label: "editada",
    broadcast_title: "Aviso",
    broadcast_message_ph: "Mensagem do aviso...",
    broadcast_hint: "Cada pessoa recebe como uma mensagem direta normal — nenhum grupo é criado.",
    broadcast_send: "Enviar aviso",
    broadcast_sent: "Aviso enviado para {n} pessoas",
    conv_wallpaper_title: "Papel de parede desta conversa",
    supervisors_section: "Supervisores",
    installers_section: "Instaladores",
    job_groups: "Grupos Trabalhos",
    group: "Grupo",
    new_group: "Novo grupo",
    group_name: "Nome do grupo",
    create_group: "Criar grupo",
    members: "membros",
    conversations: "Conversas",
    new_conversation: "Nova conversa",
    direct_message: "Mensagem direta",
    job_group: "Grupo do trabalho",
    no_conversations: "Nenhuma conversa sobre este trabalho ainda.",
    linked_msgs: "mensagens vinculadas",
    select_people: "Selecionar pessoas",
    talk_about_job: "Tudo o que você falar aqui será vinculado a este trabalho.",
    view_in_chat: "Ver na conversa",
    resolve_issue: "Clique para resolver",
    reopen_issue: "Reabrir",
    edit: "Editar",
    delete: "Excluir",
    deleted: "Excluído",
    saved: "Salvo",
    delete_confirm_q: "Excluir permanentemente?",
    delete_group_conv_confirm: "O grupo e TODAS as suas mensagens serão apagados permanentemente para todos. Isso não pode ser desfeito.",
    delete_photo_confirm: "A foto será apagada permanentemente para todos.",
    delete_file_confirm: "O arquivo será apagado permanentemente para todos.",
    delete_comm_msg_confirm: "A mensagem será apagada permanentemente para todos.",
    delete_dm_links_confirm: "Todas as {n} mensagens desta conversa vinculadas a este trabalho serão apagadas permanentemente para todos. O restante da conversa privada não é afetado.",
    delete_contact_confirm: "O contato será removido da sua lista e não aparecerá em mais nenhum lugar. Para vê-lo novamente, vocês precisam se conectar de novo (QR/código).",
    delete_contact_has_conv: "Vocês têm uma conversa ativa — ela também será apagada para você.",
    priority_high: "Alta",
    priority_medium: "Média",
    priority_low: "Baixa",
    add_member: "Adicionar membro",
    remove_member: "Remover membro",
    change_photo: "Alterar foto",
    group_updated: "Grupo atualizado",
    global_search: "Busca",
    search_ph: "Buscar mensagens, fotos, issues, tarefas...",
    no_results: "Nenhum resultado encontrado",
    search_min_hint: "Digite pelo menos 2 caracteres para buscar",
    reply: "Responder",
    replying_to: "Respondendo a",
    add_photo_video: "Adicionar foto/vídeo",
    mention_someone: "Mencionar alguém",
    mentioned_you: "mencionou você",
    you_were_mentioned: "Você foi mencionado",
    share: "Compartilhar",
    share_unavailable: "Compartilhamento não disponível neste dispositivo",
    copy_link: "Copiar link",
    link_copied: "Link copiado",
    save_image: "Salvar imagem",
    save_file: "Salvar arquivo",
    save_all_files: "Salvar todos os arquivos ({n})",
    seen_by: "Visto por",
    not_seen_yet: "ainda não viu",
    mentions: "Menções",
    no_mentions: "Nenhuma menção ainda",
    new: "Nova",
    pdf_failed: "Não foi possível carregar o PDF",
    loading: "Carregando",
    video: "Vídeo",
    save_to_job_files: "Salvar PDF nos Arquivos",
    saved_to_files: "Salvo nos Arquivos do trabalho",
    dictate: "Ditar",
    stop: "Parar",
    no_speech_detected: "Nenhuma fala detectada",
    mic_denied: "Acesso ao microfone negado",
    add_text_hint: "Toque para adicionar texto. Arraste um texto para movê-lo.",
    resolve_issue_title: "Resolver Problema",
    resolution_note_ph: "Descreva o que foi feito para resolver...",
    add_photo: "Adicionar foto",
    issue_resolved_q: "Problema resolvido?",
    yes_mark_resolved: "Sim, marcar como resolvido",
    no_keep_open: "Não, manter em aberto",
    contact_info: "Dados do contato",
    group_info: "Dados do grupo",
    shared_media: "Mídias compartilhadas",
    no_media: "Nenhuma mídia compartilhada ainda",
    language_label: "Idioma",
    offline_banner: "Sem conexão — as mensagens serão enviadas automaticamente quando a internet voltar.",
    queued_offline: "Salvo — será enviado quando a conexão voltar",
    msg_pending: "Aguardando conexão",
    msg_sending: "Enviando...",
    msg_failed: "Falha ao enviar",
    retry: "Tentar novamente",
    discard: "Descartar",
    queue_full: "Armazenamento offline cheio — não foi possível salvar esta foto",
    in_queue: "na fila",
    no_photos: "Nenhuma foto nesta categoria ainda.",
    no_issues: "Nenhum problema. Campo limpo.",
    no_tasks: "Nenhuma tarefa ainda.",
    no_decisions: "Nenhuma decisão registrada ainda.",
    no_documents: "Nenhum documento ainda.",
    items: "Itens",
    needed_by: "Necessário até",
    value: "Valor",
    note: "Observação",
    supervisor_label: "Supervisor",
    address: "Endereço",
    no_account_yet: "Ainda não tem conta?",
    listen_before_send: "Ouvir antes de enviar",
    preset_next_7_days: "Próximos 7 dias",
    all_people: "Todas as pessoas",
    download: "Baixar",
    chats_tab: "Conversas",
    delete_account: "Apagar minha conta",
    delete_account_desc: "Apaga permanentemente sua conta, credenciais de acesso e notificações, e remove você de todas as conversas. Não pode ser desfeito.",
    delete_account_confirm_title: "Apagar sua conta?",
    delete_account_confirm_text: "Isso é permanente. Sua conta, passkeys e notificações serão removidos e você será desconectado imediatamente.",
    account_deleted: "Conta apagada",
    delete_account_failed: "Não foi possível apagar a conta",
    already_have_account: "Já tem conta?",
    forgot_password: "Esqueci minha senha",
    forgot_password_title: "Redefinir sua senha",
    forgot_password_sub: "Digite o e-mail da sua conta e enviaremos um código de 6 dígitos.",
    send_code: "Enviar código",
    code_sent: "Se este e-mail estiver cadastrado, um código foi enviado. Verifique sua caixa de entrada.",
    enter_code_title: "Digite o código",
    enter_code_sub: "Enviamos um código de 6 dígitos para seu e-mail. Ele expira em 30 minutos.",
    verify_code: "Verificar código",
    resend_code: "Reenviar código",
    resend_in: "Reenviar em",
    new_password_title: "Crie uma nova senha",
    new_password_sub: "Código confirmado. Escolha uma nova senha (mínimo 6 caracteres).",
    save_new_password: "Salvar nova senha",
    password_reset_success: "Senha atualizada! Entre com sua nova senha.",
    invalid_code: "Código incorreto. Tente novamente.",
    code_expired: "Este código expirou. Solicite um novo.",
    too_many_attempts: "Muitas tentativas. Solicite um novo código.",
    no_reset_request: "Nenhuma solicitação ativa. Solicite um novo código.",
    email_send_failed: "Não foi possível enviar o e-mail. Tente novamente em instantes.",
    back_to_login: "Voltar para o login",
    sign_in_with_faceid: "Entrar com FaceID / Passkey",
    crop_failed: "Não foi possível recortar a imagem. Tente novamente.",
    mute_notifications: "Silenciar notificações",
    unmute_notifications: "Reativar notificações",
    muted_on_toast: "Silenciada — você continua recebendo, sem som. Jobs do dia continuam tocando.",
    muted_off_toast: "Notificações reativadas.",
    mute_job_exception_hint: "Exceção de obra: nos dias em que esta conversa tiver job agendado, o supervisor e os instaladores continuam recebendo com som.",
    passkey_prompt_title: "Ativar FaceID / Passkey?",
    passkey_prompt_text: "Entre com um toque — seguro e sem digitar senha. Você também pode ativar depois no Perfil.",
    passkey_prompt_enable: "Ativar FaceID",
    passkey_prompt_later: "Agora não",
    app_lock_title: "Exigir FaceID / login",
    app_lock_on_desc: "Quando ativado, você fará login (FaceID/Passkey ou senha) sempre que reabrir o app ou a aba do navegador.",
    app_lock_off_desc: "Acesso direto — você continua conectado ao reabrir o app ou a aba do navegador.",
    app_lock_enabled: "Bloqueio ativado — login será pedido ao reabrir.",
    app_lock_disabled: "Acesso direto ativado — você continuará conectado.",
    forgot_current_password: "Não lembra sua senha atual? Receber código por e-mail",
    code_sent_to: "Código enviado para",
    email_code_label: "Código de 6 dígitos do e-mail",
    use_current_password: "Usar a senha atual",
    tour_welcome_title: "Bem-vindo ao OnSiteComms!",
    tour_welcome_text: "Toda a comunicação da obra em um só lugar — mensagens, fotos, áudios e jobs.",
    tour_chat_title: "Chat com tradução automática",
    tour_chat_text: "Escreva no seu idioma — a equipe lê no idioma dela. Português e inglês, traduzidos automaticamente.",
    tour_media_title: "Voz, fotos e marcação",
    tour_media_text: "Segure o microfone para gravar (deslize para cima para travar). Tire fotos e desenhe nelas para mostrar exatamente o que precisa.",
    tour_jobs_title: "Tudo ligado aos Jobs",
    tour_jobs_text: "Cada conversa conecta a um job: endereço com navegação, clima, arquivos e tarefas — tudo em um toque.",
    tour_notif_title: "Não perca nenhuma mensagem",
    tour_notif_text: "Receba alertas de novas mensagens e menções. Gerencie as notificações em Mais → Configurações.",
    tour_next: "Próximo",
    tour_start: "Começar",
    tour_skip: "Pular tour",
    tour_row: "Tour do app",
    open_in_maps: "Abrir no app de navegação",
    customer: "Cliente",
    schedule: "Agenda",
    units: "Unidades",
    switch_profile: "Trocar Perfil",
    language: "Idioma",
    sending: "Enviando...",
    uploading: "Enviando...",
    send_photo: "Enviar Foto",
    send_photos_n: "Enviar {n} fotos",
    tomorrow: "Amanhã",
    yesterday: "Ontem",
    assigned_to: "Atribuído a",
    created_by: "Criado por",
    photo_timeline: "Linha do Tempo de Fotos",
    tap_status: "Toque para mudar o status",
    upload_doc: "Enviar Documento",
    voice_message: "Mensagem de voz",
    area_highlighted: "Área destacada",
    from_photo: "Da foto",
    quick_actions: "Ações Rápidas",
    view_all: "Ver todos",
    in_progress: "Em andamento",
    done: "Concluída",
    search_jobs: "Buscar job # ou cliente",
    min_away: "min de distância",
    contacts: "Contatos",
    new_chat: "Nova Conversa",
    search_contacts: "Buscar contatos",
    link_to_job: "Vincular a Job",
    relink_to_job: "Vincular a outro job",
    unlink_from_job: "Desvincular do job",
    unlink_selected: "Desvincular",
    unlinked_from_job: "mensagem(ns) desvinculada(s)",
    linked_to: "Vinculado a",
    linked_messages: "Conversas Vinculadas",
    select_job: "Selecionar Job",
    no_linked: "Nenhuma mensagem vinculada ainda. Use 'Vincular a Job' em qualquer conversa para conectar uma mensagem a este job.",
    open_conversation: "Abrir conversa",
    activity: "Atividade",
    more: "Mais",
    people: "Pessoas",
    working_on: "Trabalhando em",
    link_msgs_prompt: "Vincular mensagens a",
    yes: "Sim",
    no: "Não",
    back: "Voltar",
    measure_photo_hint: "Achou uma janela ou porta com medida errada? Tire uma foto — a IA marca a abertura e as medidas entram na foto.",
    measure_take_photo: "Tire a foto da janela/porta",
    measure_analyzing: "IA analisando a foto...",
    measure_found_window: "Janela identificada — largura e altura marcadas",
    measure_found_door: "Porta identificada — largura e altura marcadas",
    measure_not_found: "Não consegui identificar a abertura — as setas vão usar a foto inteira",
    measure_retake: "Refazer",
    measure_job_q_window: "Esta janela é do trabalho",
    measure_job_q_door: "Esta porta é do trabalho",
    measure_loading_pdf: "Lendo o PDF do trabalho...",
    measure_no_pdf: "Este trabalho não tem PDF — informe as medidas manualmente",
    measure_pick_location: "Qual é ela, segundo o PDF?",
    measure_other_location: "Não está na lista / outro local",
    measure_window: "Janela",
    measure_door: "Porta",
    measure_expected: "Esperado (PDF)",
    measure_real_w: "Largura medida",
    measure_shape: "Formato da janela",
    optional: "opcional",
    side_left: "Esquerda",
    side_right: "Direita",
    measure_dim_w: "Largura",
    measure_dim_h: "Altura",
    measure_dim_leg: "Altura da perna",
    measure_dim_top: "Largura do topo",
    measure_dim_legL: "Perna esquerda",
    measure_dim_legR: "Perna direita",
    measure_dim_d: "Diâmetro",
    measure_dim_side: "Lado",
    shape_rectangle: "Retângulo",
    shape_half_circle: "Meia-lua",
    shape_quarter_circle: "Quarto de círculo",
    shape_eyebrow: "Eyebrow",
    shape_springline: "Springline",
    shape_elliptical: "Elíptica",
    shape_equal_leg_triangle: "Equal Legs",
    shape_right_triangle: "Triângulo reto",
    shape_trapezoid: "Trapézio",
    shape_pentagon: "Pentágono",
    shape_octagon: "Octógono",
    shape_circle: "Círculo",
    shape_oval: "Oval",
    measure_door_config: "Configuração da porta",
    shape_door: "Só a porta",
    shape_door_sl1: "1 sidelight",
    shape_door_sl2: "2 sidelights",
    shape_door_tr: "Transom",
    shape_door_tr_sl1: "Transom + 1 sidelight",
    shape_door_tr_sl2: "Transom + 2 sidelights",
    measure_dim_sl: "Largura do sidelight",
    measure_dim_slL: "Sidelight esquerdo",
    measure_dim_slR: "Sidelight direito",
    measure_dim_tr: "Altura do transom",
    measure_dim_trL: "Transom esquerdo",
    measure_dim_trR: "Transom direito",
    measure_dim_trS: "Transom do sidelight",
    measure_dim_w_total: "Largura total (unidade inteira)",
    measure_dim_h_total: "Altura total (unidade inteira)",
    shape_door_tr2_sl1: "1 sidelight + 2 transoms",
    shape_door_tr3_sl2: "2 sidelights + 3 transoms",
    measure_real_h: "Altura medida",
    measure_match: "Confere com o PDF",
    measure_match_short: "OK",
    measure_mismatch: "Medida ERRADA",
    force_update_title: "Atualização necessária",
    force_update_body: "Uma nova versão do OnSiteComms está disponível. Atualize para continuar usando o app.",
    force_update_cta: "Atualizar agora",
    force_update_installed: "Instalada",
    force_update_required: "Mínima",
    force_update_title_admin: "Atualização Obrigatória",
    force_update_help: "Bloqueia apps com versão MENOR que a mínima. O usuário vê a imagem e é levado à loja. Ao atualizar, o app libera sozinho. Web e Master nunca são bloqueados.",
    force_update_active: "BLOQUEIO ATIVO",
    force_update_min_ios: "Versão mínima iOS",
    force_update_min_android: "Versão mínima Android",
    force_update_min_hint: "Deixe vazio para não bloquear aquela plataforma. Ex: Apple aprovou a 1.35 → digite 1.35 no campo iOS.",
    force_update_image: "Imagem da tela de bloqueio",
    force_update_image_add: "Adicionar imagem",
    force_update_image_big: "Imagem muito grande (máx. 2MB)",
    force_update_ios_url: "Link App Store",
    force_update_android_url: "Link Play Store",
    force_update_save_on: "Salvar e ATIVAR",
    force_update_saved_on: "Atualização obrigatória ATIVA",
    force_update_saved_off: "Salvo (bloqueio desligado)",
    force_update_need_min: "Informe pelo menos uma versão mínima",
    force_update_preview_close: "Toque em qualquer lugar para fechar a prévia",
    preview: "Prévia",
    change: "Trocar",
    remove: "Remover",
    measure_shape_diverges: "O PDF indica esta abertura como {pdf}, mas você selecionou {chosen}. Confira a janela no local antes de reportar.",
    measure_pdf_shape: "Formato no PDF",
    measure_shape_wrong: "Formato ERRADO (diferente do PDF)",
    measure_preview_btn: "Gerar foto anotada",
    measure_preview_hint: "Confira a foto anotada antes de enviar para a equipe.",
    buddy_measure_photo_attached: "Foto anexada.",
    buddy_measure_save_native_only: "Salvar no celular funciona no aplicativo.",
    buddy_measure_title: "Medindo",
    buddy_measure_saved: "Medição salva",
    buddy_measure_empty: "Diga ao Buddy o local, o tipo e a medida da primeira janela.",
    buddy_measure_open_notes: "Abrir Minhas Anotações",
    buddy_measure_finish: "Concluir e salvar",
    buddy_measure_cancelled: "Sessão de medição cancelada.",
    buddy_measure_saved_msg: "Relatório salvo em Minhas Anotações. Quer que eu mande para alguém?",
    buddy_trim_title: "Acabamentos", buddy_trim_saved: "Acabamentos salvos", buddy_trim_empty: "Fale o tipo de acabamento e as medidas, ex.: \"brickmold, topo 36, base 36, direita 60, esquerda 60\".",
    buddy_trim_missing: "Falta", buddy_trim_cancelled: "Anotação de acabamentos cancelada.", buddy_trim_saved_msg: "Tabela de acabamentos salva em Minhas Anotações. Quer que eu mande para alguém?",
    buddy_trim_send: "Enviar acabamentos", trim_report: "Acabamentos", trim_side_right: "Lateral direita", trim_side_left: "Lateral esquerda", trim_side_top: "Topo", trim_side_base: "Base",
    trim_no_base: "Sem base", trim_thick_short: "esp.", trim_inside: "Medida entrando", trim_face: "Medida da cara", trim_reforco: "Reforço (brick)",
    trim_field_right: "lateral direita", trim_field_left: "lateral esquerda", trim_field_top: "topo", trim_field_base: "base", trim_field_base_type: "tipo da base",
    trim_field_right_thick: "espessura direita", trim_field_left_thick: "espessura esquerda", trim_field_top_thick: "espessura do topo", trim_field_base_thick: "espessura da base",
    trim_field_inside: "medida entrando", trim_field_face: "medida da cara", trim_field_finish: "siding ou reforço", trim_field_siding: "medida do siding",
    buddy_measure_send: "Enviar medidas",
    measure_dictate_hint: "Dite: \"quarenta e quatro três quartos por vinte e um e meio\"",
    measure_save_phone: "Salvar a foto original no celular",
    measure_picker_fallback: "Abrindo o seletor de fotos…",
    measure_edit_title: "Editar medida",
    measure_edit: "Editar medida",
    measure_save_edit: "Salvar alterações",
    measure_edit_expired: "Medidas só podem ser editadas até 2 horas após o envio.",
    measure_sent: "Medida enviada!",
    measure_more_q: "Tem mais alguma janela com medida errada?",
    measure_more_yes: "Sim, próxima",
    measure_finish_send: "Concluído — enviar medidas",
    measure_close_confirm: "Você tem {n} medida(s) ainda não enviada(s). Fechar e perder tudo?",
    measure_shape_live_hint: "O desenho acompanha suas medidas (perna ÷ altura)",
    measure_more_no: "Não, terminar",
    measure_take_photo_cam: "Tirar foto (câmera)",
    measure_from_gallery: "Da galeria",
    measure_job_no_other: "Não, é de outro trabalho",
    measure_pick_job: "De qual trabalho é esta medida?",
    measure_search_job: "Buscar nº do trabalho ou cliente...",
    measure_no_job_manual: "Sem trabalho / informar manualmente",
    measure_add_btn: "Adicionar ao relatório",
    measure_added: "Adicionada",
    measure_in_report: "no relatório",
    measure_send_all: "Enviar",
    measure_catalog: "Catálogo de medidas",
    measure_wrong_count: "erradas",
    measure_multi_window_q: "Várias janelas em 1 opening?",
    measure_door_transom_q: "Porta com janela em cima?",
    measure_door_sidelites_q: "Janelas ao lado da porta?",
    measure_door_combo_q: "Porta com janelas em volta?",
    measure_adjust_single: "Confira a marcação — ajuste a caixa se precisar",
    measure_adjust_hint: "Arraste a caixa para mover · cantos para redimensionar · alça de cima para girar (foto de ângulo)",
    measure_units_found: "unidades marcadas",
    measure_add_box: "Adicionar caixa",
    measure_remove_box: "Apagar caixa",
    measure_draw_hint: "Não identifiquei a abertura — adicione a caixa manualmente",
    measure_need_box: "Adicione pelo menos 1 caixa",
    measure_continue: "Continuar",
    measure_piece: "Peça",
    measure_of: "de",
    measure_next_piece: "Próxima peça",
    measure_overall_q: "Quer adicionar a medida total do opening?",
    measure_overall_w: "Largura total",
    measure_overall_h: "Altura total",
    measure_skip: "Pular",
    measure_sketch_flag: "Desenho",
    measure_sketch_hint: "Também funciona com foto de um desenho à mão com várias janelas",
    measure_units_short: "peças",
    measure_used: "usada",
    measure_win_type: "Tipo de janela (opcional):",
    measure_door_type: "Tipo de porta (opcional):",
    measure_type_none: "Não especificar",
    measure_pick_unit_edit: "Qual unidade você quer editar?",
    measure_extra_photos: "Fotos extras desta abertura",
    measure_extra_add_later: "Adicionar fotos",
    add: "Adicionar",
    measure_unit_type: "Tipo (janela ou porta):",
    measure_windows: "Janelas",
    measure_doors: "Portas",
    not_now: "Agora não",
    end_job_topic: "Encerrar Tópico do Job",
    job_topic_active: "Novas mensagens serão vinculadas a este job",
    private: "Privado",
    shared: "Compartilhado",
    share_with_job: "Compartilhar com o Job",
    select_messages: "Selecionar mensagens",
    selected: "selecionadas",
    link_selected: "Vincular ao Job",
    overview: "Visão Geral",
    communication: "Comunicação",
    files: "Arquivos",
    open_job_chat: "Abrir Chat do Job",
    shared_jobs: "Jobs em Comum",
    search_in_conversation: "Buscar na conversa...",
    filtering_by: "Filtrando por",
    unread: "Não lidas",
    settings: "Configurações",
    create_issue: "Criar Problema",
    change_category: "Categoria",
    msgs: "mensagens",
    no_activity: "Nenhuma atividade ainda.",
    crews: "Equipes",
    reported_by: "Reportado por",
    from_message: "Da mensagem",
    translated: "Traduzido",
    see_original: "Ver original",
    show_translation: "Ver tradução",
    notifications: "Notificações",
    enable_notifications: "Ativar notificações",
    notifications_enabled: "Notificações ativadas",
    notifications_blocked: "Bloqueado pelo navegador",
    leader: "Líder",
    fi_issues_title: "Problemas abertos",
    fi_tasks_title: "Tarefas para você",
    fi_alerts_title: "Alertas do campo",
    fi_complete: "Concluir",
    fi_task_done: "Tarefa concluída!",
    fi_by: "por",
    fi_view_chat: "Ver na conversa",
    fi_resolve: "Resolver",
    fi_drag_hint: "Solte no X para dispensar",
    fi_dismissed: "Alertas de problema dispensados",
    fi_now: "agora",
    buddy_tagline: "Seu ajudante de campo",
    interp_open_btn: "Modo cliente (intérprete)",
    interp_title: "Intérprete ao Vivo",
    interp_subtitle: "O Buddy traduz entre você e o cliente",
    interp_preparing: "O Buddy está se preparando: empresa, equipe e o trabalho de hoje...",
    interp_starting: "Preparando a apresentação...",
    interp_listening: "Ouvindo — pode falar",
    interp_recording: "Escutando...",
    interp_thinking: "Traduzindo...",
    interp_speaking: "Buddy está falando...",
    interp_paused: "Microfone pausado",
    interp_reintro: "Reapresentar",
    interp_pause: "Pausar",
    interp_resume: "Retomar",
    interp_end: "Encerrar",
    interp_installer: "Você",
    interp_customer: "Cliente",
    interp_intro_label: "Apresentação",
    interp_exit_label: "Encerramento",
    interp_customer: "Cliente",
    interp_turns: "falas",
    interp_from_customer: "do cliente",
    interp_talks_hint: "Tudo o que foi dito pelo Intérprete ao Vivo do Buddy neste trabalho — o que o cliente falou e o que a equipe disse a ele.",
    interp_talks_empty: "Nenhuma conversa com o cliente registrada neste trabalho ainda.",
    job_tab_customer: "Cliente",
    interp_no_job: "Sem trabalho de hoje vinculado — esta conversa não será salva no trabalho.",
    interp_learned: "Aprendi! Salvo para a empresa toda",
    interp_start_failed: "Não consegui iniciar o intérprete. Tente de novo.",
    interp_turn_failed: "Não peguei essa — repete, por favor.",
    interp_hint: "O Buddy detecta quem falou pelo idioma. Diga \"Buddy...\" para ensinar termos, reapresentar ou encerrar.",
    interp_admin_title: "Intérprete (modo cliente) & Vocabulário",
    interp_admin_hint: "O Buddy apresenta a equipe ao cliente e interpreta ao vivo. Ensine o vocabulário da empresa aqui (ou por voz) — vale para o intérprete E para a tradução automática do chat.",
    interp_intro_instr_label: "Instruções da apresentação (opcional)",
    interp_intro_instr_ph: "Ex.: sempre mencionar nossa garantia de 20 anos; ser breve; agradecer por nos escolher...",
    interp_intro_saved: "Instruções da apresentação salvas",
    interp_kind_term: "Termo",
    interp_kind_team: "Equipe",
    interp_kind_fact: "Fato",
    interp_know_ph: "Ex.: Manter o termo 'casing' sem tradução — nunca traduzir como 'moldura'",
    interp_know_added: "Salvo — vale para a empresa toda",
    interp_know_empty: "Nada ensinado ainda. Adicione termos aqui ou ensine o Buddy por voz.",
    buddy_global_title: "Conhecimento global (todas as empresas e avulsos)",
    buddy_delete_conv: "Apagar conversa (para mim)",
    buddy_type_ph: "Digite um comando para o Buddy…",
    buddy_mem_title: "O que o Buddy sabe sobre mim",
    buddy_mem_hint: "Tudo que você ensinou ao Buddy por voz ou texto. Edite ou apague quando quiser — fica guardado até segunda ordem.",
    buddy_mem_empty: "Nada ainda. Diga \"Buddy, lembra que…\" e aparece aqui.",
    buddy_mem_add_ph: "Adicionar algo que o Buddy deve lembrar…",
    buddy_mem_deleted: "Memória apagada",
    buddy_mem_saved: "Salvo",
    buddy_rem_title: "Meus lembretes",
    buddy_rem_hint: "Lembretes que o Buddy vai te enviar (horário de Nova York). Edite o texto ou a hora, ou cancele.",
    buddy_rem_empty: "Nenhum lembrete ativo. Diga \"Buddy, me lembra às 15h de…\".",
    buddy_rem_recurring_hint: "Agenda recorrente — para mudar dias/horário, peça ao Buddy por voz.",
    buddy_rem_in_past: "Esse horário já passou",
    buddy_rem_deleted: "Lembrete cancelado",
    bc_title: "Notificação com flyer / imagem",
    bc_hint: "Envie um flyer para quem você escolher. A pessoa recebe o push (com a imagem) e o flyer abre em tela cheia no app com um X para fechar. Vezes = quantas vezes será enviado e exibido.",
    bc_title_ph: "Título da notificação",
    bc_body_ph: "Mensagem curta (opcional)",
    bc_pick_image: "Escolher imagem",
    bc_need_title_or_image: "Coloque um título ou uma imagem",
    bc_sent: "Enviado!",
    bc_pick_company: "Escolha a empresa",
    bc_mode_all: "Todos",
    bc_mode_company: "Empresa inteira",
    bc_mode_company_role: "Empresa + cargo",
    bc_mode_role: "Cargo (todas as empresas)",
    bc_mode_solo: "Contas avulsas (sem empresa)",
    bc_mode_individual: "Pessoas específicas",
    bc_times: "Quantas vezes",
    bc_interval: "Horas entre envios",
    bc_recipients: "destinatários",
    bc_send_now: "Enviar agora",
    bc_history: "Flyers enviados",
    bc_when_now: "Agora",
    bc_when_schedule: "Agendar",
    bc_schedule_btn: "Agendar",
    bc_scheduled: "Agendado!",
    bc_need_datetime: "Escolha data e hora",
    bc_ny_time: "Horário de Nova York",
    bc_scheduled_for: "Agendado para",
    bc_next_send: "Próximo envio",
    buddy_conv_deleted: "Conversa apagada para você",
    buddy_global_hint: "Só o MASTER. Tudo aqui vale para TODAS as empresas e contas avulsas: tradução automática do chat, prévia de push, legendas de foto/vídeo, Intérprete e o próprio Buddy — em cima do conhecimento de cada empresa. Por voz: \"Buddy, ensina pra todo mundo que...\".",
    buddy_global_ph: "Ex.: O termo 'casing' fica sempre em inglês — nunca traduzir",
    buddy_global_added: "Salvo — vale para todo mundo na plataforma",
    buddy_global_empty: "Nenhum conhecimento global ainda.",
    buddy_global_badge: "GLOBAL",
    buddy_enabled_title: "Assistente Buddy",
    buddy_enabled_on: "Ligado — botão flutuante do Buddy e \"Hey Buddy\" disponíveis",
    buddy_enabled_off: "Desligado — Buddy oculto (tradução e transcrição continuam seguindo a configuração de IA)",
    banner_buddy: "Buddy ativo",
    delete_selected_title: "Apagar {n} selecionado(s)?",
    delete_selected_desc: "Esta ação não pode ser desfeita.",
    select_items: "Selecionar",
    media_tab: "Mídia",
    media_one: "item",
    media_many: "itens",
    select_day: "Selecionar todas do dia",
    deselect_day: "Desmarcar o dia",
    take_another: "Outra",
    save_to_gallery: "Salvar na galeria",
    saved_to_gallery_n: "{n} salva(s) na galeria",
    gallery_save_failed: "Não foi possível salvar na galeria",
    new_messages_pill: "{n} novas",
    unread_divider_one: "1 mensagem não lida",
    unread_divider_many: "{n} mensagens não lidas",
    app_update_banner: "Seu app está desatualizado — toque para atualizar",
    live_update_ready: "Nova versão pronta — toque para aplicar",
    live_update_applying: "Aplicando atualização…",
    live_update_checking: "Verificando…",
    live_update_downloading: "Baixando…",
    live_update_check: "Verificar atualização",
    live_update_uptodate: "App já está atualizado",
    live_update_failed: "Falha na atualização",
    live_update_ota: "atualização ao vivo",
    live_update_server: "servidor",
    live_update_builtin: "versão da loja",
    live_update_no_plugin: "plugin de atualização ausente neste build",
    store_versions_title: "Versões nas lojas",
    store_versions_hint: "Lidas automaticamente a cada hora da App Store / Google Play. Usuários com versão mais antiga veem uma barra amarela até atualizar. O campo de override força uma versão caso a consulta à loja falhe.",
    store_versions_refreshed: "Versões das lojas atualizadas",
    store_lookup_failed: "consulta falhou",
    store_override_ph: "override",
    store_checked_at: "Última verificação",
    interp_choose_title: "Em qual parada você está?",
    interp_choose_sub: "Fale o nome do cliente ou a ordem (primeira, segunda...) — ou toque em uma parada abaixo.",
    interp_choose_speak: "Você tem {n} paradas hoje. Em qual você está? Pode falar o nome do cliente ou a ordem — primeira, segunda...",
    interp_choose_retry: "Desculpa, não peguei. Fala o nome do cliente ou a ordem — ou toca em uma parada na tela.",
    interp_choose_status: "Qual parada? Fale ou toque",
    interp_helpers_title: "Quem está com você hoje?",
    interp_helpers_status: "Quem está com você? Fale ou toque",
    interp_helpers_fixed: "Helpers fixos",
    interp_helpers_none_saved: "Nenhum helper fixo salvo ainda — fale os nomes e o Buddy vai lembrar.",
    interp_helpers_alone: "Estou sozinho",
    interp_helpers_only_fixed: "Só os fixos",
    interp_helpers_alone_say: "Estou sozinho hoje",
    interp_helpers_fixed_say: "Só os meus helpers fixos",
    interp_helpers_retry: "Desculpa, não peguei. Me diga quem está com você hoje, ou fale 'sozinho'.",
    interp_ask_helpers_label: "Perguntar quem são os helpers antes da apresentação",
    helpers_fixed_title: "Meus helpers fixos",
    helpers_add: "Adicionar",
    helpers_empty: "Nenhum helper ainda — toque em + ou diga ao Buddy: \"meu helper fixo é o Juca\".",
    helpers_name_ph: "Nome do helper",
    helpers_saved: "Helpers atualizados",
    interp_ask_helpers_user_hint: "Antes de cada apresentação o Buddy pergunta a você quem está junto hoje (fixos / avulsos / sozinho)",
    interp_ask_helpers_hint: "O Buddy pergunta ao instalador, em particular, quem está com ele (fixos / avulsos / sozinho) e só anuncia esses nomes.",
    buddy_know_update: "Editar conhecimento da empresa?",
    buddy_know_delete: "Apagar conhecimento da empresa?",
    buddy_know_updated: "Atualizado — vale para a empresa toda",
    buddy_know_deleted: "Apagado para a empresa toda",
    buddy_intro_draft: "Instruções da apresentação ao cliente",
    buddy_intro_cleared: "(limpar todas as instruções)",
    buddy_intro: 'Oi! Eu sou o Buddy, seu ajudante. Diga "Hey Buddy" e fale naturalmente — eu percebo quando você termina e a conversa continua. Ou segure o microfone. Mensagens, lembretes, tempo, medidas, dúvidas técnicas...',
    slide_to_cancel: "Arraste para cancelar",
    voice_cancelled: "Gravação cancelada",
    message_info: "Dados da mensagem",
    played_by: "Ouvido por",
    seen_by: "Visto por",
    delivered_to: "Entregue para",
    not_delivered_yet: "Ainda não entregue",
    nobody_yet: "Ninguém ainda",
    sent_at: "Enviada",
    voice_invalid: "Não foi possível ler esta gravação — grave novamente",
    voice_empty: "Nada foi gravado — segure o microfone até o cronômetro começar",
    voice_interrupted: "Gravação interrompida — ouça e envie se estiver OK",
    voice_send_failed: "Falha ao enviar o áudio",
    chatter_hint: "Relatório de fim de dia para o Chatter da empresa — feito só com o PDF, o chat de hoje e os problemas do job. Revise antes de postar.",
    chatter_release: "Customer happy - release the Survey",
    chatter_hold: "Hold the Survey",
    chatter_unknown: "Supervisor ainda não confirmou com o cliente - hold the Survey",
    chatter_thumb_up: "Cliente gostou",
    chatter_thumb_down: "Cliente NÃO gostou",
    chatter_sat_hint: "Já ligou para o cliente? Toque para registrar o veredito no relatório.",
    chatter_sat_by: "Marcado por",
    chatter_sat_clear: "Desfazer",
    chatter_copy: "Copiar",
    chatter_copied: "Relatório copiado",
    chatter_saved: "Relatório salvo",
    chatter_regen: "Gerar de novo",
    chatter_generated: "Gerado",
    factory_reset: "Reset de fábrica",
    factory_reset_confirm: "Apaga TUDO que esta conta fez ou configurou — mensagens, conversas diretas, fotos, problemas, tarefas, memórias do Buddy, helpers, lembretes, aparelhos, biometria e preferências. E-mail, senha, função e empresa são mantidos, como se a conta tivesse acabado de ser criada. Não dá para desfazer.",
    factory_reset_done: "Conta restaurada ao estado de fábrica",
    weekly_summary: "Resumo semanal",
    weekly_jobs: "Trabalhos",
    weekly_units: "Unidades",
    weekly_crews: "Equipes",
    weekly_summary_hint: "Resumo da IA dos seus trabalhos da semana (seg–dom)",
    weekly_summary_empty: "Nenhum trabalho ativo seu nesta semana.",
    buddy_hold: "Toque para falar",
    buddy_listening: "Ouvindo...",
    buddy_send_media: "Enviar arquivo",
    buddy_media_sent: "Enviado!",
    buddy_edit_msg: "Editar mensagem",
    buddy_msg_edited: "Mensagem editada.",
    buddy_delete_msg: "Apagar mensagem",
    buddy_msg_deleted: "Mensagem apagada.",
    buddy_issue_status: "Atualizar issue",
    buddy_issue_updated: "Issue atualizado!",
    buddy_task_complete: "Concluir tarefa",
    buddy_task_reopen: "Reabrir tarefa",
    buddy_task_done: "Tarefa concluída!",
    buddy_task_reopened: "Tarefa reaberta.",
    buddy_new_group: "Novo grupo",
    buddy_group_created: "Grupo criado!",
    theme_title: "Tema",
    theme_light: "Claro",
    theme_dark: "Escuro",
    theme_system: "Automático (segue o telefone)",
    search_offline_hint: "Sem conexão — buscando no que está salvo neste telefone",
    settings_sec_account: "Conta e segurança",
    settings_sec_appearance: "Aparência",
    settings_sec_buddy: "Buddy (assistente)",
    settings_sec_data: "Dados e conexão",
    buddy_memories_short: "Tudo que você ensinou ao Buddy — ver, editar, apagar",
    buddy_reminders_short: "Lembretes que o Buddy vai te enviar",
    offline_mode_on_short: "Ligado",
    offline_mode_off_short: "Desligado — somente online",
    offline_setup_title: "Modo offline neste telefone?",
    offline_setup_intro: "Mantenha uma cópia das suas conversas neste telefone para ler tudo mesmo sem sinal. Quando a conexão voltar, tudo sincroniza automaticamente (envio e recebimento).",
    offline_setup_intro_settings: "Escolha quanto guardar neste telefone. Tudo continua salvo no servidor de qualquer forma.",
    offline_history: "Histórico para baixar",
    offline_history_90d: "Últimos 90 dias",
    offline_history_12m: "Últimos 12 meses",
    offline_history_all: "Tudo",
    offline_history_all_hint: "Pode ocupar bastante espaço em contas antigas.",
    offline_photos: "Fotos",
    offline_photos_thumb: "Só miniaturas",
    offline_photos_thumb_hint: "Leve. A foto em tamanho cheio carrega quando houver sinal.",
    offline_photos_full: "Fotos em tamanho cheio",
    offline_photos_full_hint: "Ocupa mais espaço no telefone.",
    offline_voice_note: "Mensagens de voz ficam sempre offline (são pequenas).",
    offline_enable_btn: "Sim, baixar e manter sincronizado",
    offline_online_only_btn: "Não, somente online",
    offline_downloading: "Baixando suas conversas…",
    offline_downloading_hint: "Pode continuar usando o app — segue em segundo plano.",
    offline_mode: "Modo offline neste aparelho",
    offline_mode_on_hint: "As conversas ficam espelhadas neste telefone e sincronizam automaticamente.",
    offline_mode_off_hint: "Somente online — nada fica guardado neste aparelho.",
    offline_media_files: "mídias",
    offline_device_free: "livre no aparelho",
    offline_sync_now: "Sincronizar agora",
    offline_change_options: "Opções",
    offline_manage: "Liberar espaço",
    offline_manage_title: "Armazenamento offline",
    offline_clear_media_30: "Apagar mídias com mais de 30 dias",
    offline_clear_media_all: "Apagar todas as mídias offline",
    offline_clear_conv_title: "Apagar uma conversa deste telefone",
    offline_clear: "Apagar",
    offline_disabled_toast: "Modo offline desligado — dados removidos deste aparelho.",
    offline_full_title: "Memória do telefone cheia",
    offline_full_body: "Não há mais espaço para manter suas conversas offline. Libere espaço (apague mídias ou conversas deste telefone) ou passe para o modo somente online.",
    offline_full_manage_btn: "Liberar espaço e continuar offline",
    offline_full_short: "Memória cheia — libere espaço para continuar.",
    offline_banner_mode: "Sem conexão — modo offline: mostrando o que está salvo neste telefone.",
    offline_syncing: "Sincronizando…",
    presence_typing_one: "{name} está digitando…",
    presence_typing_many: "Várias pessoas estão digitando…",
    presence_recording_one: "{name} está gravando áudio…",
    presence_recording_many: "Várias pessoas estão gravando áudio…",
    presence_recording_label: "Gravando áudio…",
    presence_typing_label: "digitando",
    buddy_thinking: "Pensando...",
    buddy_speaking: "Falando...",
    buddy_interrupt_hint: 'diga "Hey Buddy" para interromper',
    buddy_memories_label: "Memórias do Buddy",
    buddy_memories_hint: "Tudo que você ensinou ao Buddy — ele usa em todas as conversas",
    buddy_memories_empty: 'O Buddy ainda não aprendeu nada. Ensine por voz ("Buddy, lembra que...") ou adicione abaixo.',
    buddy_memory_add_ph: "Ensine algo novo ao Buddy...",
    buddy_memory_saved: "Buddy aprendeu!",
    buddy_memory_updated: "Memória atualizada",
    buddy_memory_deleted: "Memória apagada",
    buddy_new_memory: "Lembrar isso?",
    buddy_remember_btn: "Lembrar",
    buddy_personality: "Personalidade",
    buddy_style_default: "Padrão",
    buddy_style_formal: "Formal",
    buddy_style_casual: "Descontraído",
    buddy_style_direct: "Direto",
    buddy_instructions_ph: 'Instruções pessoais... ex: "sempre me chame de chefe", "responda curto"',
    buddy_prefs_saved: "Buddy adaptado a você!",
    buddy_prefs_save: "Salvar",
    buddy_rules_title: "Regras da empresa para o Buddy",
    buddy_rules_hint: "As regras valem para o Buddy de todos os usuários, ou só de um usuário específico. Usuários não veem nem alteram.",
    buddy_rule_ph: 'Nova regra... ex: "Sempre lembrar do EPI ao falar de instalação"',
    buddy_rule_target_all: "Todos os usuários",
    buddy_rule_add: "Adicionar regra",
    buddy_rule_added: "Regra adicionada",
    buddy_rule_saved: "Regra salva",
    buddy_rule_deleted: "Regra removida",
    buddy_user_memories: "Memórias por usuário",
    buddy_pick_user: "Escolha um usuário...",
    buddy_no_memories_user: "Este usuário ainda não ensinou nada ao Buddy.",
    buddy_send: "Enviar",
    buddy_cancel: "Cancelar",
    buddy_to: "Para",
    buddy_sent: "Mensagem enviada!",
    buddy_group: "Grupo",
    buddy_new_task: "Nova tarefa",
    buddy_new_issue: "Novo problema",
    buddy_task_created: "Tarefa criada!",
    buddy_issue_created: "Problema registrado!",
    buddy_confirm: "Confirmar",
    buddy_open_job: "Abrir job",
    buddy_wake_label: '"Hey Buddy" (mãos livres)',
    buddy_wake_on: '"Hey Buddy" ativado — estou te ouvindo com o app aberto',
    buddy_wake_off: '"Hey Buddy" desativado',
    buddy_wake_hint: 'ou diga "Hey Buddy"',
    buddy_too_short: "Segure o botão enquanto fala",
    buddy_error: "Opa, algo deu errado. Tenta de novo!",
    buddy_mic_denied: "Para conversar com Buddy, habilite o microfone",
    buddy_speak_now: "Pode falar — estou ouvindo!",
    buddy_handsfree_hint: "Respondo quando você pausar",
    buddy_tap_cancel: "toque para cancelar",
    buddy_draft_discarded: "Ok, rascunho descartado.",
    buddy_voice_on: "Voz ligada — Buddy fala as respostas",
    buddy_voice_off: "Voz mutada — apenas texto",
    buddy_size_label: "Tamanho do Buddy (P/M/G)",
    buddy_speed_label: "Velocidade da voz do Buddy (1x / 1.5x / 2x)",
    buddy_sfx_on: "Sons de ferramenta: alto",
    buddy_sfx_low: "Sons de ferramenta: baixo",
    buddy_sfx_off: "Sons de ferramenta: desligados",
    buddy_load_older: "Ver mensagens antigas",
  },
  es: {
    offline_opened: "Sin internet — mostrando tus datos guardados; se sincroniza cuando vuelva la conexión.",
    buddy_company_remove: "Quitar miembro de la empresa",
    buddy_company_leave_approve: "Aprobar solicitud de salida",
    buddy_company_leave_reject: "Rechazar solicitud de salida",
    buddy_company_removed: "Miembro eliminado.",
    invites_title: "Invitaciones enviadas",
    invites_sent: "enviadas",
    invites_accepted: "aceptadas",
    invites_empty: "Aún no se enviaron invitaciones.",
    invited_by: "por",
    invite_status_accepted: "Se unió",
    invite_status_pending: "Pendiente",
    invite_share_hint: "Compartir no está disponible en este dispositivo — el texto fue copiado. Pégalo en WhatsApp o donde prefieras.",
    invite_share: "Compartir por WhatsApp u otra app",
    close: "Cerrar",
    invite_title: "Invitar a OnSiteComms",
    invite_not_found: "aún no está en OnSiteComms. ¿Quieres enviar una invitación?",
    invite_email_explain: "Enviaremos un correo de invitación con un enlace — cuando la persona cree la cuenta, quedan conectados automáticamente.",
    invite_sms_explain: "Se abrirá tu app de mensajes con la invitación ya escrita — solo toca Enviar.",
    invite_sms_hint: "Si la app de mensajes no se abrió, copia el texto y envíalo como prefieras.",
    invite_send_email: "Enviar invitación por correo",
    invite_send_sms: "Enviar invitación por SMS",
    invite_open_sms: "Abrir mensajes",
    invite_email_sent: "Invitación enviada a",
    invite_already_registered: "Esa persona ya tiene cuenta — revisa el correo/teléfono escrito.",
    invite_email_unavailable: "La invitación por correo no está disponible ahora.",
    invite_invalid: "Escribe un correo o teléfono válido.",
    buddy_admin_approve: "Aprobar cuenta",
    buddy_admin_reject: "Rechazar solicitud de cuenta",
    buddy_admin_broadcast: "Enviar broadcast",
    buddy_admin_user_update: "Actualizar usuario",
    buddy_admin_user_delete: "Eliminar usuario",
    buddy_admin_approved: "¡Cuenta aprobada!",
    buddy_admin_rejected: "Solicitud rechazada.",
    buddy_admin_broadcast_sent: "¡Broadcast enviado!",
    buddy_admin_user_updated: "¡Usuario actualizado!",
    buddy_admin_user_deleted: "Usuario eliminado.",
    attach_intent_camera: "Buddy: toca para tomar la foto y enviarla aquí",
    attach_intent_gallery: "Buddy: toca para elegir la foto y enviarla aquí",
    attach_intent_video: "Buddy: toca para elegir el video y enviarlo aquí",
    attach_intent_document: "Buddy: toca para elegir el archivo y enviarlo aquí",
    app_tagline: "Diseñado para resolver el trabajo de campo.",
    select_profile: "¿Quién eres?",
    select_profile_sub: "Elige tu perfil para entrar a OnSiteComms. No se necesita contraseña en modo demo.",
    sign_in: "Iniciar sesión",
    create_account: "Crear cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    your_name: "Nombre completo",
    role: "Rol",
    or: "o",
    sign_in_passkey: "Iniciar sesión con FaceID / Passkey",
    sign_in_apple: "Iniciar sesión con Apple",
    apple_soon: "Iniciar sesión con Apple estará disponible pronto",
    apple_prod_only: "El inicio de sesión con Apple funciona en on-site-comms.com (después del despliegue de producción)",
    apple_signing_in: "Iniciando sesión con Apple...",
    apple_login_failed: "Error al iniciar sesión con Apple. Intenta de nuevo.",
    google_soon: "Iniciar sesión con Google estará disponible pronto",
    google_signing_in: "Iniciando sesión con Google...",
    google_login_failed: "Error al iniciar sesión con Google. Intenta de nuevo.",
    google_account_not_found: "Cuenta no encontrada. Pide a tu administrador que registre tu correo electrónico primero.",
    register_approval_notice: "Las nuevas cuentas requieren aprobación del administrador. Recibirás un correo electrónico cuando tu solicitud sea aprobada.",
    register_pending_title: "¡Solicitud enviada!",
    register_pending_sub: "Tu solicitud de cuenta fue enviada al administrador. Recibirás un correo electrónico tan pronto como sea aprobada.",
    register_already_pending: "Tu solicitud ya fue enviada y está esperando aprobación.",
    login_pending_approval: "Tu cuenta aún está esperando la aprobación del administrador. Recibirás un correo electrónico cuando sea aprobada.",
    reg_requests_title: "Solicitudes de cuenta",
    reg_approve: "Aprobar",
    reg_reject: "Rechazar",
    reg_approved_toast: "Cuenta aprobada",
    reg_rejected_toast: "Solicitud rechazada",
    reg_mode_solo: "Sin empresa",
    reg_mode_join: "Unirse a una empresa",
    reg_mode_create: "Crear empresa",
    reg_solo_notice: "Cuenta independiente: comienzas solo y agregas contactos uno a uno usando códigos de conexión.",
    reg_create_notice: "Vas a crear la empresa y serás su administrador, aprobando quién se une.",
    company_name: "Nombre de la empresa",
    company_code: "Código de la empresa",
    company_name_required: "Ingresa el nombre de la empresa",
    company_code_required: "Ingresa el código de la empresa (pregunta a tu administrador)",
    invalid_company_code: "Código de empresa no encontrado. Verifica con tu administrador.",
    phone_optional: "Teléfono (opcional)",
    phone_exists: "Este número de teléfono ya está registrado",
    invalid_phone: "Número de teléfono inválido",
    company_created_toast: "¡Empresa creada! Comparte el código de la empresa (en Admin) para invitar a tu equipo",
    company_and_connections: "Empresa & Conexiones",
    company: "Empresa",
    no_company: "Cuenta independiente (sin empresa)",
    connect_code_explainer: "Tu código ES tu correo electrónico o número de teléfono. Compártelo con alguien DE FUERA de tu empresa para que puedan conectarse contigo.",
    generate_my_code: "Generar mi código",
    enter_someones_code: "Correo o teléfono de la persona",
    connect: "Conectar",
    connected_with: "Conectado con",
    invalid_connect_code: "Este usuario no existe",
    phone: "Teléfono",
    own_connect_code: "Ese es tu propio código",
    valid_until: "válido hasta",
    copied: "Copiado",
    members: "miembros",
    company_code_hint: "Comparte este código con personas que deben UNIRSE a tu empresa (tú apruebas cada solicitud).",
    partner_companies: "Empresas asociadas",
    partner_code_placeholder: "Código de socio",
    connect_companies: "Conectar empresas",
    partner_connected_toast: "Empresas conectadas",
    partner_disconnected_toast: "Empresas desconectadas",
    disconnect_company: "Desconectar",
    disconnect_company_confirm: "Ambas empresas dejarán de ver los contactos de la otra.",
    purge_related_question: "¿Te gustaría eliminar las conversaciones y contactos relacionados?",
    purge_yes_delete_all: "Sí — eliminar todo",
    purge_no_keep_loose: "No — mantener como contactos sueltos",
    purge_no_hint: "Si los mantienes, los contactos con conversaciones iniciadas se convierten en contactos sueltos.",
    no_partner_companies: "Aún no hay empresas asociadas — ingresa un código de socio arriba para intercambiar tarjetas de visita.",
    my_company_badge: "Mi empresa",
    company_card_empty: "Sin información de contacto aún — toca Editar para completar tu tarjeta de negocio.",
    company_card_saved: "Tarjeta de negocio guardada",
    edit_company_card: "Editar tarjeta",
    connect_company_hint: "Ingresa el código de la otra empresa para intercambiar tarjetas de visita — los directorios de contactos de ambas empresas se vuelven visibles entre sí.",
    company_name_label: "Nombre de la empresa",
    company_address_label: "Dirección",
    company_website_label: "Sitio web",
    business_cards_tab: "Tarjetas de Visita",
    partner_visibility_btn: "Contactos visibles",
    partner_visibility_title: "Contactos visibles",
    partner_visibility_hint: "Elige qué contactos de esta empresa pueden ver tus usuarios. Los contactos desmarcados desaparecen del directorio y de la lista de nuevos chats (los administradores siempre ven a todos; las conversaciones existentes se mantienen).",
    partner_visibility_hint_out: "Elige qué contactos de TU empresa puede ver esta empresa asociada. Los contactos desmarcados quedan invisibles para TODOS allí — incluidos sus administradores (las conversaciones existentes se mantienen).",
    partner_visibility_tab_in: "Lo que ve mi equipo",
    partner_visibility_tab_out: "Lo que ellos ven de la mía",
    partner_visibility_saved: "Visibilidad de contactos actualizada",
    partner_visibility_count: "{n} de {t} contactos visibles",
    select_all: "Seleccionar todo",
    clear_all: "Desmarcar todo",
    personal_contacts: "Contactos personales",
    add_personal_contact: "Agregar contacto personal",
    add_existing_user: "Agregar usuario",
    add_existing_user_hint: "¿La persona ya tiene una cuenta en la app? Ingresa su correo electrónico o teléfono para invitarla a tu empresa. Se convierte en miembro tan pronto como apruebe.",
    add_existing_user_toast: "Invitación enviada — esperando la aprobación de la persona",
    company_invite_title: "Invitación a la empresa",
    company_invite_text: "{admin} te invitó a unirte a {company} como {role}",
    invite_accepted_toast: "Ahora eres parte de la empresa",
    invite_declined_toast: "Invitación rechazada",
    pending_invites_title: "Invitaciones enviadas (esperando aprobación)",
    cancel_invite: "Cancelar invitación",
    invite_cancelled_toast: "Invitación cancelada",
    already_member: "Esta persona ya es parte de tu empresa",
    belongs_to_other_company: "Esta persona ya pertenece a otra empresa — debe salir de allí primero.",
    last_admin_error: "La empresa debe tener siempre al menos un Administrador. Promueve a otro Administrador primero.",
    connect_confirm_title: "¿Conectar con esta persona?",
    connect_confirm_hint: "Se abrirá una conversación directa entre ustedes.",
    member_history_title: "Historial de miembros",
    mh_joined: "se unió a la empresa",
    mh_left: "salió de la empresa",
    mh_removed: "fue removido de la empresa",
    mh_created: "cuenta creada",
    mh_deleted: "cuenta eliminada",
    mh_promoted: "se convirtió en Administrador",
    mh_by: "por",
    mh_empty: "Aún no hay eventos — el historial comienza a contar desde ahora.",
    transfer_admin: "Transferir rol de Administrador",
    transfer_admin_hint: "Eres el único Administrador — para poder salir de la empresa, primero pasa el rol a otro miembro.",
    transfer_admin_pick: "Elige el nuevo Administrador",
    transfer_admin_done: "ahora también es Administrador — ya puedes solicitar la salida.",
    pmhr_links_title: "Vínculos de sincronización",
    pmhr_links_hint: "La sincronización nunca crea usuarios. Vincula cada supervisor y equipo del cronograma a un usuario EXISTENTE — incluidos los usuarios de empresas asociadas — nada queda huérfano.",
    pmhr_partner_company: "empresa asociada",
    buddy_voice_title: "Voz de Buddy",
    buddy_voice_desc: "Se usa cuando Buddy habla y se presenta al cliente",
    buddy_voice_preview: "Escuchar una muestra",
    buddy_voice_error: "No se pudo actualizar la voz. Inténtalo de nuevo.",
    voice_echo: "masculina (predeterminada)",
    voice_alloy: "neutral",
    voice_fable: "británica",
    voice_onyx: "grave",
    voice_nova: "femenina",
    voice_shimmer: "femenina suave",
    signin_with_apple: "Iniciar sesión con Apple",
    signin_with_google: "Iniciar sesión con Google",
    signin_with_faceid: "Iniciar sesión con Face ID",
    ai_consent_title: "Funciones de IA y tus datos",
    ai_consent_p1: "OnSiteComms usa OpenAI para ofrecer traducción automática, transcripción de audio y el asistente Buddy.",
    ai_consent_p2: "Cuando usas estas funciones, el siguiente contenido se envía a OpenAI (EE. UU.) solo para brindar la función. Nunca se usa para publicidad, y OpenAI no usa datos de la API para entrenar sus modelos:",
    ai_consent_b1: "Texto de tus mensajes — para la traducción automática",
    ai_consent_b2: "Grabaciones de voz — para transcripción y el intérprete en vivo",
    ai_consent_b3: "Tus preguntas y comandos de voz a Buddy",
    ai_consent_b4: "Fotos que pidas analizar a la IA (p. ej., medidas)",
    ai_consent_warning: "Si no autorizas, NO podrás usar la traducción automática, el asistente Buddy ni la transcripción de audio. Puedes cambiarlo en cualquier momento en Configuraciones.",
    ai_consent_accept: "Autorizar y continuar",
    ai_consent_decline: "No autorizar",
    ai_consent_privacy: "Leer nuestra Política de Privacidad",
    ai_consent_error: "No se pudo guardar tu elección. Inténtalo de nuevo.",
    ai_settings_title: "Funciones de IA (OpenAI)",
    ai_settings_on: "Autorizado — traducción automática, Buddy y transcripción activos",
    ai_settings_off: "Apagado — sin traducción automática, sin Buddy, sin transcripción",
    info_email: "Correo",
    info_phone: "Celular",
    contact_copied: "¡Contacto copiado!",
    email_pending: "Ya existe una solicitud de cuenta pendiente con este correo — pide a tu admin que la apruebe",
    master_users_title: "Todas las cuentas",
    master_banners_hint: "Todas las cuentas del sistema en una sola lista: cambia el rol, edita, quita de la empresa o elimina. Los interruptores vuelven a mostrar un banner en el PRÓXIMO inicio de sesión del usuario (tour de apertura / consentimiento Buddy-IA); cada uno aparece una vez y se apaga solo.",
    banner_tour: "Tour de apertura",
    banner_ai: "Consentimiento Buddy/IA",
    master_users_search_ph: "Buscar por nombre, email o empresa...",
    all_companies: "Todas las empresas",
    all_roles: "Todos los roles",
    master_no_company: "Sin empresa",
    master_sort_name_asc: "Nombre (A–Z)",
    master_sort_name_desc: "Nombre (Z–A)",
    master_sort_company: "Por empresa",
    master_sort_role: "Por rol",
    master_sort_pending: "Banners pendientes primero",
    master_filter_no_results: "Ninguna cuenta coincide con los filtros",
    pmhr_link_pending: "Pendiente",
    pmhr_link_linked: "Vinculado",
    pmhr_link_btn: "Vincular",
    pmhr_link_saved: "Vínculo guardado",
    pmhr_links_pending_toast: "Sincronización finalizada — hay vínculos pendientes por configurar",
    pmhr_kind_crew: "Equipo",
    pmhr_kind_supervisor: "Supervisor",
    pmhr_link_select: "Elige usuario",
    personal_connections_title: "Conexiones personales",
    own_company_code: "Ese es el código de tu propia empresa",
    code_regenerated_toast: "Nuevo código de empresa generado (el antiguo ya no funciona)",
    leave_requests_title: "Solicitudes de salida",
    leave_approved_toast: "Salida aprobada",
    leave_rejected_toast: "Salida rechazada",
    member_removed_toast: "Removido de la empresa",
    remove_from_company: "Eliminar de la empresa",
    remove_from_company_confirm: "{name} saldrá de la empresa y perderá acceso a sus trabajos, equipos y directorio de conversaciones. Los contactos con conversaciones iniciadas se convierten en contactos personales. La cuenta permanece activa (individual).",
    request_leave_company: "Solicitar salida de la empresa",
    leave_company_confirm: "Tu administrador debe aprobar esta solicitud. Tu cuenta permanece activa, pero perderás acceso a los contactos y trabajos de la empresa.",
    leave_requested_toast: "Solicitud enviada a tu administrador",
    leave_pending_note: "Solicitud de salida enviada — esperando aprobación del administrador.",
    confirm: "Confirmar",
    sync_source_title: "Fuente de sincronización (sistema de tu empresa)",
    sync_source_sub: "Cada empresa configura AQUÍ su propio sistema de trabajos. La sincronización solo afecta los trabajos de tu empresa.",
    sync_base_url: "Dirección de la API (ej.: https://tusistema.com/api)",
    sync_username: "Usuario",
    sync_password: "Contraseña",
    sync_password_saved: "Contraseña (guardada)",
    sync_interval: "Intervalo (min)",
    sync_past_days: "Días pasados",
    sync_future_days: "Días futuros",
    sync_save: "Guardar configuración de sincronización",
    sync_saved_toast: "Configuración de sincronización guardada",
    sync_test: "Probar conexión",
    sync_test_ok: "¡Conexión OK! El inicio de sesión funcionó y se encontraron {n} trabajos en la fuente. Puedes activar la sincronización automática.",
    sync_last_error_title: "La última sincronización falló — aquí está el motivo:",
    sync_err_not_configured: "La sincronización aún no está configurada. Completa la dirección de la API, usuario y contraseña, guarda y prueba de nuevo.",
    sync_err_invalid_url: "La dirección de la API es inválida. Usa el formato completo, ej.: https://tusistema.com/api (debe comenzar con http:// o https://).",
    sync_err_connection: "No se pudo conectar a la dirección. Verifica si escribiste la URL correctamente y asegúrate de que el sistema esté en línea y accesible desde internet.",
    sync_err_timeout: "El sistema de la fuente tardó demasiado en responder. Puede estar lento o fuera de línea — intenta de nuevo en unos minutos.",
    sync_err_auth: "La fuente rechazó el NOMBRE DE USUARIO o la CONTRASEÑA. Verifica las credenciales de tu sistema de trabajos (no tu inicio de sesión en OnSiteComms).",
    sync_err_server: "El sistema de la fuente devolvió un error interno (5xx). El problema está de su lado — intenta de nuevo más tarde.",
    sync_err_bad_response: "La dirección respondió, pero no en el formato esperado. Asegúrate de que sea la dirección de la API (generalmente termina en /api) y que el sistema sea compatible.",
    sync_err_generic: "Error de sincronización inesperado. Usa Probar conexión para ver los detalles.",
    company_qr_title: "Código QR de invitación de la empresa",
    company_qr_hint: "Tu equipo escanea este QR con la cámara del teléfono: el registro se abre con el código de la empresa ya completado. Aún apruebas cada solicitud.",
    company_qr_copy_link: "Copiar enlace",
    join_link_logged_in: "Este es un invitación para registrarse en la empresa. Ya estás conectado — cierra sesión para registrarte con este código.",
    share_link: "Compartir",
    share_invite_text_personal: "Chatea conmigo en OnSiteComms — toca el enlace para conectar:",
    share_invite_text_company: "Únete a mi empresa en OnSiteComms — toca el enlace para registrarte:",
    my_qr_btn: "Mi código QR",
    my_qr_title: "Mi código QR de conexión",
    my_qr_hint: "Cualquiera que escanee este QR con la cámara del teléfono se conecta contigo al instante y se abre un chat directo (inicia sesión primero si es necesario).",
    connect_after_login: "Inicia sesión (o crea tu cuenta) para completar la conexión",
    welcome_back: "Bienvenido",
    account_created: "¡Cuenta creada!",
    login_failed: "Correo electrónico o contraseña inválidos",
    register_failed: "No se pudo crear la cuenta",
    email_exists: "Ya existe una cuenta con este correo electrónico",
    password_min: "La contraseña debe tener al menos 6 caracteres",
    passkey_error: "Error al iniciar sesión con passkey",
    passkey_cancelled: "Passkey cancelada",
    passkey_added: "¡Passkey añadida! Ahora puedes iniciar sesión con FaceID",
    passkey_already_active: "¡FaceID ya estaba habilitado en este dispositivo — todo listo!",
    reminder_alarm_title: "¡Recordatorio!",
    reminder_alarm_sub: "Buddy te está recordando:",
    reminder_alarm_close: "OK, entendido",
    add_passkey: "Agregar Passkey (FaceID)",
    passkey_active: "Passkey activa",
    sign_out: "Cerrar sesión",
    login_footer: "Inicio de sesión seguro. Las sesiones permanecen activas durante 30 días.",
    profile: "Perfil",
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar nueva contraseña",
    password_changed: "¡Contraseña cambiada!",
    passwords_mismatch: "Las contraseñas no coinciden",
    wrong_current_password: "La contraseña actual es incorrecta",
    reopened: "Reabierto",
    push_notifications: "Notificaciones push",
    notifications_off: "Notificaciones desactivadas",
    markup_sent: "Marcado enviado a la conversación",
    speak_issue: "Habla del problema",
    speak_again: "Habla de nuevo",
    listening_tap_stop: "Escuchando... toca para parar",
    creating_title: "Creando el borrador del problema...",
    draft_ready: "Borrador listo — revisa abajo",
    add_media_question: "¿Agregar una foto o video?",
    create_now: "Crear problema ahora",
    speak_resolution: "Habla de la solución",
    speak_task: "Habla de la tarea",
    speak_material: "Habla de la solicitud de material",
    processing_voice: "Procesando lo que dijiste...",
    send_now: "Enviar ahora",
    task_create_now: "Crear tarea ahora",
    add_photo_question: "¿Agregar una foto?",
    pick_assignee_hint: "Elige a quién se le asigna abajo y luego crea",
    photo_one: "Foto",
    unread_chat: "Chat no leído",
    take_photo: "Tomar foto",
    photo_gallery: "Foto (Galería)",
    record_video: "Grabar video",
    video_gallery: "Video (Galería)",
    camera_unavailable: "Cámara no disponible",
    captions: "Subtítulos",
    generating_captions: "Generando subtítulos...",
    generate_captions: "Generar subtítulos",
    compressing_video: "Comprimiendo video...",
    sending_video: "Enviando video...",
    sending_photo: "Enviando foto...",
    photo_sent_to: "Foto enviada a {name}",
    photo_send_failed_to: "No se pudo enviar la foto a {name}",
    tap_to_retry: "toca para reintentar",
    video_quality_title: "Enviar video como",
    video_quality_fast: "Rápido (720p)",
    video_quality_fast_hint: "Comprimido en el teléfono — menos datos, más rápido",
    video_quality_original: "Original",
    video_quality_original_hint: "Calidad completa, archivo más grande",
    queued: "Esperando...",
    video_sending_bg: "Enviando en segundo plano — puedes seguir usando la app",
    video_sent_to: "Video enviado a {name}",
    video_send_failed_to: "No se pudo enviar el video a {name}",
    video_discarded: "Video descartado",
    copy: "Copiar",
    forward: "Reenviar",
    forward_to: "Reenviar a...",
    send_to_chat: "Enviar a un chat",
    pick_emoji: "Elegir emoji",
    reactions: "Reacciones",
    you: "Tú",
    tap_to_remove: "Toca para quitar",
    stickers: "Stickers",
    sticker: "Sticker",
    add_sticker: "Agregar",
    stickers_imported: "{n} sticker(s) agregado(s)",
    sticker_import_hint: "Importa PNG, WebP o GIF (animados también) — p. ej., stickers exportados de WhatsApp",
    no_recent_stickers: "Aún no hay stickers recientes",
    no_saved_stickers: "Aún no hay stickers guardados. Toca + para agregar los tuyos.",
    save_sticker: "Guardar en Mis stickers",
    sticker_saved: "Sticker guardado",
    sticker_from_photo: "Sticker desde foto",
    create_sticker: "Crear sticker",
    no_speech_detected: "No se detectó voz en este video",
    crop_hint_sticker: "Arrastra para ubicar la foto dentro del marco — usa el control para hacer zoom",
    sticker_studio: "Estudio de stickers",
    sticker_text_placeholder: "Agregar texto (opcional)",
    text_top: "Arriba",
    text_bottom: "Abajo",
    record_video_sticker: "Grabar un video corto para sticker",
    sticker_clip_start: "Inicio del clip (máx. 5s)",
    sticker_creating: "Creando…",
    sticker_studio_hint_anim: "Arrastra para encuadrar · zoom · hasta 5 s en bucle, sin sonido",
    sticker_too_large: "Sticker demasiado pesado — usa un clip más corto o cerrado",
    sticker_render_failed: "No se pudo crear el sticker con este archivo",
    sticker_no_preview: "Vista previa no disponible en este dispositivo — el sticker usará el centro de los primeros 5 segundos",
    make_sticker: "Crear sticker",
    sticker_saved_hint: "Sticker guardado en \"Míos\" en la bandeja de stickers",
    view_photo: "Ver foto",
    period_all: "Todas las fechas",
    period_today: "Hoy",
    period_this_week: "Esta semana",
    period_last_week: "Semana pasada",
    period_next_week: "Próxima semana",
    period_this_month: "Este mes",
    period_last_month: "Mes pasado",
    period_next_month: "Próximo mes",
    forward_comment_placeholder: "Agrega un comentario (opcional)",
    forwarded: "Reenviado",
    message_forwarded: "Mensaje reenviado",
    deleted_message_by: "Mensaje eliminado por {name} el {date} a las {time}",
    add_favorite: "Agregar a favoritos",
    remove_favorite: "Eliminar de favoritos",
    favorites: "Favoritos",
    no_favorites: "Aún no hay mensajes favoritos",
    added_favorite: "Agregado a favoritos",
    removed_favorite: "Eliminado de favoritos",
    pin_message: "Fijar en la parte superior",
    pin_for: "Fijar por...",
    hours_24: "24 horas",
    days_7: "7 días",
    days_30: "30 días",
    pinned_by: "Fijado por",
    message_pinned: "Mensaje fijado",
    deleted_message: "Mensaje eliminado",
    delete_conversation: "Eliminar conversación",
    delete_conversation_confirm: "La conversación desaparecerá solo de tu lista — la otra persona la conserva. Si alguien envía un nuevo mensaje volverá a aparecer, pero el historial antiguo seguirá borrado para ti.",
    conversation_deleted: "Conversación eliminada",
    save_to_device: "Guardar en el dispositivo",
    saved_to_device: "Guardado en tu dispositivo",
    other_supervisors_jobs: "Trabajos de otros supervisores",
    installer: "Líder de Equipo",
    supervisor: "Supervisor",
    office: "Oficina",
    manager: "Gerente",
    admin: "Admin",
    admin_panel: "Panel Admin",
    admin_only: "Acceso solo para admin",
    users: "Usuarios",
    system: "Sistema",
    create_user: "Crear usuario",
    full_name: "Nombre completo",
    password_ph: "Contraseña (mín. 6 caracteres)",
    password_updated: "Contraseña actualizada",
    user_created: "Usuario creado",
    reset_password: "Restablecer contraseña",
    last_login: "Último acceso",
    clear: "Limpiar",
    passkeys_cleared: "Passkeys eliminadas — el usuario puede registrar el Face ID nuevamente",
    token_removed: "Dispositivo eliminado",
    test_push_sent: "Push de prueba enviado",
    test_push_body: "¡Las notificaciones push están funcionando!",
    no_devices_yet: "Aún no hay dispositivos registrados. Los dispositivos aparecen aquí después de que los usuarios inician sesión en la app móvil.",
    pmhr_tab: "Sincronización",
    pmhr_title: "Sincronización de Agenda",
    pmhr_sync_now: "Sincronizar ahora",
    pmhr_syncing: "Sincronizando...",
    pmhr_sync_done: "Sincronización completa",
    pmhr_auto_sync: "Sincronización automática",
    pmhr_auto_on: "Funciona automáticamente cada {n} min",
    pmhr_auto_off: "La sincronización automática está desactivada — solo sincronización manual",
    pmhr_last_sync: "Última sincronización",
    pmhr_never: "Nunca",
    pmhr_synced_jobs: "Jobs sincronizados",
    pmhr_synced_pdfs: "PDFs importados",
    pmhr_created: "Creado",
    pmhr_updated: "Actualizado",
    pmhr_deleted: "Eliminado",
    pmhr_pdfs: "PDFs",
    pmhr_skipped: "Sin cambios",
    pmhr_errors: "Errores",
    pmhr_history: "Historial de sincronizaciones",
    pmhr_no_logs: "Aún no hay sincronizaciones",
    pmhr_window: "Ventana: últimos {p} + próximos {f} días",
    pmhr_note: "Jobs y PDFs del Installation Package se reflejan desde tu sistema de programación. Usuarios y grupos de chat NUNCA se crean automáticamente — vincula supervisores y equipos a usuarios existentes en \"Vínculos de sincronización\" arriba.",
    dup_title: "Trabajos duplicados",
    dup_check: "Verificar duplicados",
    dup_checking: "Verificando...",
    dup_none: "No se encontraron trabajos o PDFs duplicados. ¡Todo limpio!",
    dup_found: "{j} trabajo(s) duplicado(s) ({e} copias extras) y {p} PDF(s) extra(s) encontrados:",
    dup_delete_all: "Eliminar todos los duplicados",
    dup_deleted: "Duplicados eliminados",
    dup_copies: "copias",
    delete_user: "Eliminar usuario",
    delete_message: "Eliminar mensaje",
    delete_message_confirm: "\"Eliminar para mí\" la oculta solo para ti. \"Eliminar para todos\" la elimina para todos.",
    delete_for_me: "Eliminar para mí",
    delete_for_everyone: "Eliminar para todos",
    delete_window_expired: "Ya pasó el plazo para eliminar para todos — aún puedes eliminarla solo para ti.",
    message_deleted: "Mensaje eliminado",
    search: "Buscar...",
    send_markup_title: "Enviar marcação",
    send_to_whom: "¿A quién quieres enviarlo?",
    link_to_job_q: "¿Vincular a un trabajo? (opcional)",
    choose_job: "Elegir trabajo",
    old_measurements_wrong: "Medidas antiguas incorrectas",
    all_crews: "Todas",
    service_supervisor_label: "Supervisor predeterminado para trabajos Service",
    service_supervisor_none: "Ninguno (dejar sin supervisor)",
    service_supervisor_hint: "Los trabajos Service llegan de la matriz sin supervisor — la persona elegida aquí se asigna automáticamente en cada sincronización.",
    resolved: "Resuelto",
    cleanup_orphans_title: "Limpiar registros huérfanos",
    cleanup_orphans_desc: "Elimina restos que apuntan a cosas que ya no existen: mensajes de conversaciones eliminadas y problemas/tareas cuyo trabajo Y conversación desaparecieron. Los problemas aún ligados a un trabajo vivo se conservan.",
    cleanup_orphans_btn: "Limpiar huérfanos",
    cleanup_orphans_confirm: "Esto elimina permanentemente todos los registros huérfanos de todo el sistema. No se puede deshacer. ¿Continuar?",
    cleanup_orphans_done: "Limpiado: {m} mensajes, {i} problemas, {t} tareas, {f} archivos",
    new_job_group_chat: "Nuevo Grupo de Trabajo",
    start_conversation: "Iniciar conversación",
    edit_user: "Editar usuario",
    no_crew: "Sin equipo",
    new_password_optional: "Nueva contraseña (opcional)",
    keep_current_password: "Deja vacío para mantener la actual",
    delete_user_confirm: "Esto eliminará permanentemente a este usuario. Los mensajes que envió permanecerán en el historial de chat. Esto no se puede deshacer.",
    user_deleted: "Usuario eliminado",
    download_source_zip: "Descargar código fuente completo (ZIP)",
    download_source_desc: "Backend + frontend + proyectos de iOS y Android, listos para Xcode / Android Studio (node_modules excluido — ejecuta 'yarn install' después de descomprimir).",
    preparing_zip: "Preparando ZIP...",
    zip_phase_zipping: "Comprimendo código fuente",
    zip_phase_downloading: "Descargando",
    zip_files: "archivos",
    zip_done: "¡Código fuente descargado!",
    cleanup_demo_title: "Eliminar datos de demostración",
    font_size_title: "Tamaño del texto",
    font_small: "Pequeña",
    font_medium: "Mediana",
    font_large: "Grande",
    font_preview: "Así se verán tus mensajes.",
    bio_unlock_reason: "Desbloquear OnSiteComms",
    change_photo: "Cambiar foto",
    remove_photo: "Eliminar foto",
    photo_updated: "Foto actualizada",
    photo_removed: "Foto eliminada",
    group_photo: "Foto de grupo",
    seed_demo_title: "Crear cuenta demo (App Review)",
    seed_demo_desc: "Crea/actualiza la cuenta demo para los equipos de revisión de Google Play y Apple: johnny.garbim@gmail.com con trabajos, conversaciones, fotos y una encuesta de ejemplo (todo en inglés). Se puede ejecutar varias veces sin problema.",
    seed_demo_done: "Cuenta demo lista",
    cleanup_demo_desc: "Elimina SOLAMENTE los datos de demostración: la cuenta demo de App Review (johnny.garbim@gmail.com, Mike Anderson, Carlos Silva), sus trabajos (#10424, #10431), chats y fotos, además de cualquier dato seed antiguo. Se mantienen usuarios reales, conversaciones reales y trabajos sincronizados.",
    cleanup_demo_confirm: "¿Eliminar los datos de demostración permanentemente?",
    demo_cleaned: "Datos de demostración eliminados",
    job_type_install: "Install",
    job_type_service: "Service/JIP",
    removed_from_matrix: "Eliminado de la matriz",
    job_notes: "Notas",
    tab_active: "Activos (hoy)",
    tab_past: "Pasados",
    tab_future: "Próximos",
    no_jobs_today: "No hay trabajos programados para hoy.",
    filter_teams: "Equipos",
    filter_dates: "Fechas",
    clear_filters: "Limpiar filtros",
    day_of_days: "Día {d} de {n}",
    days_count: "{n} días",
    preset_this_week: "Esta semana",
    preset_this_month: "Este mes",
    preset_last_week: "La semana pasada",
    preset_last_month: "El mes pasado",
    preset_next_week: "La próxima semana",
    preset_next_month: "El próximo mes",
    devices: "Dispositivos",
    media: "Medios",
    something_wrong: "Algo salió mal",
    source_code_title: "Código fuente para Xcode / Android Studio",
    source_code_info: "Los proyectos nativos (ios/ y android/) están dentro del código fuente de la app. Para compilar en Xcode/Android Studio:",
    source_step_1: "En Emergent: usa 'Guardar en GitHub' (o Descargar código) en el menú del proyecto para obtener el código completo",
    source_step_2: "En tu computadora: cd frontend, ejecuta 'yarn install' y 'yarn cap:sync'",
    source_step_3: "Abre con 'yarn cap:ios' (Xcode) o 'yarn cap:android' (Android Studio) — consulta CAPACITOR_GUIA.md",
    crew_leader: "Líder de Equipo",
    home: "Inicio",
    jobs: "Jobs",
    messages: "Mensajes",
    issues: "Problemas",
    tasks: "Tareas",
    photos: "Fotos",
    today: "HOY",
    open_issues: "Problemas Abiertos",
    active_jobs: "Jobs Activos",
    unread_conversations: "Chats No Leídos",
    new_field_photos: "Fotos Nuevas de Campo",
    completed_jobs: "Jobs Completados",
    open_tasks: "Mis Tareas Abiertas",
    recent_activity: "Reciente",
    my_jobs: "Mis Jobs",
    all_jobs: "Todos los Jobs",
    scheduled: "Agendado",
    active: "Activo",
    completed: "Concluido",
    crew: "Equipo",
    job_chat: "Chat del Job",
    crew_chat: "Chat del Equipo",
    direct: "Directo",
    chat: "Chat",
    decisions: "Decisiones",
    documents: "Documentos",
    info: "Info",
    report_issue: "Reportar Problema",
    complete_job: "Concluir Job",
    job_completed: "Job completado",
    type_message: "Mensaje",
    draft: "Borrador",
    waiting_conn: "esperando conexión",
    offline_queue_title: "Cola de envío",
    retry_now: "Intentar ahora",
    queue_empty: "Nada esperando para ser enviado",
    poll: "Encuesta",
    create_poll: "Crear Encuesta",
    poll_question: "Pregunta",
    poll_question_ph: "Pregunta algo...",
    poll_options: "Opciones",
    add_option: "Agregar opción",
    option: "Opción",
    poll_multi: "Respuestas múltiples",
    poll_anonymous: "Votos anónimos",
    votes: "votos",
    vote_one: "voto",
    no_votes_yet: "Aún no hay votos",
    job_day_summaries: "Resúmenes de los días",
    daily_summary: "Resumen Diario",
    summary_hint: "Resumen IA por job — generado automáticamente a las 6 AM y 6 PM, o bajo demanda.",
    summary_generate: "Generar ahora",
    summary_generating: "Generando...",
    summary_refresh: "Actualizar",
    summary_empty: "Aún no hay resúmenes para este día.",
    summary_empty_home: "Aún sin resumen de hoy — toca para abrir y generar.",
    summary_none_activity: "No se encontró actividad de chat de jobs para este día.",
    summary_recheck: "Verificar nuevamente",
    issues_opened_label: "abiertas",
    issues_resolved_label: "resueltas",
    drop_media_here: "Suelta para enviar",
    drop_media_sub: "Las fotos abren el editor · Los videos abren el reproductor de revisión",
    drop_unsupported: "Solo se pueden soltar fotos y videos aquí",
    send: "Enviar",
    photo: "Foto",
    voice: "Voz",
    document: "Documento",
    issue: "Problema",
    question: "Pregunta",
    measurement: "Medida",
    material_request: "Solicitud de Material",
    task: "Tarea",
    priority: "Prioridad",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    status_open: "Abierto",
    status_reviewing: "En Revisión",
    status_action_required: "Acción Necesaria",
    status_resolved: "Resuelto",
    location: "Ubicación",
    description: "Descripción",
    title: "Título",
    cancel: "Cancelar",
    save: "Guardar",
    create: "Crear",
    before: "Antes",
    during: "Durante",
    issue_cat: "Problema",
    correction: "Corrección",
    after: "Después",
    all: "Todos",
    category: "Categoría",
    caption: "Leyenda",
    markup: "Marcado",
    edit_photo: "Editar Foto",
    original: "Original",
    versions: "Versiones",
    compare: "Comparar",
    compare_select: "Selecciona la segunda foto",
    sync_zoom: "Zoom sincronizado",
    reply_to_area: "Responder a Área",
    reply_area_hint: "Arrastra sobre la foto para resaltar el área",
    create_task: "Crear Tarea",
    task_area_hint: "Arrastra sobre la foto para marcar el área de la tarea",
    assign_to: "Asignar a",
    due: "Fecha Límite",
    due_placeholder: "p. ej. Antes de completar el job",
    mark_decision: "Marcar como Decisión",
    unmark_decision: "Desmarcar Decisión",
    decision: "DECISIÓN",
    hold_to_record: "Mantén para grabar",
    recording: "Grabando...",
    transcribing: "Transcribiendo...",
    transcript: "Transcripción",
    complete_with_photo: "Completar con Foto",
    completion_photo: "Foto de finalización",
    mark_complete: "Marcar como Completo",
    open_job_hub: "Abrir Centro del Job",
    view_thread: "Ver Conversación",
    no_messages: "Aún no hay mensajes. Comienza la conversación.",
    search_no_results: "Sin resultados",
    search_convs_msgs: "Buscar conversaciones y mensajes...",
    adjust_photo: "Ajustar foto",
    crop_hint: "Arrastra para posicionar la foto dentro del círculo · usa el control deslizante para hacer zoom",
    use_photo: "Usar foto",
    wallpaper_title: "Fondo de chat",
    wallpaper_choose: "Elegir foto",
    wallpaper_default: "Predeterminado",
    wallpaper_custom: "Foto personalizada",
    wallpaper_updated: "Fondo actualizado",
    wallpaper_reset: "Fondo predeterminado restaurado",
    schedule_message: "Programar mensaje",
    ask_job_tab: "Preguntar IA",
    ask_job_title: "Preguntar al Job",
    ask_job_hint: "Pregunta cualquier cosa sobre este job — la IA responde usando los mensajes, notas de voz y fotos de este job.",
    ask_job_placeholder: "p. ej. ¿Qué decidimos sobre la instalación?",
    ask_job_sources: "Fuentes",
    ask_job_error: "IA no disponible en este momento. Intenta de nuevo.",
    ask_job_thinking: "Pensando...",
    ask_job_send: "Preguntar",
    quick_replies: "Respuestas rápidas",
    quick_replies_empty: "Aún no hay frases configuradas.",
    quick_replies_admin_hint: "El admin gestiona estas frases en el panel Admin.",
    quick_replies_user_hint: "Crea las tuyas en Más → Frases rápidas.",
    phrases_row: "Frases rápidas",
    phrases_desc: "Tus frases personales aparecen en el botón ⚡ de los chats — solo para ti. Las frases de la empresa (definidas por el Admin) aparecen para todos en la empresa.",
    phrase_company_badge: "Empresa",
    quick_replies_tab: "Frases",
    quick_reply_add: "Agregar frase",
    quick_reply_placeholder: "p. ej. Estoy en camino",
    quick_reply_added: "Frase añadida",
    quick_reply_deleted: "Frase eliminada",
    quick_reply_saved: "Frase actualizada",
    app_manual: "Manual de la app",
    buddy_manual: "Manual de Buddy & Intérprete",
    photo_stamp: "Estampar fecha + trabajo en la foto",
    photo_stamp_short: "Estampilla",
    require_ack: "Requiere confirmación",
    require_ack_hint: "Cada persona debe tocar \"Entendido\" — verás quién confirmó.",
    ack_button: "Entendido",
    ack_confirmed: "Confirmado",
    ack_waiting: "Esperando confirmación",
    ack_see_confirmations: "Ver confirmaciones",
    ack_dialog_title: "Confirmaciones",
    ack_pending: "Pendiente",
    ack_all_confirmed: "Todos confirmaron",
    catchup_chip: "¿Qué me perdí?",
    catchup_title: "¿Qué me perdí?",
    catchup_recent: "Estás al día — resumen de la conversación reciente:",
    catchup_missed: "{n} mensajes mientras estuviste ausente:",
    catchup_error: "IA no disponible en este momento. Intenta de nuevo.",
    catchup_empty: "Nada que resumir aún.",
    urgent_menu: "Mensaje urgente",
    urgent_armed: "Mensaje urgente — recuerda cada 1 min hasta que se lea (hasta 10x)",
    urgent_badge: "URGENTE",
    urgent_unseen: "No visto — recordatorios agotados",
    broadcast_urgent: "Urgente",
    broadcast_urgent_hint: "Reavisa a cada persona cada 1 min (hasta 10x). Si sigue sin leer, te avisan.",
    schedule_needs_text: "Escribe el mensaje primero, luego prográmalo",
    schedule_when: "Enviar a",
    schedule_confirm: "Programar",
    schedule_future: "Elige un horario en el futuro",
    scheduled_success: "Mensaje programado",
    scheduled_canceled: "Programación cancelada",
    scheduled_chip: "{n} programada(s)",
    scheduled_list_title: "Mensajes programados",
    edit_message: "Editar",
    editing_message: "Editando mensaje",
    edited_label: "editada",
    broadcast_title: "Anuncio",
    broadcast_message_ph: "Mensaje de anuncio...",
    broadcast_hint: "Cada persona lo recibe como un mensaje directo normal — no se crea ningún grupo.",
    broadcast_send: "Enviar anuncio",
    broadcast_sent: "Anuncio enviado a {n} personas",
    conv_wallpaper_title: "Fondo de pantalla para esta conversación",
    supervisors_section: "Supervisores",
    installers_section: "Instaladores",
    job_groups: "Grupos de Trabajo",
    group: "Grupo",
    new_group: "Nuevo grupo",
    group_name: "Nombre del grupo",
    create_group: "Crear grupo",
    conversations: "Conversaciones",
    new_conversation: "Nueva conversación",
    direct_message: "Mensaje directo",
    job_group: "Grupo de trabajo",
    no_conversations: "Aún no hay conversaciones sobre este trabajo.",
    linked_msgs: "mensajes vinculados",
    select_people: "Seleccionar personas",
    talk_about_job: "Todo lo que digas aquí estará vinculado a este trabajo.",
    view_in_chat: "Ver en la conversación",
    resolve_issue: "Haz clic para resolver",
    reopen_issue: "Reabrir",
    edit: "Editar",
    delete: "Eliminar",
    deleted: "Eliminado",
    saved: "Guardado",
    delete_confirm_q: "¿Eliminar permanentemente?",
    delete_group_conv_confirm: "El grupo y TODOS sus mensajes se eliminarán permanentemente para todos. Esto no se puede deshacer.",
    delete_photo_confirm: "La foto se eliminará permanentemente para todos.",
    delete_file_confirm: "El archivo se eliminará permanentemente para todos.",
    delete_comm_msg_confirm: "El mensaje se eliminará permanentemente para todos.",
    delete_dm_links_confirm: "Todos los {n} mensajes de esta conversación vinculados a este trabajo se eliminarán permanentemente para todos. El resto de la conversación privada no se ve afectado.",
    delete_contact_confirm: "El contacto se eliminará de tu lista y ya no aparecerá en ningún lugar. Para verlo de nuevo, deben conectarse otra vez (QR/código).",
    delete_contact_has_conv: "Ustedes tienen una conversación activa — también se eliminará para ti.",
    priority_high: "Alta",
    priority_medium: "Media",
    priority_low: "Baja",
    add_member: "Agregar miembro",
    remove_member: "Eliminar miembro",
    group_updated: "Grupo actualizado",
    global_search: "Buscar",
    search_ph: "Buscar mensajes, fotos, problemas, tareas...",
    no_results: "No se encontraron resultados",
    search_min_hint: "Escribe al menos 2 caracteres para buscar",
    reply: "Responder",
    replying_to: "Respondiendo a",
    add_photo_video: "Agregar foto/video",
    mention_someone: "Mencionar a alguien",
    mentioned_you: "te mencionó",
    you_were_mentioned: "Te mencionaron",
    share: "Compartir",
    share_unavailable: "Compartir no disponible en este dispositivo",
    copy_link: "Copiar enlace",
    link_copied: "Enlace copiado",
    save_image: "Guardar imagen",
    save_file: "Guardar archivo",
    save_all_files: "Guardar todos los archivos ({n})",
    seen_by: "Visto por",
    not_seen_yet: "aún no ha visto",
    mentions: "Menciones",
    no_mentions: "Sin menciones aún",
    new: "Nuevo",
    pdf_failed: "No se pudo cargar el PDF",
    loading: "Cargando",
    video: "Video",
    save_to_job_files: "Guardar PDF en archivos del trabajo",
    saved_to_files: "Guardado en archivos del trabajo",
    dictate: "Dictar",
    stop: "Detener",
    no_speech_detected: "No se detectó habla",
    mic_denied: "Acceso al micrófono denegado",
    add_text_hint: "Toca para agregar texto. Arrastra un texto para moverlo.",
    resolve_issue_title: "Resolver Problema",
    resolution_note_ph: "Describe lo que se hizo para solucionarlo...",
    add_photo: "Agregar foto",
    issue_resolved_q: "¿Problema resuelto?",
    yes_mark_resolved: "Sí, marcar como resuelto",
    no_keep_open: "No, mantener abierto",
    contact_info: "Información de contacto",
    group_info: "Información del grupo",
    shared_media: "Medios compartidos",
    no_media: "No se han compartido medios aún",
    language_label: "Idioma",
    offline_banner: "Sin conexión — los mensajes se enviarán automáticamente cuando vuelvas a estar en línea.",
    queued_offline: "Guardado — se enviará cuando la conexión regrese",
    msg_pending: "Esperando conexión",
    msg_sending: "Enviando...",
    msg_failed: "Error al enviar",
    retry: "Intentar de nuevo",
    discard: "Descartar",
    queue_full: "El almacenamiento offline está lleno — no se pudo guardar esta foto",
    in_queue: "en la cola",
    no_photos: "Aún no hay fotos en esta categoría.",
    no_issues: "Sin problemas. Campo limpio.",
    no_tasks: "Aún no hay tareas.",
    no_decisions: "Aún no hay decisiones registradas.",
    no_documents: "Aún no hay documentos.",
    items: "Items",
    needed_by: "Necesario hasta",
    value: "Valor",
    note: "Nota",
    supervisor_label: "Supervisor",
    address: "Dirección",
    no_account_yet: "¿Aún no tienes cuenta?",
    listen_before_send: "Escuchar antes de enviar",
    preset_next_7_days: "Próximos 7 días",
    all_people: "Todas las personas",
    download: "Descargar",
    chats_tab: "Conversas",
    delete_account: "Eliminar mi cuenta",
    delete_account_desc: "Elimina permanentemente tu cuenta, credenciales de acceso y tokens de notificación, y te saca de todas las conversaciones. Esto no se puede deshacer.",
    delete_account_confirm_title: "¿Eliminar tu cuenta?",
    delete_account_confirm_text: "Esto es permanente. Tu cuenta, claves de acceso y notificaciones serán eliminadas y serás desconectado inmediatamente.",
    account_deleted: "Cuenta eliminada",
    delete_account_failed: "No se pudo eliminar la cuenta",
    already_have_account: "¿Ya tienes cuenta?",
    forgot_password: "Olvidé mi contraseña",
    forgot_password_title: "Restablecer tu contraseña",
    forgot_password_sub: "Ingresa el correo de tu cuenta y te enviaremos un código de 6 dígitos.",
    send_code: "Enviar código",
    code_sent: "Si este correo está registrado, se envió un código. Revisa tu bandeja de entrada.",
    enter_code_title: "Ingresa el código",
    enter_code_sub: "Te enviamos un código de 6 dígitos a tu correo. Expira en 30 minutos.",
    verify_code: "Verificar código",
    resend_code: "Reenviar código",
    resend_in: "Reenviar en",
    new_password_title: "Crea una nueva contraseña",
    new_password_sub: "Tu código fue confirmado. Elige una nueva contraseña (6+ caracteres).",
    save_new_password: "Guardar nueva contraseña",
    password_reset_success: "¡Contraseña actualizada! Inicia sesión con tu nueva contraseña.",
    invalid_code: "Código incorrecto. Intenta de nuevo.",
    code_expired: "Este código ha expirado. Solicita uno nuevo.",
    too_many_attempts: "Demasiadas intentos. Solicita un nuevo código.",
    no_reset_request: "No hay ninguna solicitud activa. Solicita un nuevo código.",
    email_send_failed: "No se pudo enviar el correo. Intenta de nuevo en breve.",
    back_to_login: "Volver a iniciar sesión",
    sign_in_with_faceid: "Iniciar sesión con FaceID / Passkey",
    crop_failed: "No se pudo recortar la imagen. Intenta de nuevo.",
    mute_notifications: "Silenciar notificaciones",
    unmute_notifications: "Reactivar notificaciones",
    muted_on_toast: "Silenciado — seguirás recibiendo mensajes, en silencio. Los trabajos de hoy seguirán sonando.",
    muted_off_toast: "Notificaciones reactivadas.",
    mute_job_exception_hint: "Excepción de obra: en los días que esta conversación tenga un trabajo programado, el supervisor y los instaladores seguirán recibiendo alertas sonoras.",
    passkey_prompt_title: "¿Activar FaceID / Passkey?",
    passkey_prompt_text: "Inicia sesión con un solo toque — seguro y sin escribir contraseña. También puedes activarlo más tarde en Perfil.",
    passkey_prompt_enable: "Activar FaceID",
    passkey_prompt_later: "Ahora no",
    app_lock_title: "Requerir FaceID / inicio de sesión",
    app_lock_on_desc: "Cuando está activado, iniciarás sesión (FaceID/passkey o contraseña) cada vez que vuelvas a abrir la app o la pestaña del navegador.",
    app_lock_off_desc: "Acceso directo — seguirás conectado al volver a abrir la app o la pestaña del navegador.",
    app_lock_enabled: "Bloqueo activado — se requerirá inicio de sesión al reabrir.",
    app_lock_disabled: "Acceso directo habilitado — seguirás conectado.",
    forgot_current_password: "¿No recuerdas tu contraseña actual? Envíame un código por correo",
    code_sent_to: "Código enviado a",
    email_code_label: "Código de 6 dígitos del correo",
    use_current_password: "Usar la contraseña actual",
    tour_welcome_title: "¡Bienvenido a OnSiteComms!",
    tour_welcome_text: "Toda tu comunicación de obra en un solo lugar — mensajes, fotos, notas de voz y trabajos.",
    tour_chat_title: "Chat con traducción automática",
    tour_chat_text: "Escribe en tu idioma — los compañeros lo leen en el suyo. Portugués e inglés, traducidos automáticamente.",
    tour_media_title: "Voz, fotos y anotaciones",
    tour_media_text: "Sostén el micrófono para grabar (desliza hacia arriba para bloquear). Toma fotos y dibuja sobre ellas para mostrar exactamente lo que necesitas.",
    tour_jobs_title: "Todo relacionado con los Jobs",
    tour_jobs_text: "Cada conversación se conecta a un trabajo: dirección con navegación, clima, archivos y tareas — todo en un toque.",
    tour_notif_title: "No te pierdas ningún mensaje",
    tour_notif_text: "Recibe notificaciones de nuevos mensajes y menciones. Administra las alertas en cualquier momento en Más → Configuraciones.",
    tour_next: "Siguiente",
    tour_start: "Comenzar",
    tour_skip: "Saltar tour",
    tour_row: "Tour de la app",
    open_in_maps: "Abrir en la app de navegación",
    customer: "Cliente",
    schedule: "Agenda",
    units: "Unidades",
    switch_profile: "Cambiar Perfil",
    language: "Idioma",
    sending: "Enviando...",
    uploading: "Enviando...",
    send_photo: "Enviar Foto",
    send_photos_n: "Enviar {n} fotos",
    tomorrow: "Mañana",
    yesterday: "Ayer",
    assigned_to: "Asignado a",
    created_by: "Creado por",
    photo_timeline: "Línea de Tiempo de Fotos",
    tap_status: "Toca para cambiar el estado",
    upload_doc: "Enviar Documento",
    voice_message: "Mensaje de voz",
    area_highlighted: "Área destacada",
    from_photo: "De la foto",
    quick_actions: "Acciones Rápidas",
    view_all: "Ver todos",
    in_progress: "En progreso",
    done: "Hecho",
    search_jobs: "Buscar job # o cliente",
    min_away: "min de distancia",
    contacts: "Contactos",
    new_chat: "Nueva Conversación",
    search_contacts: "Buscar contactos",
    link_to_job: "Vincular a Job",
    relink_to_job: "Vincular a otro job",
    unlink_from_job: "Desvincular del job",
    unlink_selected: "Desvincular",
    unlinked_from_job: "mensaje(s) desvinculado(s)",
    linked_to: "Vinculado a",
    linked_messages: "Conversaciones Vinculadas",
    select_job: "Seleccionar Job",
    no_linked: "No hay mensajes vinculados aún. Usa 'Vincular a Job' en cualquier conversación para conectar un mensaje a este job.",
    open_conversation: "Abrir conversación",
    activity: "Actividad",
    more: "Más",
    people: "Personas",
    working_on: "Trabajando en",
    link_msgs_prompt: "Vincular mensajes a",
    yes: "Sí",
    no: "No",
    back: "Atrás",
    measure_photo_hint: "¿Encontraste una ventana o puerta de tamaño incorrecto? Toma una foto — la IA marcará la abertura y las medidas irán en la foto.",
    measure_take_photo: "Toma una foto de la ventana/puerta",
    measure_analyzing: "IA analizando la foto...",
    measure_found_window: "Ventana identificada — ancho y alto marcados",
    measure_found_door: "Puerta identificada — ancho y alto marcados",
    measure_not_found: "No se pudo identificar la abertura — las flechas usarán toda la foto",
    measure_retake: "Volver a tomar",
    measure_job_q_window: "¿Esta ventana es del trabajo?",
    measure_job_q_door: "¿Esta puerta es del trabajo?",
    measure_loading_pdf: "Leyendo el PDF del trabajo...",
    measure_no_pdf: "Este trabajo no tiene PDF — ingresa las medidas manualmente",
    measure_pick_location: "¿Cuál es, según el PDF?",
    measure_other_location: "No está en la lista / otro lugar",
    measure_window: "Ventana",
    measure_door: "Puerta",
    measure_expected: "Esperado (PDF)",
    measure_real_w: "Ancho medido",
    measure_shape: "Forma de la ventana",
    optional: "opcional",
    side_left: "Izquierda",
    side_right: "Derecha",
    measure_dim_w: "Ancho",
    measure_dim_h: "Alto",
    measure_dim_leg: "Altura de pierna",
    measure_dim_top: "Ancho superior",
    measure_dim_legL: "Pierna izquierda",
    measure_dim_legR: "Pierna derecha",
    measure_dim_d: "Diámetro",
    measure_dim_side: "Lado",
    shape_rectangle: "Rectángulo",
    shape_half_circle: "Medio círculo",
    shape_quarter_circle: "Cuarto de círculo",
    shape_eyebrow: "Eyebrow",
    shape_springline: "Springline",
    shape_elliptical: "Elíptica",
    shape_equal_leg_triangle: "Equal Legs",
    shape_right_triangle: "Triángulo recto",
    shape_trapezoid: "Trapecio",
    shape_pentagon: "Pentágono",
    shape_octagon: "Octágono",
    shape_circle: "Círculo",
    shape_oval: "Óvalo",
    measure_door_config: "Configuración de la puerta",
    shape_door: "Solo la puerta",
    shape_door_sl1: "1 sidelight",
    shape_door_sl2: "2 sidelights",
    shape_door_tr: "Transom",
    shape_door_tr_sl1: "Transom + 1 sidelight",
    shape_door_tr_sl2: "Transom + 2 sidelights",
    measure_dim_sl: "Ancho del sidelight",
    measure_dim_slL: "Sidelight izquierdo",
    measure_dim_slR: "Sidelight derecho",
    measure_dim_tr: "Altura del transom",
    measure_dim_trL: "Transom izquierdo",
    measure_dim_trR: "Transom derecho",
    measure_dim_trS: "Transom del sidelight",
    measure_dim_w_total: "Ancho total (unidad completa)",
    measure_dim_h_total: "Alto total (unidad completa)",
    shape_door_tr2_sl1: "1 sidelight + 2 transoms",
    shape_door_tr3_sl2: "2 sidelights + 3 transoms",
    measure_real_h: "Alto medido",
    measure_match: "Coincide con el PDF",
    measure_match_short: "OK",
    measure_mismatch: "Medida INCORRECTA",
    force_update_title: "Actualización necesaria",
    force_update_body: "Hay una nueva versión de OnSiteComms. Actualiza para seguir usando la app.",
    force_update_cta: "Actualizar ahora",
    force_update_installed: "Instalada",
    force_update_required: "Mínima",
    force_update_title_admin: "Actualización obligatoria",
    force_update_help: "Bloquea apps con versión MENOR que la mínima. El usuario ve la imagen y va a la tienda. Al actualizar, la app se libera sola. Web y Master nunca se bloquean.",
    force_update_active: "BLOQUEO ACTIVO",
    force_update_min_ios: "Versión mínima iOS",
    force_update_min_android: "Versión mínima Android",
    force_update_min_hint: "Deja vacío para no bloquear esa plataforma. Ej: Apple aprobó 1.35 → escribe 1.35 en el campo iOS.",
    force_update_image: "Imagen de la pantalla de bloqueo",
    force_update_image_add: "Agregar imagen",
    force_update_image_big: "Imagen demasiado grande (máx. 2MB)",
    force_update_ios_url: "Link App Store",
    force_update_android_url: "Link Play Store",
    force_update_save_on: "Guardar y ACTIVAR",
    force_update_saved_on: "Actualización obligatoria ACTIVA",
    force_update_saved_off: "Guardado (bloqueo apagado)",
    force_update_need_min: "Indica al menos una versión mínima",
    force_update_preview_close: "Toca en cualquier lugar para cerrar la vista previa",
    preview: "Vista previa",
    change: "Cambiar",
    remove: "Quitar",
    measure_shape_diverges: "El PDF indica esta abertura como {pdf}, pero seleccionaste {chosen}. Verifica la unidad en el lugar antes de reportar.",
    measure_pdf_shape: "Forma en el PDF",
    measure_shape_wrong: "Forma INCORRECTA (distinta del PDF)",
    measure_preview_btn: "Generar foto anotada",
    measure_preview_hint: "Revisa la foto anotada antes de enviarla al equipo.",
    buddy_measure_photo_attached: "Foto adjunta.",
    buddy_measure_save_native_only: "Guardar en el celular funciona en la app.",
    buddy_measure_title: "Midiendo",
    buddy_measure_saved: "Medición guardada",
    buddy_measure_empty: "Dile a Buddy la ubicación, el tipo y la medida de la primera ventana.",
    buddy_measure_open_notes: "Abrir Mis Notas",
    buddy_measure_finish: "Concluir y guardar",
    buddy_measure_cancelled: "Sesión de medición cancelada.",
    buddy_measure_saved_msg: "Informe guardado en Mis Notas. ¿Quieres que lo envíe a alguien?",
    buddy_trim_title: "Acabados", buddy_trim_saved: "Acabados guardados", buddy_trim_empty: "Di el tipo de acabado y sus medidas, ej.: \"brickmold, superior 36, base 36, derecha 60, izquierda 60\".",
    buddy_trim_missing: "Falta", buddy_trim_cancelled: "Notas de acabados canceladas.", buddy_trim_saved_msg: "Tabla de acabados guardada en Mis Notas. ¿Quieres que la envíe a alguien?",
    buddy_trim_send: "Enviar acabados", trim_report: "Acabados", trim_side_right: "Lateral derecho", trim_side_left: "Lateral izquierdo", trim_side_top: "Superior", trim_side_base: "Base",
    trim_no_base: "Sin base", trim_thick_short: "gros.", trim_inside: "Medida entrando", trim_face: "Medida de la cara", trim_reforco: "Refuerzo (brick)",
    trim_field_right: "lateral derecho", trim_field_left: "lateral izquierdo", trim_field_top: "superior", trim_field_base: "base", trim_field_base_type: "tipo de base",
    trim_field_right_thick: "grosor derecho", trim_field_left_thick: "grosor izquierdo", trim_field_top_thick: "grosor superior", trim_field_base_thick: "grosor de la base",
    trim_field_inside: "medida entrando", trim_field_face: "medida de la cara", trim_field_finish: "siding o refuerzo", trim_field_siding: "medida del siding",
    buddy_measure_send: "Enviar medidas",
    measure_dictate_hint: "Dicta: \"cuarenta y cuatro tres cuartos por veintiuno y medio\"",
    measure_save_phone: "Guardar la foto original en el celular",
    measure_picker_fallback: "Abriendo el selector de fotos…",
    measure_edit_title: "Editar medida",
    measure_edit: "Editar medida",
    measure_save_edit: "Guardar cambios",
    measure_edit_expired: "Las medidas solo se pueden editar hasta 2 horas después del envío.",
    measure_sent: "¡Medida enviada!",
    measure_more_q: "¿Hay alguna otra ventana con medida incorrecta?",
    measure_more_yes: "Sí, la siguiente",
    measure_finish_send: "Listo — enviar medidas",
    measure_close_confirm: "Tienes {n} medida(s) sin enviar. ¿Cerrar y perderlas?",
    measure_shape_live_hint: "El dibujo sigue tus medidas (pierna ÷ altura)",
    measure_more_no: "No, terminar",
    measure_take_photo_cam: "Tomar foto (cámara)",
    measure_from_gallery: "Desde la galería",
    measure_job_no_other: "No, es de otro trabajo",
    measure_pick_job: "¿De cuál trabajo es esta medida?",
    measure_search_job: "Buscar nº del trabajo o cliente...",
    measure_no_job_manual: "Sin trabajo / ingresar manualmente",
    measure_add_btn: "Agregar al informe",
    measure_added: "Agregado",
    measure_in_report: "en el informe",
    measure_send_all: "Enviar",
    measure_catalog: "Catálogo de medidas",
    measure_wrong_count: "erradas",
    measure_multi_window_q: "¿Varias ventanas en una apertura?",
    measure_door_transom_q: "¿Puerta con una ventana arriba?",
    measure_door_sidelites_q: "¿Ventanas al lado de la puerta?",
    measure_door_combo_q: "¿Puerta con ventanas alrededor?",
    measure_adjust_single: "Revisa la marca — ajusta la caja si es necesario",
    measure_adjust_hint: "Arrastra la caja para mover · esquinas para redimensionar · asa superior para girar (fotos en ángulo)",
    measure_units_found: "unidades marcadas",
    measure_add_box: "Agregar caja",
    measure_remove_box: "Eliminar caja",
    measure_draw_hint: "No pude identificar la apertura — añade la caja manualmente",
    measure_need_box: "Agrega al menos 1 caja",
    measure_continue: "Continuar",
    measure_piece: "Unidad",
    measure_of: "de",
    measure_next_piece: "Siguiente unidad",
    measure_overall_q: "¿Quieres agregar la medida total de la apertura también?",
    measure_overall_w: "Ancho total",
    measure_overall_h: "Altura total",
    measure_skip: "Saltar",
    measure_sketch_flag: "Boceto",
    measure_sketch_hint: "También funciona con una foto de un boceto a mano con varias ventanas",
    measure_units_short: "unidades",
    measure_used: "usada",
    measure_win_type: "Tipo de ventana (opcional):",
    measure_door_type: "Tipo de puerta (opcional):",
    measure_type_none: "No especificado",
    measure_pick_unit_edit: "¿Qué unidad quieres editar?",
    measure_extra_photos: "Fotos extra de esta abertura",
    measure_extra_add_later: "Agregar fotos",
    add: "Agregar",
    measure_unit_type: "Tipo (ventana o puerta):",
    measure_windows: "Ventanas",
    measure_doors: "Puertas",
    not_now: "Ahora no",
    end_job_topic: "Finalizar Tópico del Trabajo",
    job_topic_active: "Nuevos mensajes estarán vinculados a este trabajo",
    private: "Privado",
    shared: "Compartido",
    share_with_job: "Compartir con el Trabajo",
    select_messages: "Seleccionar mensajes",
    selected: "seleccionadas",
    link_selected: "Vincular al Trabajo",
    overview: "Visión General",
    communication: "Comunicación",
    files: "Archivos",
    open_job_chat: "Abrir Chat de Trabajo",
    shared_jobs: "Trabajos Compartidos",
    search_in_conversation: "Buscar en la conversación...",
    filtering_by: "Filtrando por",
    unread: "No leídos",
    settings: "Configuraciones",
    create_issue: "Crear Problema",
    change_category: "Categoría",
    msgs: "mensajes",
    no_activity: "Aún no hay actividad.",
    crews: "Equipos",
    reported_by: "Reportado por",
    from_message: "De mensaje",
    translated: "Traducido",
    see_original: "Ver original",
    show_translation: "Ver traducción",
    notifications: "Notificaciones",
    enable_notifications: "Activar notificaciones",
    notifications_enabled: "Notificaciones activadas",
    notifications_blocked: "Bloqueado por el navegador",
    leader: "Líder",
    fi_issues_title: "Problemas abiertos",
    fi_tasks_title: "Tareas para ti",
    fi_alerts_title: "Alertas de campo",
    fi_complete: "Completar",
    fi_task_done: "¡Tarea completada!",
    fi_by: "por",
    fi_view_chat: "Ver en chat",
    fi_resolve: "Resolver",
    fi_drag_hint: "Suelta en la X para descartar",
    fi_dismissed: "Alertas de problema descartadas",
    fi_now: "ahora",
    buddy_tagline: "Tu ayudante de campo",
    interp_open_btn: "Modo cliente (intérprete)",
    interp_title: "Intérprete en Vivo",
    interp_subtitle: "Buddy traduce entre tú y el cliente",
    interp_preparing: "Buddy se está preparando: empresa, equipo y el trabajo de hoy...",
    interp_starting: "Preparando la presentación...",
    interp_listening: "Escuchando — cualquiera puede hablar",
    interp_recording: "Escuchándote...",
    interp_thinking: "Traduciendo...",
    interp_speaking: "Buddy está hablando...",
    interp_paused: "Micrófono en pausa",
    interp_reintro: "Reintroducir",
    interp_pause: "Pausar",
    interp_resume: "Reanudar",
    interp_end: "Finalizar",
    interp_installer: "Tú",
    interp_customer: "Cliente",
    interp_intro_label: "Introducción",
    interp_exit_label: "Cierre",
    interp_customer: "Cliente",
    interp_turns: "intervenciones",
    interp_from_customer: "del cliente",
    interp_talks_hint: "Todo lo dicho a través del Intérprete en Vivo de Buddy en este trabajo — lo que dijo el cliente y lo que el equipo le dijo.",
    interp_talks_empty: "Aún no hay conversación con el cliente registrada en este trabajo.",
    job_tab_customer: "Cliente",
    interp_no_job: "Sin trabajo de hoy vinculado — esta conversación no se guardará en el trabajo.",
    interp_learned: "¡Entendido! Guardado para toda la empresa",
    interp_start_failed: "No se pudo iniciar el intérprete. Intenta de nuevo.",
    interp_turn_failed: "No escuché eso — repite, por favor.",
    interp_hint: "Buddy detecta quién está hablando por el idioma. Di \"Buddy...\" para enseñar términos, reintroducir o finalizar.",
    interp_admin_title: "Intérprete (modo cliente) & Vocabulario",
    interp_admin_hint: "Buddy presenta al equipo al cliente e interpreta en vivo. Enseña el vocabulario de la empresa aquí (o por voz) — aplica tanto al intérprete COMO a la traducción automática del chat.",
    interp_intro_instr_label: "Instrucciones de introducción (opcional)",
    interp_intro_instr_ph: "Ej.: siempre mencionar nuestra garantía de 20 años; ser breve; agradecer por elegirnos...",
    interp_intro_saved: "Instrucciones de introducción guardadas",
    interp_kind_term: "Término",
    interp_kind_team: "Equipo",
    interp_kind_fact: "Hecho",
    interp_know_ph: "Ej.: Mantener el término 'casing' sin traducir — nunca traducir como 'moldura'",
    interp_know_added: "Guardado — aplica a toda la empresa",
    interp_know_empty: "Nada enseñado aún. Agrega términos aquí o enseña a Buddy por voz.",
    buddy_global_title: "Conocimiento global (todas las empresas y cuentas sueltas)",
    buddy_delete_conv: "Eliminar conversación (para mí)",
    buddy_type_ph: "Escribe un comando para Buddy…",
    buddy_mem_title: "Lo que Buddy sabe de mí",
    buddy_mem_hint: "Todo lo que le enseñaste a Buddy por voz o texto. Edita o borra cuando quieras — se guarda hasta que digas lo contrario.",
    buddy_mem_empty: "Nada aún. Di \"Buddy, recuerda que…\" y aparece aquí.",
    buddy_mem_add_ph: "Agregar algo que Buddy debe recordar…",
    buddy_mem_deleted: "Memoria eliminada",
    buddy_mem_saved: "Guardado",
    buddy_rem_title: "Mis recordatorios",
    buddy_rem_hint: "Recordatorios que Buddy te enviará (hora de Nueva York). Edita el texto o la hora, o cancela.",
    buddy_rem_empty: "Sin recordatorios activos. Di \"Buddy, recuérdame a las 3 pm…\".",
    buddy_rem_recurring_hint: "Agenda recurrente — para cambiar días/hora, pídeselo a Buddy por voz.",
    buddy_rem_in_past: "Esa hora ya pasó",
    buddy_rem_deleted: "Recordatorio cancelado",
    bc_title: "Notificación con flyer / imagen",
    bc_hint: "Envía un flyer a quien elijas. La persona recibe el push (con la imagen) y el flyer se abre a pantalla completa en la app con una X para cerrar. Veces = cuántas veces se envía y se muestra.",
    bc_title_ph: "Título de la notificación",
    bc_body_ph: "Mensaje corto (opcional)",
    bc_pick_image: "Elegir imagen",
    bc_need_title_or_image: "Agrega un título o una imagen",
    bc_sent: "¡Enviado!",
    bc_pick_company: "Elige la empresa",
    bc_mode_all: "Todos",
    bc_mode_company: "Toda la empresa",
    bc_mode_company_role: "Empresa + cargo",
    bc_mode_role: "Cargo (todas las empresas)",
    bc_mode_solo: "Cuentas sueltas (sin empresa)",
    bc_mode_individual: "Personas específicas",
    bc_times: "Cuántas veces",
    bc_interval: "Horas entre envíos",
    bc_recipients: "destinatarios",
    bc_send_now: "Enviar ahora",
    bc_history: "Flyers enviados",
    bc_when_now: "Ahora",
    bc_when_schedule: "Programar",
    bc_schedule_btn: "Programar",
    bc_scheduled: "¡Programado!",
    bc_need_datetime: "Elige fecha y hora",
    bc_ny_time: "Hora de Nueva York",
    bc_scheduled_for: "Programado para",
    bc_next_send: "Próximo envío",
    buddy_conv_deleted: "Conversación eliminada para ti",
    buddy_global_hint: "Solo el MASTER. Todo aquí aplica a TODAS las empresas y cuentas sueltas: traducción automática del chat, vista previa de push, subtítulos de foto/video, el Intérprete y el propio Buddy — además del conocimiento de cada empresa. Por voz: \"Buddy, enséñale a todos que...\".",
    buddy_global_ph: "Ej.: El término 'casing' siempre queda en inglés — nunca traducirlo",
    buddy_global_added: "Guardado — aplica a todos en la plataforma",
    buddy_global_empty: "Aún no hay conocimiento global.",
    buddy_global_badge: "GLOBAL",
    buddy_enabled_title: "Asistente Buddy",
    buddy_enabled_on: "Activado — botón flotante de Buddy y \"Hey Buddy\" disponibles",
    buddy_enabled_off: "Desactivado — Buddy oculto (traducción y transcripción siguen la configuración de IA)",
    banner_buddy: "Buddy activo",
    delete_selected_title: "¿Eliminar {n} seleccionado(s)?",
    delete_selected_desc: "Esta acción no se puede deshacer.",
    select_items: "Seleccionar",
    media_tab: "Medios",
    media_one: "elemento",
    media_many: "elementos",
    select_day: "Seleccionar todo el día",
    deselect_day: "Deseleccionar el día",
    take_another: "Otra",
    save_to_gallery: "Guardar en la galería",
    saved_to_gallery_n: "{n} guardada(s) en la galería",
    gallery_save_failed: "No se pudo guardar en la galería",
    new_messages_pill: "{n} nuevas",
    unread_divider_one: "1 mensaje no leído",
    unread_divider_many: "{n} mensajes no leídos",
    app_update_banner: "Tu app está desactualizada — toca para actualizar",
    live_update_ready: "Nueva versión lista — toca para aplicar",
    live_update_applying: "Aplicando actualización…",
    live_update_checking: "Verificando…",
    live_update_downloading: "Descargando…",
    live_update_check: "Buscar actualización",
    live_update_uptodate: "La app está actualizada",
    live_update_failed: "Error al actualizar",
    live_update_ota: "actualización en vivo",
    live_update_server: "servidor",
    live_update_builtin: "versión de la tienda",
    live_update_no_plugin: "falta el plugin de actualización en este build",
    store_versions_title: "Versiones en las tiendas",
    store_versions_hint: "Leídas automáticamente cada hora de la App Store / Google Play. Los usuarios con una versión anterior ven una barra amarilla hasta actualizar. El campo override fuerza una versión si la consulta a la tienda falla.",
    store_versions_refreshed: "Versiones de las tiendas actualizadas",
    store_lookup_failed: "consulta falló",
    store_override_ph: "override",
    store_checked_at: "Última verificación",
    interp_choose_title: "¿En qué parada estás?",
    interp_choose_sub: "Di el nombre del cliente o el orden (primera, segunda...) — o toca una parada abajo.",
    interp_choose_speak: "Tienes {n} paradas hoy. ¿En cuál estás? Puedes decir el nombre del cliente o el orden — primera, segunda...",
    interp_choose_retry: "Lo siento, no entendí eso. Di el nombre del cliente o el orden — o toca una parada en la pantalla.",
    interp_choose_status: "¿Cuál parada? Habla o toca",
    interp_helpers_title: "¿Quién está contigo hoy?",
    interp_helpers_status: "¿Quién está contigo? Habla o toca",
    interp_helpers_fixed: "Helpers fijos",
    interp_helpers_none_saved: "Aún no hay helpers fijos guardados — di los nombres y Buddy los recordará.",
    interp_helpers_alone: "Estoy solo",
    interp_helpers_only_fixed: "Solo los fijos",
    interp_helpers_alone_say: "Estoy solo hoy",
    interp_helpers_fixed_say: "Solo mis helpers fijos",
    interp_helpers_retry: "Perdón, no entendí. Dime quién está contigo hoy, o di 'solo'.",
    interp_ask_helpers_label: "Preguntar quiénes son los helpers antes de la presentación",
    helpers_fixed_title: "Mis helpers fijos",
    helpers_add: "Agregar",
    helpers_empty: "Ningún helper aún — toca + o dile a Buddy: \"mi helper fijo es Juca\".",
    helpers_name_ph: "Nombre del helper",
    helpers_saved: "Helpers actualizados",
    interp_ask_helpers_user_hint: "Antes de cada presentación Buddy te pregunta quién está contigo hoy (fijos / extras / solo)",
    interp_ask_helpers_hint: "Buddy le pregunta al instalador, en privado, quién está con él (fijos / extras / solo) y solo anuncia esos nombres.",
    buddy_know_update: "¿Editar conocimiento de la empresa?",
    buddy_know_delete: "¿Eliminar conocimiento de la empresa?",
    buddy_know_updated: "Actualizado — aplica a toda la empresa",
    buddy_know_deleted: "Eliminado para toda la empresa",
    buddy_intro_draft: "Instrucciones de introducción al cliente",
    buddy_intro_cleared: "(limpiar todas las instrucciones)",
    buddy_intro: "¡Hola! Soy Buddy, tu asistente. Di \"Hey Buddy\" y simplemente habla — me doy cuenta cuando terminas y seguimos la conversación. O mantén el micrófono. Mensajes, recordatorios, clima, medidas, preguntas técnicas...",
    slide_to_cancel: "Desliza para cancelar",
    voice_cancelled: "Grabación cancelada",
    message_info: "Info. del mensaje",
    played_by: "Reproducido por",
    seen_by: "Visto por",
    delivered_to: "Entregado a",
    not_delivered_yet: "Aún no entregado",
    nobody_yet: "Nadie todavía",
    sent_at: "Enviado",
    voice_invalid: "No se pudo leer esta grabación — graba de nuevo",
    voice_empty: "No se grabó nada — mantén presionado el micrófono hasta que empiece el cronómetro",
    voice_interrupted: "Grabación interrumpida — escucha y envía si está bien",
    voice_send_failed: "Error al enviar el audio",
    chatter_hint: "Informe de fin de día para el Chatter de la empresa — hecho solo con el PDF, el chat de hoy y los problemas del job. Revisa antes de publicar.",
    chatter_release: "Customer happy - release the Survey",
    chatter_hold: "Hold the Survey",
    chatter_unknown: "El supervisor aún no confirmó con el cliente - hold the Survey",
    chatter_thumb_up: "Cliente satisfecho",
    chatter_thumb_down: "Cliente NO satisfecho",
    chatter_sat_hint: "¿Ya llamaste al cliente? Toca para registrar el veredicto en el informe.",
    chatter_sat_by: "Marcado por",
    chatter_sat_clear: "Deshacer",
    chatter_copy: "Copiar",
    chatter_copied: "Informe copiado",
    chatter_saved: "Informe guardado",
    chatter_regen: "Generar de nuevo",
    chatter_generated: "Generado",
    factory_reset: "Restablecer de fábrica",
    factory_reset_confirm: "Borra TODO lo que esta cuenta hizo o configuró — mensajes, chats directos, fotos, problemas, tareas, memorias de Buddy, helpers, recordatorios, dispositivos, biometría y preferencias. E-mail, contraseña, rol y empresa se mantienen, como si la cuenta acabara de crearse. No se puede deshacer.",
    factory_reset_done: "Cuenta restablecida al estado de fábrica",
    weekly_summary: "Resumen semanal",
    weekly_jobs: "Trabajos",
    weekly_units: "Unidades",
    weekly_crews: "Equipos",
    weekly_summary_hint: "Resumen de la IA de tus trabajos de la semana (lun–dom)",
    weekly_summary_empty: "Ningún trabajo activo tuyo esta semana.",
    buddy_hold: "Toca para hablar",
    buddy_listening: "Escuchando...",
    buddy_send_media: "Enviar archivo",
    buddy_media_sent: "¡Enviado!",
    buddy_edit_msg: "Editar mensaje",
    buddy_msg_edited: "Mensaje editado.",
    buddy_delete_msg: "Borrar mensaje",
    buddy_msg_deleted: "Mensaje borrado.",
    buddy_issue_status: "Actualizar issue",
    buddy_issue_updated: "¡Issue actualizado!",
    buddy_task_complete: "Completar tarea",
    buddy_task_reopen: "Reabrir tarea",
    buddy_task_done: "¡Tarea completada!",
    buddy_task_reopened: "Tarea reabierta.",
    buddy_new_group: "Nuevo grupo",
    buddy_group_created: "¡Grupo creado!",
    theme_title: "Tema",
    theme_light: "Claro",
    theme_dark: "Oscuro",
    theme_system: "Automático (sigue el teléfono)",
    search_offline_hint: "Sin conexión — buscando en lo guardado en este teléfono",
    settings_sec_account: "Cuenta y seguridad",
    settings_sec_appearance: "Apariencia",
    settings_sec_buddy: "Buddy (asistente)",
    settings_sec_data: "Datos y conexión",
    buddy_memories_short: "Todo lo que le enseñaste a Buddy — ver, editar, borrar",
    buddy_reminders_short: "Recordatorios que Buddy te enviará",
    offline_mode_on_short: "Activado",
    offline_mode_off_short: "Desactivado — solo en línea",
    offline_setup_title: "¿Modo sin conexión en este teléfono?",
    offline_setup_intro: "Guarda una copia de tus conversaciones en este teléfono para leer todo sin señal. Al volver la conexión, todo se sincroniza automáticamente (envío y recepción).",
    offline_setup_intro_settings: "Elige cuánto guardar en este teléfono. Todo sigue guardado en el servidor de todas formas.",
    offline_history: "Historial a descargar",
    offline_history_90d: "Últimos 90 días",
    offline_history_12m: "Últimos 12 meses",
    offline_history_all: "Todo",
    offline_history_all_hint: "Puede ocupar mucho espacio en cuentas antiguas.",
    offline_photos: "Fotos",
    offline_photos_thumb: "Solo miniaturas",
    offline_photos_thumb_hint: "Ligero. La foto completa carga cuando haya señal.",
    offline_photos_full: "Fotos en tamaño completo",
    offline_photos_full_hint: "Ocupa más espacio en el teléfono.",
    offline_voice_note: "Los mensajes de voz siempre quedan sin conexión (son pequeños).",
    offline_enable_btn: "Sí, descargar y mantener sincronizado",
    offline_online_only_btn: "No, solo en línea",
    offline_downloading: "Descargando tus conversaciones…",
    offline_downloading_hint: "Puedes seguir usando la app — continúa en segundo plano.",
    offline_mode: "Modo sin conexión en este dispositivo",
    offline_mode_on_hint: "Las conversaciones se reflejan en este teléfono y se sincronizan automáticamente.",
    offline_mode_off_hint: "Solo en línea — nada se guarda en este dispositivo.",
    offline_media_files: "archivos",
    offline_device_free: "libre en el dispositivo",
    offline_sync_now: "Sincronizar ahora",
    offline_change_options: "Opciones",
    offline_manage: "Liberar espacio",
    offline_manage_title: "Almacenamiento sin conexión",
    offline_clear_media_30: "Borrar medios de más de 30 días",
    offline_clear_media_all: "Borrar todos los medios sin conexión",
    offline_clear_conv_title: "Borrar una conversación de este teléfono",
    offline_clear: "Borrar",
    offline_disabled_toast: "Modo sin conexión apagado — datos eliminados de este dispositivo.",
    offline_full_title: "Memoria del teléfono llena",
    offline_full_body: "No queda espacio para mantener tus conversaciones sin conexión. Libera espacio (borra medios o conversaciones de este teléfono) o pasa al modo solo en línea.",
    offline_full_manage_btn: "Liberar espacio y seguir sin conexión",
    offline_full_short: "Memoria llena — libera espacio para continuar.",
    offline_banner_mode: "Sin conexión — modo sin conexión: mostrando lo guardado en este teléfono.",
    offline_syncing: "Sincronizando…",
    presence_typing_one: "{name} está escribiendo…",
    presence_typing_many: "Varias personas están escribiendo…",
    presence_recording_one: "{name} está grabando audio…",
    presence_recording_many: "Varias personas están grabando audio…",
    presence_recording_label: "Grabando audio…",
    presence_typing_label: "escribiendo",
    buddy_thinking: "Pensando...",
    buddy_speaking: "Hablando...",
    buddy_interrupt_hint: "di \"Hey Buddy\" para interrumpir",
    buddy_memories_label: "Memorias de Buddy",
    buddy_memories_hint: "Todo lo que le enseñaste a Buddy — lo usa en cada conversación",
    buddy_memories_empty: "Buddy aún no ha aprendido nada. Enséñale por voz (\"Buddy, recuerda que...\") o agrega abajo.",
    buddy_memory_add_ph: "Enseña algo nuevo a Buddy...",
    buddy_memory_saved: "¡Buddy lo aprendió!",
    buddy_memory_updated: "Memoria actualizada",
    buddy_memory_deleted: "Memoria eliminada",
    buddy_new_memory: "¿Recordar esto?",
    buddy_remember_btn: "Recordar",
    buddy_personality: "Personalidad",
    buddy_style_default: "Predeterminado",
    buddy_style_formal: "Formal",
    buddy_style_casual: "Informal",
    buddy_style_direct: "Directo",
    buddy_instructions_ph: "Instrucciones personales... ej: \"siempre llámame jefe\", \"responde corto\"",
    buddy_prefs_saved: "¡Buddy se adaptó a ti!",
    buddy_prefs_save: "Guardar",
    buddy_rules_title: "Reglas de la empresa para Buddy",
    buddy_rules_hint: "Las reglas aplican para el Buddy de todos los usuarios, o solo para un usuario específico. Los usuarios no pueden ver ni cambiar.",
    buddy_rule_ph: "Nueva regla... ej: \"Siempre mencionar el equipo de seguridad al hablar de instalaciones\"",
    buddy_rule_target_all: "Todos los usuarios",
    buddy_rule_add: "Agregar regla",
    buddy_rule_added: "Regla añadida",
    buddy_rule_saved: "Regla guardada",
    buddy_rule_deleted: "Regla eliminada",
    buddy_user_memories: "Memorias por usuario",
    buddy_pick_user: "Selecciona un usuario...",
    buddy_no_memories_user: "Este usuario aún no le ha enseñado nada a Buddy.",
    buddy_send: "Enviar",
    buddy_cancel: "Cancelar",
    buddy_to: "A",
    buddy_sent: "¡Mensaje enviado!",
    buddy_group: "Grupo",
    buddy_new_task: "Nueva tarea",
    buddy_new_issue: "Nuevo problema",
    buddy_task_created: "¡Tarea creada!",
    buddy_issue_created: "¡Problema registrado!",
    buddy_confirm: "Confirmar",
    buddy_open_job: "Abrir job",
    buddy_wake_label: "\"Hey Buddy\" (manos libres)",
    buddy_wake_on: "\"Hey Buddy\" activado — te estoy escuchando mientras la app está abierta",
    buddy_wake_off: "\"Hey Buddy\" desactivado",
    buddy_wake_hint: "o di \"Hey Buddy\"",
    buddy_too_short: "Mantén el botón mientras hablas",
    buddy_error: "Ups, algo salió mal. ¡Intenta de nuevo!",
    buddy_mic_denied: "Para hablar con Buddy, activa el micrófono",
    buddy_speak_now: "Adelante — ¡te estoy escuchando!",
    buddy_handsfree_hint: "Respondo cuando pauses",
    buddy_tap_cancel: "toca para cancelar",
    buddy_draft_discarded: "Ok, borrador descartado.",
    buddy_voice_on: "Voz activada — Buddy dice las respuestas",
    buddy_voice_off: "Voz silenciada — solo texto",
    buddy_size_label: "Tamaño de Buddy (S/M/L)",
    buddy_speed_label: "Velocidad de la voz de Buddy (1x / 1.5x / 2x)",
    buddy_sfx_on: "Sonidos de herramienta: alto",
    buddy_sfx_low: "Sonidos de herramienta: suave",
    buddy_sfx_off: "Sonidos de herramienta: apagados",
    buddy_load_older: "Ver mensajes antiguos",
  },
};

export function makeT(lang) {
  return (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key;
}
